import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  TextField,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import EventIcon from "@material-ui/icons/Event";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import BuildIcon from "@material-ui/icons/Build";
import AddIcon from "@material-ui/icons/Add";
import BusinessIcon from "@material-ui/icons/Business";
import CategoryIcon from "@material-ui/icons/Category";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import MicIcon from "@material-ui/icons/Mic";
import RemoveIcon from "@material-ui/icons/Remove";
import SearchIcon from "@material-ui/icons/Search";
import ScheduleIcon from "@material-ui/icons/Schedule";
import VisibilityIcon from "@material-ui/icons/Visibility";
import WarningIcon from "@material-ui/icons/Warning";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getCustomers } from "../../../../api/customer";
import {
  downloadMailboxAttachment,
  getMailboxMessage,
  getMailboxThreads,
} from "../../../../api/mailbox";
import { getOperarios } from "../../../../api/operario";
import { getProducts } from "../../../../api/product";
import {
  assignOperarioToObra,
  blockOperarioInObra,
  deleteObraMaterialRequest,
  deleteObraTaskReport,
  deleteObraTaskReportLine,
  deleteObraSupplierRequest,
  deleteObraSupplierRequestGroup,
  getObraHeaderById,
  getObraOperarioHours,
  getObraOperarioTaskHours,
  getObraOperarioTaskReportEditor,
  getObraTaskReports,
  getObraMaterialRequestEditor,
  getObraMaterialRequests,
  getObraPurchaseOrders,
  getObraPurchaseOrder,
  getObraPurchaseOrderReceiptEditor,
  previewObraPurchaseOrderPdf,
  postObraPurchaseOrderReceipt,
  sendObraPurchaseOrder,
  analyzeObraPurchaseOrderDeliveryNote,
  addSupplierToObraSupplierRequestGroup,
  deleteObraPurchaseOrderReceipt,
  getObraMaterialAssignmentEditor,
  postObraMaterialAssignments,
  getObraSupplierRequestBudgetSelection,
  getObraSupplierRequestById,
  getObraSupplierRequestEditor,
  getObraSupplierRequestMailHistory,
  markObraSupplierRequestMailAsReviewed,
  getObraSupplierRequestResponse,
  getObraSupplierRequests,
  postObraMaterialRequest,
  postObraSupplierRequest,
  postObraOperarioHours,
  postObraOperarioTaskReport,
  postObraOperarioTaskAssistantAudio,
  removeOperarioFromObra,
  unblockOperarioInObra,
  autoFillObraSupplierRequestResponse,
  sendObraSupplierRequestMail,
  generateObraPurchaseOrders,
  updateObraMaterialRequest,
  updateObraMaterialRequestStatus,
  updateObraSupplierRequest,
  updateObraSupplierRequestResponse,
  updateObraSupplierRequestStatus,
  updateObraHitos,
  updateObraHeader,
  updateObraPurchaseOrder,
  updateObraProductCompletion,
} from "../../../../api/obraHeader";
import { getObraPlanningStatus } from "../../../../api/obraPlanningStatus";
import { getObraStatus } from "../../../../api/obraStatus";
import { getSuppliers } from "../../../../api/supplier";
import { TIPO_PARTIDA } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { formatInstallationTime } from "../../../../utils/helpers";
import "../../../../customStyles/obraHours.css";
import MailComposeDialog from "../../../components/dialogs/MailComposeDialog";
import MailViewDialog from "../../../components/dialogs/MailViewDialog";
import Table from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";

function getEmptyObraHeader() {
  return {
    id: null,
    oferta_id: null,
    oferta_revision_num: null,
    oferta_num_oferta: "",
    cliente_id: null,
    localizacion: "",
    direccion_entrega: "",
    contacto_entrega: "",
    telefono_entrega: "",
    horario_entrega: "",
    observaciones_pedido: "",
    condiciones_pedido: "",
    oferta_referencia: "",
    coste_mano_de_obra: 0,
    coste_subcontrata: 0,
    coste_materiales: 0,
    codigo_obra: "",
    fecha_inicio: null,
    fecha_fin: null,
    estado_obra_id: null,
    situacion_planificacion_id: null,
    porcentaje_completado: 0,
    completado_material: 0,
    completado_tiempo: 0,
    completado_tareas: 0,
    completado_importe: 0,
    tiempo_real_operarios: 0,
    coste_mano_de_obra_real: 0,
    desviacion_coste_mano_de_obra: 0,
    coste_materiales_previsto_actual: 0,
    coste_materiales_real: 0,
    operarios: [],
    hitos: [],
    capitulos: [],
  };
}

function formatDate(dateValue) {
  if (!dateValue) return "";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";

  return `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}/${date.getFullYear()}`;
}

function formatDateTime(dateValue) {
  if (!dateValue) return "";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";

  return `${formatDate(date)} ${String(date.getHours()).padStart(2, "0")}:${String(
    date.getMinutes()
  ).padStart(2, "0")}`;
}

function getSupplierRequestStatusStyle(status, request = {}) {
  if (status === "Aprobado") {
    return { label: "Aprobado por usuario", backgroundColor: "#E5F8EC", color: "#187A42" };
  }

  if (status === "Precios asignados") {
    return {
      label: request.analizado_por_usuario ? "Analizado por usuario" : "Analizado por IA",
      backgroundColor: request.analizado_por_usuario ? "#E5F8EC" : "#FFF5D9",
      color: request.analizado_por_usuario ? "#187A42" : "#9A6700",
    };
  }

  if (status === "Enviado" || status === "Respuesta recibida") {
    return {
      label: status === "Respuesta recibida" ? "Respuesta recibida" : "Enviado",
      backgroundColor: "#FFF5D9",
      color: "#9A6700",
    };
  }

  return { label: "Pendiente de enviar", backgroundColor: "#EEF1F5", color: "#63738C" };
}

function formatDateForInput(dateValue) {
  if (!dateValue) return "";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
}

function getSupplierAvailabilityDisplay(price, requestedQuantity) {
  if (price.no_disponible) {
    return { text: "No servido por este proveedor", color: "#D32F2F" };
  }

  const requested = parseDecimal(requestedQuantity);
  const immediate = parseDecimal(
    price.cantidad_disponible_inmediata == null
      ? requested
      : price.cantidad_disponible_inmediata
  );
  const expectedDate = formatDate(price.fecha_disponibilidad);

  if (requested <= 0 || immediate >= requested) {
    return { text: "Disponible", color: "#1B9A59" };
  }

  if (immediate > 0) {
    return {
      text: `${parsePercent(immediate)} disponibles${expectedDate ? ` · Resto: ${expectedDate}` : " · Resto pendiente"}`,
      color: "#D28A00",
    };
  }

  return {
    text: expectedDate ? `Entrega: ${expectedDate}` : "Bajo pedido · Fecha pendiente",
    color: "#D28A00",
  };
}

function getPurchaseOrderLineAvailabilityDisplay(line) {
  if (!line.disponibilidad_informada) {
    return { text: "Disponibilidad no informada por el proveedor", color: "#6C757D" };
  }

  if (line.no_disponible) {
    return { text: "No servido por el proveedor", color: "#D32F2F" };
  }

  const requested = parseDecimal(line.cantidad);
  const immediate = parseDecimal(line.cantidad_disponible_inmediata);
  const expectedDate = formatDate(line.fecha_disponibilidad);
  let text;
  let color;

  if (requested <= 0 || immediate >= requested) {
    text = `Disponible inmediatamente: ${parsePercent(immediate)} / ${parsePercent(requested)}`;
    color = "#1B9A59";
  } else {
    text = `Disponible ahora: ${parsePercent(immediate)} / ${parsePercent(requested)}${expectedDate ? ` · Resto previsto: ${expectedDate}` : " · Resto: fecha pendiente"}`;
    color = "#D28A00";
  }

  return {
    text: line.observacion_disponibilidad ? `${text} · ${line.observacion_disponibilidad}` : text,
    color,
  };
}

function getSupplierResponseAvailabilityStyle(line, isAnalysed) {
  if (!isAnalysed) {
    return { backgroundColor: "#FFFFFF", borderColor: "#E4E6EF", color: "#6C757D" };
  }

  const requested = parseDecimal(line.cantidad_solicitada);
  const immediate = parseDecimal(line.cantidad_disponible_inmediata);

  if (immediate <= 0) {
    return { backgroundColor: "#FFF1F1", borderColor: "#F6CACA", color: "#A32626" };
  }

  if (requested <= 0 || immediate >= requested) {
    return { backgroundColor: "#EFFAF3", borderColor: "#BCE6CA", color: "#187A42" };
  }

  return { backgroundColor: "#FFF8E8", borderColor: "#F2D693", color: "#9A6700" };
}

function parseMoney(value) {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

function parsePercent(value) {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

function getPercentValue(value) {
  const parsed = Number(value || 0);

  if (Number.isNaN(parsed)) {
    return 0;
  }

  return Math.max(0, Math.min(100, parsed));
}

function formatHoursAndMinutes(totalMinutes) {
  const minutes = Math.max(0, Math.ceil(Number(totalMinutes || 0)));
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${hours} h ${remainingMinutes} min`;
}

function formatCircularPercent(value) {
  const percentValue = getPercentValue(value);

  return percentValue === 100 ? "100" : parsePercent(percentValue);
}

function getProgressFromTotals(currentValue, totalValue) {
  const current = Number(currentValue || 0);
  const total = Number(totalValue || 0);

  if (Number.isNaN(current) || Number.isNaN(total) || total <= 0) {
    return 0;
  }

  return getPercentValue((current / total) * 100);
}

function buildSupplierRequestMailBody(detail) {
  const supplierName = detail?.proveedor_nombre || "proveedor";
  const linesHtml = (detail?.lineas || [])
    .map((line) => {
      const quantity = parsePercent(line.cantidad_solicitada);
      const unitText = line.unidad ? ` ${line.unidad}` : "";
      const referenceText = line.referencia ? ` (${line.referencia})` : "";
      return `<li>${line.descripcion}${referenceText}: ${quantity}${unitText}</li>`;
    })
    .join("");

  return `
    <p>Estimado, ${supplierName}</p>
    <p>Por la presente, solicitamos presupuesto para los siguientes materiales:</p>
    <ul>
      ${linesHtml}
    </ul>
    <p>Quedamos a la espera de su respuesta.</p>
    <p>Gracias.</p>
  `.trim();
}

function buildSupplierRequestMailSubject(obraCode, requestCode) {
  const normalizedObraCode = obraCode || "OBRA";
  const normalizedRequestCode = requestCode || "SOLICITUD";
  return `Peticion para ${normalizedObraCode} - ${normalizedRequestCode}`;
}

function SummaryField({ label, value, className = "col-md-4" }) {
  return (
    <div className={className}>
      <TextField
        fullWidth
        margin="normal"
        variant="outlined"
        label={label}
        value={value}
        InputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  );
}

function InfoBadge({ label, value, detail = null, labelColor = "#63738C", icon: Icon, accentColor, rightContent = null }) {
  return (
    <div className="col-md-4 mb-5">
      <div
        className="d-flex align-items-center justify-content-between h-100 px-5 py-5"
        style={{
          borderRadius: "0.7rem",
          backgroundColor: "#FFFFFF",
          minHeight: "112px",
          border: "1px solid #E7ECF5",
          boxShadow: "0 9px 20px rgba(35, 45, 85, 0.06)",
        }}
      >
        <div
          className="font-weight-bolder"
          style={{ color: "#182B4D", fontSize: "1.45rem" }}
        >
          {value}
          <div className="font-weight-normal mt-2" style={{ color: labelColor, fontSize: "0.86rem" }}>
            {label}
          </div>
          {detail && (
            <div className="font-weight-normal mt-1" style={{ color: "#63738C", fontSize: "0.74rem" }}>
              {detail}
            </div>
          )}
        </div>
        {rightContent || (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: "50px", height: "50px", borderRadius: "0.35rem", color: "#FFFFFF", backgroundColor: accentColor }}
          >
            <Icon fontSize="small" />
          </div>
        )}
      </div>
    </div>
  );
}

function ProgressCircle({ label, value, accentColor = "#20C997", prominent = false, detail = null, secondaryDetail = null }) {
  const percentValue = getPercentValue(value);
  const size = prominent ? 95 : 76;
  const center = size / 2;
  const radius = prominent ? 37.5 : 30;
  const strokeWidth = prominent ? 8.75 : 7;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentValue / 100) * circumference;

  return (
    <div className="d-flex flex-column align-items-center text-center" style={{ width: prominent ? "103px" : "82px", flex: `0 1 ${prominent ? 103 : 82}px` }}>
      <div style={{ position: "relative", width: `${size}px`, height: `${size}px` }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
          <circle cx={center} cy={center} r={radius} fill="none" stroke="#EDF1F7" strokeWidth={strokeWidth} />
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={accentColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 350ms ease" }}
          />
        </svg>
        <div
          className="font-weight-bolder text-dark"
          style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: prominent ? "1rem" : "0.82rem" }}
        >
          {formatCircularPercent(percentValue)}%
        </div>
      </div>
      <div className="font-weight-bold mt-2 text-nowrap" style={{ color: "#5E6278", fontSize: prominent ? "0.74rem" : "0.68rem" }}>
        {label}
      </div>
      {detail && (
        <div className="font-weight-bolder mt-1 text-nowrap" style={{ color: "#3F4254", fontSize: "0.68rem" }}>
          {detail}
        </div>
      )}
      {secondaryDetail && (
        <div className="mt-1 text-nowrap" style={{ color: "#7E8299", fontSize: "0.66rem" }}>
          {secondaryDetail}
        </div>
      )}
    </div>
  );
}

function PlanningStatusBadge({ value }) {
  let backgroundColor = "#E4E6EF";
  let textColor = "#3F4254";

  if (value === "A tiempo") {
    backgroundColor = "#C9F7F5";
    textColor = "#0BB783";
  } else if (value === "Warning") {
    backgroundColor = "#FFF4DE";
    textColor = "#FFA800";
  } else if (value === "Retraso") {
    backgroundColor = "#FFE2E5";
    textColor = "#F64E60";
  }

  return (
    <span
      className="font-weight-bold text-uppercase px-3 py-2"
      style={{ backgroundColor, color: textColor, borderRadius: "0.42rem" }}
    >
      {value || "-"}
    </span>
  );
}

function OperarioHoursCircle({ value, accentColor = "#1587E8" }) {
  const percentValue = getPercentValue(value);
  const radius = 21;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentValue / 100) * circumference;

  return (
    <div style={{ position: "relative", width: "58px", height: "58px", flex: "0 0 58px" }}>
      <svg width="58" height="58" viewBox="0 0 58 58" style={{ transform: "rotate(-90deg)" }}>
        <circle cx="29" cy="29" r={radius} fill="none" stroke="#EDF1F7" strokeWidth="6" />
        <circle
          cx="29"
          cy="29"
          r={radius}
          fill="none"
          stroke={accentColor}
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div
        className="font-weight-bolder text-dark"
        style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.68rem" }}
      >
        {formatCircularPercent(percentValue)}%
      </div>
    </div>
  );
}

function getSortedHitos(hitos) {
  return [...(hitos || [])].sort((a, b) => {
    const firstDate = new Date(a.fecha_prevista);
    const secondDate = new Date(b.fecha_prevista);
    return firstDate.getTime() - secondDate.getTime();
  });
}

function getDefaultHitoDraft() {
  return {
    id: null,
    completado_tiempo: "",
    fecha_prevista: "",
  };
}

function getEmptyMaterialRequestEditor() {
  return {
    solicitud_id: null,
    codigo: "",
    fecha_solicitud: null,
    user_solicita_id: null,
    user_solicita_nombre: "",
    operario_solicita_id: null,
    operario_solicita_nombre: "",
    estado_id: null,
    estado_descripcion: "",
    permite_acciones: true,
    observaciones: "",
    motivo_rechazo: "",
    materiales_totales: 0,
    materiales_en_solicitudes_oferta: 0,
    materiales_en_pedidos: 0,
    materiales_recibidos: 0,
    capitulos: [],
    material_adicional: [],
  };
}

function getEmptyMaterialQuantityDraft() {
  return {
    mode: "material",
    chapterId: null,
    partidaId: null,
    productId: null,
    maxQuantity: 0,
    quantity: "",
    description: "",
  };
}

function getEmptySupplierRequestEditor() {
  return {
    requestId: null,
    requestIds: [],
    groupId: null,
    observaciones: "",
    capitulos: [],
  };
}

function getEmptySupplierResponseEditor() {
  return {
    requestId: null,
    supplierName: "",
    fecha_respuesta: null,
    mail_id_origen: null,
    observaciones: "",
    referencia_oferta_proveedor: "",
    precio_total: 0,
    isAnalysed: false,
    lineas: [],
  };
}

function getEmptySupplierBudgetSelection() {
  return {
    groupId: null,
    groupCode: "",
    materiales: [],
  };
}

function parseDecimal(value) {
  const parsed = Number(value || 0);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return parsed;
}

function availableBudgetPrices(material) {
  return (material.precios || [])
    .filter((price) => price.disponible && parseDecimal(price.precio_total) > 0)
    .sort((first, second) => parseDecimal(first.precio_total) - parseDecimal(second.precio_total));
}

function budgetSubtotal(materials, choosePrice) {
  let cents = 0;
  let pricedMaterials = 0;

  materials.forEach((material) => {
    const price = choosePrice(material);
    if (!price?.disponible || parseDecimal(price.precio_total) <= 0) return;
    cents += Math.round(parseDecimal(price.precio_total) * 100);
    pricedMaterials += 1;
  });

  return { total: cents / 100, pricedMaterials };
}

function calculateBudgetComparison(materials) {
  const rows = materials || [];
  const suppliers = (rows[0]?.precios || []).map((price) => ({
    id: price.solicitud_presupuesto_cabecera_id,
    name: price.proveedor_nombre || "Proveedor",
    ...budgetSubtotal(rows, (material) =>
      (material.precios || []).find((candidate) => candidate.solicitud_presupuesto_cabecera_id === price.solicitud_presupuesto_cabecera_id)
    ),
  }));

  return {
    materialCount: rows.length,
    suppliers,
    cheapest: budgetSubtotal(rows, (material) => availableBudgetPrices(material)[0]),
    mostExpensive: budgetSubtotal(rows, (material) => {
      const prices = availableBudgetPrices(material);
      return prices[prices.length - 1];
    }),
    selected: budgetSubtotal(rows, (material) =>
      (material.precios || []).find((price) => price.solicitud_presupuesto_cabecera_id === material.selectedSupplierRequestId)
    ),
  };
}

function TabButton({ active, label, disabled = false, onClick }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      disabled={disabled}
      onClick={onClick}
      className="border-0 bg-transparent px-5 py-4"
      style={{
        color: active ? DETAIL_SECTION_BLUE : disabled ? "#B5B5C3" : "#5E6278",
        fontWeight: active ? 700 : 600,
        borderBottom: active ? `3px solid ${DETAIL_SECTION_BLUE}` : "3px solid transparent",
        opacity: disabled ? 0.7 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "color 160ms ease, border-color 160ms ease",
      }}
    >
      {label}
    </button>
  );
}

function DetailLabel({ children, width, color = "#7E8299" }) {
  return (
    <div
      className="font-weight-bold text-uppercase"
      style={{ width, fontSize: "0.75rem", letterSpacing: "0.04em", color }}
    >
      {children}
    </div>
  );
}

function getPartidaTypeInfo(typeValue) {
  return TIPO_PARTIDA.find((item) => item.value === typeValue) || null;
}

function MaterialMetricBox({ label, value, width = "110px" }) {
  return (
    <div
      className="d-flex flex-column justify-content-center px-3 py-2"
      style={{
        width,
        minHeight: "58px",
        border: "1px solid #E4E6EF",
        borderRadius: "0.42rem",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div
        className="text-uppercase font-weight-bold"
        style={{ fontSize: "0.68rem", color: "#7E8299", lineHeight: 1.2 }}
      >
        {label}
      </div>
      <div
        className="font-weight-bolder text-dark mt-1"
        style={{ fontSize: "1rem", lineHeight: 1.2 }}
      >
        {value}
      </div>
    </div>
  );
}

function ActionIconButton({ title, onClick, disabled = false, children, color }) {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled}
          style={{
            padding: "4px",
            color: color || undefined,
            opacity: disabled ? 0.3 : 1,
          }}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}

function ProgressMetric({
  label,
  value,
  width = "220px",
  labelColor = "#7E8299",
  trackColor = "#E4E6EF",
  fillColor = "#2F80ED",
  valueColor = "#1F1F1F",
}) {
  const percentValue = getPercentValue(value);

  return (
    <div style={{ width }}>
      {!!label && (
        <DetailLabel color={labelColor}>{label}</DetailLabel>
      )}
      <div
        className="d-flex align-items-center"
        style={{ gap: "0.75rem", marginTop: label ? "0.25rem" : 0 }}
      >
        <div
          style={{
            flex: 1,
            backgroundColor: trackColor,
            height: "14px",
            overflow: "hidden",
            borderRadius: "999px",
          }}
        >
          <div
            style={{
              width: `${percentValue}%`,
              backgroundColor: fillColor,
              height: "100%",
              borderRadius: "999px",
            }}
          />
        </div>
        <div
          className="font-weight-bolder"
          style={{ minWidth: "48px", textAlign: "right", color: valueColor }}
        >
          {parsePercent(percentValue)}%
        </div>
      </div>
    </div>
  );
}

const DETAIL_SECTION_BLUE = "#3311CC";
const PRICED_SUPPLIER_REQUEST_STATUS_ID = "a4c4f7b1-f415-4a1d-bdb4-2a1407f8d006";

export default function EditObrasPage() {
  const [obraHeader, setObraHeader] = useState(getEmptyObraHeader());
  const [customers, setCustomers] = useState([]);
  const [operarios, setOperarios] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [obraStatus, setObraStatus] = useState([]);
  const [obraPlanningStatus, setObraPlanningStatus] = useState([]);
  const [products, setProducts] = useState([]);
  const [materialRequests, setMaterialRequests] = useState([]);
  const [supplierRequests, setSupplierRequests] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [taskReports, setTaskReports] = useState([]);
  const [purchaseOrderEditor, setPurchaseOrderEditor] = useState(null);
  const [purchaseOrderEmailBodyDraft, setPurchaseOrderEmailBodyDraft] = useState("");
  const [confirmationDialog, setConfirmationDialog] = useState(null);
  const [emailLinkDialog, setEmailLinkDialog] = useState({ open: false, url: "https://" });
  const [savingPurchaseOrder, setSavingPurchaseOrder] = useState(false);
  const [savingPurchaseOrderSend, setSavingPurchaseOrderSend] = useState(false);
  const [openDeliveryDataDialog, setOpenDeliveryDataDialog] = useState(false);
  const [deliveryDataDraft, setDeliveryDataDraft] = useState(null);
  const [savingDeliveryData, setSavingDeliveryData] = useState(false);
  const [purchaseOrderReceipt, setPurchaseOrderReceipt] = useState(null);
  const [purchaseOrderQuantityDraft, setPurchaseOrderQuantityDraft] = useState(null);
  const [savingPurchaseOrderReceipt, setSavingPurchaseOrderReceipt] = useState(false);
  const [openDeliveryNoteDialog, setOpenDeliveryNoteDialog] = useState(false);
  const [deliveryNoteFile, setDeliveryNoteFile] = useState(null);
  const [analyzingDeliveryNote, setAnalyzingDeliveryNote] = useState(false);
  const [deliveryNoteDragActive, setDeliveryNoteDragActive] = useState(false);
  const [expandedPurchaseOrders, setExpandedPurchaseOrders] = useState([]);
  const [materialAssignmentEditor, setMaterialAssignmentEditor] = useState(null);
  const [materialAssignmentDraft, setMaterialAssignmentDraft] = useState(null);
  const [expandedMaterialAssignmentChapters, setExpandedMaterialAssignmentChapters] = useState([]);
  const [expandedMaterialAssignmentPartidas, setExpandedMaterialAssignmentPartidas] = useState([]);
  const [savingMaterialAssignments, setSavingMaterialAssignments] = useState(false);
  const [openOperariosDialog, setOpenOperariosDialog] = useState(false);
  const [selectedOperariosToAssign, setSelectedOperariosToAssign] = useState([]);
  const [savingOperarios, setSavingOperarios] = useState(false);
  const [openOperarioHoursDialog, setOpenOperarioHoursDialog] = useState(false);
  const [openOperarioHoursHistoryDialog, setOpenOperarioHoursHistoryDialog] = useState(false);
  const [openOperarioRealHoursHistoryDialog, setOpenOperarioRealHoursHistoryDialog] = useState(false);
  const [savingOperarioHours, setSavingOperarioHours] = useState(false);
  const [operarioHoursEntry, setOperarioHoursEntry] = useState({
    operario: null,
    fecha: formatDateForInput(new Date()),
    horas: 0,
    minutos: 0,
    observaciones: "",
  });
  const [operarioHoursHistory, setOperarioHoursHistory] = useState({ operario: null, rows: [] });
  const [loadingOperarioHoursHistory, setLoadingOperarioHoursHistory] = useState(false);
  const [operarioRealHoursHistory, setOperarioRealHoursHistory] = useState({ operario: null, rows: [] });
  const [loadingOperarioRealHoursHistory, setLoadingOperarioRealHoursHistory] = useState(false);
  const [expandedOperarioTaskHourDates, setExpandedOperarioTaskHourDates] = useState([]);
  const [taskReportEditor, setTaskReportEditor] = useState(null);
  const [taskReportLineDraft, setTaskReportLineDraft] = useState(null);
  const [taskReportHistoryDialog, setTaskReportHistoryDialog] = useState(null);
  const [expandedTaskReportChapters, setExpandedTaskReportChapters] = useState([]);
  const [expandedTaskReportPartidas, setExpandedTaskReportPartidas] = useState([]);
  const [savingTaskReport, setSavingTaskReport] = useState(false);
  const [taskVoiceDialog, setTaskVoiceDialog] = useState(null);
  const [sendingTaskVoice, setSendingTaskVoice] = useState(false);
  const taskVoiceRecorderRef = useRef(null);
  const taskVoiceDialogActiveRef = useRef(false);

  useEffect(() => () => {
    taskVoiceDialogActiveRef.current = false;
    const recorder = taskVoiceRecorderRef.current;
    if (!recorder) return;
    recorder.onstop = null;
    if (recorder.state !== "inactive") recorder.stop();
    if (recorder.stream) recorder.stream.getTracks().forEach((track) => track.stop());
  }, []);
  const [openHitosDialog, setOpenHitosDialog] = useState(false);
  const [openHitoEditorDialog, setOpenHitoEditorDialog] = useState(false);
  const [savingHitos, setSavingHitos] = useState(false);
  const [selectedTab, setSelectedTab] = useState("detalle");
  const [expandedChapters, setExpandedChapters] = useState([]);
  const [expandedPartidas, setExpandedPartidas] = useState([]);
  const [openMaterialRequestDialog, setOpenMaterialRequestDialog] = useState(false);
  const [savingMaterialRequest, setSavingMaterialRequest] = useState(false);
  const [materialRequestEditor, setMaterialRequestEditor] = useState(
    getEmptyMaterialRequestEditor()
  );
  const [openSupplierRequestDialog, setOpenSupplierRequestDialog] = useState(false);
  const [savingSupplierRequest, setSavingSupplierRequest] = useState(false);
  const [supplierRequestEditor, setSupplierRequestEditor] = useState(
    getEmptySupplierRequestEditor()
  );
  const [expandedSupplierRequestChapters, setExpandedSupplierRequestChapters] =
    useState([]);
  const [expandedSupplierRequestPartidas, setExpandedSupplierRequestPartidas] =
    useState([]);
  const [selectedSupplierRequestLineIds, setSelectedSupplierRequestLineIds] =
    useState([]);
  const [selectedSupplierItems, setSelectedSupplierItems] = useState([]);
  const [openSupplierSelectionDialog, setOpenSupplierSelectionDialog] =
    useState(false);
  const [openAddSupplierDialog, setOpenAddSupplierDialog] = useState(false);
  const [supplierRequestGroupToExtend, setSupplierRequestGroupToExtend] = useState(null);
  const [supplierToAdd, setSupplierToAdd] = useState(null);
  const [addingSupplierToRequest, setAddingSupplierToRequest] = useState(false);
  const [openSupplierRequestMailDialog, setOpenSupplierRequestMailDialog] =
    useState(false);
  const [sendingSupplierRequestMail, setSendingSupplierRequestMail] =
    useState(false);
  const [supplierRequestMailDraft, setSupplierRequestMailDraft] = useState(null);
  const [openSupplierBudgetSelectionDialog, setOpenSupplierBudgetSelectionDialog] =
    useState(false);
  const [loadingSupplierBudgetSelection, setLoadingSupplierBudgetSelection] =
    useState(false);
  const [savingSupplierBudgetSelection, setSavingSupplierBudgetSelection] =
    useState(false);
  const [supplierBudgetSelection, setSupplierBudgetSelection] = useState(
    getEmptySupplierBudgetSelection()
  );
  const budgetComparison = useMemo(
    () => calculateBudgetComparison(supplierBudgetSelection.materiales),
    [supplierBudgetSelection.materiales]
  );
  const [openSupplierResponseDialog, setOpenSupplierResponseDialog] =
    useState(false);
  const [savingSupplierResponse, setSavingSupplierResponse] = useState(false);
  const [autoFillingSupplierResponse, setAutoFillingSupplierResponse] = useState(false);
  const [autoFillSupplierResponseOnOpen, setAutoFillSupplierResponseOnOpen] = useState(false);
  const [supplierResponseEditor, setSupplierResponseEditor] = useState(
    getEmptySupplierResponseEditor()
  );
  const [supplierResponseSourceMail, setSupplierResponseSourceMail] = useState(null);
  const [openSupplierResponseSourceMailDialog, setOpenSupplierResponseSourceMailDialog] =
    useState(false);
  const [supplierRequestMailHistory, setSupplierRequestMailHistory] = useState({});
  const [supplierRequestHistoryMail, setSupplierRequestHistoryMail] = useState(null);
  const [openSupplierRequestHistoryMailDialog, setOpenSupplierRequestHistoryMailDialog] =
    useState(false);
  const [downloadingSupplierResponseAttachmentKey, setDownloadingSupplierResponseAttachmentKey] =
    useState(null);
  const [expandedSupplierRequestGroups, setExpandedSupplierRequestGroups] =
    useState([]);
  const [expandedSupplierRequests, setExpandedSupplierRequests] = useState([]);
  const [expandedMaterialRequestChapters, setExpandedMaterialRequestChapters] =
    useState([]);
  const [expandedMaterialRequestPartidas, setExpandedMaterialRequestPartidas] =
    useState([]);
  const [openMaterialQuantityDialog, setOpenMaterialQuantityDialog] =
    useState(false);
  const [materialQuantityDraft, setMaterialQuantityDraft] = useState(
    getEmptyMaterialQuantityDraft()
  );
  const [openExtraMaterialDialog, setOpenExtraMaterialDialog] = useState(false);
  const [selectedExtraProduct, setSelectedExtraProduct] = useState(null);
  const [extraMaterialQuantity, setExtraMaterialQuantity] = useState("1");
  const [extraMaterialIndications, setExtraMaterialIndications] = useState("");
  const [hitosDraft, setHitosDraft] = useState({
    fecha_inicio: "",
    fecha_fin: "",
    hitos: [],
  });
  const [hitoEditorMode, setHitoEditorMode] = useState({
    type: "hito",
    id: null,
  });
  const [hitoEditorDraft, setHitoEditorDraft] = useState(getDefaultHitoDraft());
  const obraOverviewRef = useRef(null);
  const deliveryNoteFileInputRef = useRef(null);
  const purchaseOrderEmailBodyEditorRef = useRef(null);
  const [obraOverviewHeight, setObraOverviewHeight] = useState(null);

  const obraProgressTotals = useMemo(() => {
    const partidas = (obraHeader.capitulos || []).flatMap((chapter) => chapter.partidas || []);
    return {
      importeInvertido: partidas.reduce((total, partida) => total + Number(partida.pvp_invertido || 0), 0),
      importeTotal: partidas.reduce((total, partida) => total + Number(partida.avance_importe_valor_total || 0), 0),
      tiempoParaAvance: (obraHeader.capitulos || []).reduce((total, chapter) => total + Number(chapter.tiempo_invertido_para_avance || 0), 0),
      tiempoTotal: (obraHeader.capitulos || []).reduce((total, chapter) => total + Number(chapter.tiempo_total || 0), 0),
      tiempoReal: Number(obraHeader.tiempo_real_operarios || 0),
      tareasCompletadas: partidas.reduce((total, partida) => total + Number(partida.avance_tareas_valor_actual || 0), 0),
      tareasTotales: partidas.reduce((total, partida) => total + Number(partida.avance_tareas_valor_total || 0), 0),
      materialesAsignados: partidas.reduce((total, partida) => total + Number(partida.avance_materiales_valor_actual || 0), 0),
      materialesTotales: partidas.reduce((total, partida) => total + Number(partida.avance_materiales_valor_total || 0), 0),
    };
  }, [obraHeader.capitulos, obraHeader.tiempo_real_operarios]);

  const obraId = useParams().id;
  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const accessToken = loggedUser?.accessToken;
  const customerId = obraHeader?.cliente_id;
  const obraStatusId = obraHeader?.estado_obra_id;
  const planningStatusId = obraHeader?.situacion_planificacion_id;

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  const handleBack = useCallback(() => {
    const prevTablePage = location.state?.page;
    history.push(`/obras${prevTablePage ? "?page=" + prevTablePage : ""}`);
  }, [history, location.state]);

  const loadObraPageData = useCallback(() => {
    return Promise.all([
      getObraHeaderById(obraId, accessToken),
      getCustomers(accessToken),
      getOperarios(accessToken),
      getSuppliers(accessToken),
      getObraStatus(accessToken),
      getObraPlanningStatus(accessToken),
      getObraMaterialRequests(obraId, accessToken),
      getObraSupplierRequests(obraId, accessToken),
      getObraPurchaseOrders(obraId, accessToken),
      getObraTaskReports(obraId, accessToken),
    ]).then(
      ([
        obraRes,
        customersRes,
        operariosRes,
        suppliersRes,
        obraStatusRes,
        obraPlanningStatusRes,
        materialRequestsRes,
        supplierRequestsRes,
        purchaseOrdersRes,
        taskReportsRes,
      ]) => {
        if (obraRes.status === 200) {
          setObraHeader(obraRes.data);
        }
        if (customersRes.status === 200) {
          setCustomers(customersRes.data);
        }
        if (operariosRes.status === 200) {
          setOperarios(operariosRes.data);
        }
        if (suppliersRes.status === 200) {
          setSuppliers((suppliersRes.data || []).filter((item) => item?.activo));
        }
        if (obraStatusRes.status === 200) {
          setObraStatus(obraStatusRes.data);
        }
        if (obraPlanningStatusRes.status === 200) {
          setObraPlanningStatus(obraPlanningStatusRes.data);
        }
        if (materialRequestsRes.status === 200) {
          setMaterialRequests(materialRequestsRes.data);
        }
        if (supplierRequestsRes.status === 200) {
          setSupplierRequests(supplierRequestsRes.data);
        }
        if (purchaseOrdersRes.status === 200) {
          setPurchaseOrders(purchaseOrdersRes.data || []);
        }
        if (taskReportsRes.status === 200) {
          setTaskReports(taskReportsRes.data || []);
        }
      }
    );
  }, [obraId, accessToken]);

  useEffect(() => {
    if (!obraId) {
      handleBack();
      return;
    }

    loadObraPageData()
      .then(() => {
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se ha podido obtener la obra.",
        });
        handleBack();
      });
  }, [obraId, disableLoadingData, handleBack, loadObraPageData]);

  const customer = useMemo(
    () => customers.find((item) => item.id === customerId) || null,
    [customers, customerId]
  );

  const selectedObraStatus = useMemo(
    () => obraStatus.find((item) => item.id === obraStatusId) || null,
    [obraStatus, obraStatusId]
  );

  const selectedPlanningStatus = useMemo(
    () => obraPlanningStatus.find((item) => item.id === planningStatusId) || null,
    [obraPlanningStatus, planningStatusId]
  );

  const assignedOperarios = useMemo(() => {
    if (!obraHeader?.operarios?.length) {
      return [];
    }

    return obraHeader.operarios
      .map((obraOperario) => {
        const operario = operarios.find(
          (item) => item.id === obraOperario.operario_id
        );

        return {
          ...obraOperario,
          nombreCompleto: operario
            ? `${operario.nombre || ""} ${operario.apellidos || ""}`.trim()
            : obraOperario.operario_id,
          categoria: operario?.categoria?.descripcion || "",
          costeHora: Number(operario?.coste_hora || 0),
          esExterno: Boolean(operario?.es_externo),
          proveedorNombre: suppliers.find((supplier) => supplier.id === operario?.proveedor_id)?.nombre || "",
        };
      })
      .sort((a, b) => a.nombreCompleto.localeCompare(b.nombreCompleto));
  }, [obraHeader, operarios, suppliers]);

  const getTaskCompanionNames = (companionIds = []) =>
    companionIds
      .map((operarioId) =>
        assignedOperarios.find((operario) => operario.operario_id === operarioId)
          ?.nombreCompleto
      )
      .filter(Boolean);

  useEffect(() => {
    const overviewElement = obraOverviewRef.current;

    if (isLoadingData || !overviewElement) {
      return undefined;
    }

    const updateOverviewHeight = () => {
      setObraOverviewHeight(Math.ceil(overviewElement.getBoundingClientRect().height));
    };

    updateOverviewHeight();
    const observer = new ResizeObserver(updateOverviewHeight);
    observer.observe(overviewElement);

    return () => observer.disconnect();
  }, [isLoadingData]);

  const availableOperarios = useMemo(() => {
    const assignedIds = new Set(assignedOperarios.map((item) => item.operario_id));

    return operarios
      .filter((operario) => operario?.activo && !assignedIds.has(operario.id))
      .sort((a, b) =>
        `${a.apellidos || ""} ${a.nombre || ""}`.localeCompare(
          `${b.apellidos || ""} ${b.nombre || ""}`
        )
      );
  }, [assignedOperarios, operarios]);

  const hitoRows = useMemo(() => {
    const sortedHitos = getSortedHitos(hitosDraft.hitos);

    return [
      {
        key: "start",
        type: "start",
        description: "FECHA INICIO",
        date: hitosDraft.fecha_inicio,
      },
      ...sortedHitos.map((hito) => ({
        key: hito.id || hito.tempId,
        type: "hito",
        id: hito.id || hito.tempId,
        description: `${parsePercent(hito.completado_tiempo)}%`,
        date: hito.fecha_prevista,
        completado_tiempo: hito.completado_tiempo,
      })),
      {
        key: "end",
        type: "end",
        description: "FECHA FIN",
        date: hitosDraft.fecha_fin,
      },
    ];
  }, [hitosDraft]);

  const detailChapters = useMemo(
    () => [...(obraHeader.capitulos || [])].sort((a, b) => a.ordinal - b.ordinal),
    [obraHeader]
  );

  const selectedMaterialRequestLines = useMemo(() => {
    const obraLines = [];

    (materialRequestEditor.capitulos || []).forEach((chapter) => {
      (chapter.partidas || []).forEach((partida) => {
        (partida.productos || []).forEach((product) => {
          if (parseDecimal(product.cantidad_seleccionada) > 0) {
            const isMaterialGroup = Boolean(product.es_agrupacion_material);
            obraLines.push({
              key: isMaterialGroup
                ? `group-${product.obra_agrupacion_material_id}`
                : `obra-${product.obra_producto_id}`,
              isExtra: false,
              isMaterialGroup,
              chapterDescription: `Cap. ${chapter.ordinal} ${chapter.descripcion}`,
              partidaDescription: `${partida.ordinal}. ${partida.descripcion}`,
              description: product.descripcion,
              reference: product.referencia,
              unit: product.unidad,
              quantity: parseDecimal(product.cantidad_seleccionada),
              totalNeeded: parseDecimal(product.cantidad_total_obra),
              requested: parseDecimal(product.cantidad_solicitada_acumulada),
              pending: parseDecimal(product.cantidad_pendiente),
              capitulo_id: chapter.capitulo_id,
              partida_id: partida.partida_id,
              obra_producto_id: isMaterialGroup ? null : product.obra_producto_id,
              obra_agrupacion_material_id: isMaterialGroup
                ? product.obra_agrupacion_material_id
                : null,
              plantilla_producto_original_id: product.plantilla_producto_original_id,
              referencia_snapshot: product.referencia,
              descripcion_snapshot: product.descripcion,
              unidad_snapshot: product.unidad,
            });
          }
        });
      });
    });

    const extraLines = (materialRequestEditor.material_adicional || [])
      .filter((item) => parseDecimal(item.cantidad_seleccionada) > 0)
      .map((item) => ({
        key: `extra-${item.plantilla_producto_original_id}`,
        isExtra: true,
        chapterDescription: "Material adicional",
        partidaDescription: "",
        description: item.descripcion,
        reference: item.referencia,
        unit: item.unidad,
        quantity: parseDecimal(item.cantidad_seleccionada),
        totalNeeded: null,
        requested: null,
        pending: null,
        plantilla_producto_original_id: item.plantilla_producto_original_id,
        referencia_snapshot: item.referencia,
        descripcion_snapshot: item.descripcion,
        unidad_snapshot: item.unidad,
        indicaciones: item.indicaciones || "",
      }));

    return [...obraLines, ...extraLines];
  }, [materialRequestEditor]);

  const supplierRequestGroups = useMemo(() => {
    const grouped = new Map();

    (supplierRequests || []).forEach((request) => {
      const groupId = request.solicitud_presupuesto_grupo_id;
      const currentGroup = grouped.get(groupId) || {
        id: groupId,
        codigo: request.grupo_codigo || "-",
        descripcion: request.grupo_descripcion || "",
        fecha_solicitud: request.fecha_solicitud,
        requests: [],
      };

      currentGroup.requests.push(request);
      grouped.set(groupId, currentGroup);
    });

    return Array.from(grouped.values())
      .map((group) => ({
        ...group,
        requests: [...group.requests].sort(
          (a, b) => new Date(b.fecha_solicitud).getTime() - new Date(a.fecha_solicitud).getTime()
        ),
      }))
      .sort(
        (a, b) =>
          new Date(b.fecha_solicitud).getTime() - new Date(a.fecha_solicitud).getTime()
      );
  }, [supplierRequests]);

  const selectedSupplierRequestLines = useMemo(() => {
    const lines = [];

    (supplierRequestEditor.capitulos || []).forEach((chapter) => {
      (chapter.partidas || []).forEach((partida) => {
        (partida.productos || []).forEach((product) => {
          if (
            selectedSupplierRequestLineIds.includes(
              product.linea_solicitud_material_obra_id
            )
          ) {
            lines.push({
              key: product.linea_solicitud_material_obra_id,
              chapterDescription: `Cap. ${chapter.ordinal} ${chapter.descripcion}`,
              partidaDescription: `${partida.ordinal}. ${partida.descripcion}`,
              linea_solicitud_material_obra_id:
                product.linea_solicitud_material_obra_id,
              obra_producto_id: product.obra_producto_id,
              plantilla_producto_original_id: product.plantilla_producto_original_id,
              description: product.descripcion,
              reference: product.referencia,
              unit: product.unidad,
              quantity: parseDecimal(product.cantidad_solicitada),
            });
          }
        });
      });
    });

    return lines;
  }, [selectedSupplierRequestLineIds, supplierRequestEditor]);

  const availableExtraProducts = useMemo(() => {
    const selectedIds = new Set(
      (materialRequestEditor.material_adicional || []).map(
        (item) => item.plantilla_producto_original_id
      )
    );

    return products
      .filter((product) => !selectedIds.has(product.id) && !product.tipo_producto?.es_mano_de_obra)
      .sort((a, b) =>
        `${a.referencia || ""} ${a.descripcion || ""}`.localeCompare(
          `${b.referencia || ""} ${b.descripcion || ""}`
        )
      );
  }, [materialRequestEditor, products]);

  const toggleMaterialRequestChapter = (chapterId) => {
    setExpandedMaterialRequestChapters((current) =>
      current.includes(chapterId)
        ? current.filter((item) => item !== chapterId)
        : [...current, chapterId]
    );
  };

  const toggleMaterialRequestPartida = (partidaId) => {
    setExpandedMaterialRequestPartidas((current) =>
      current.includes(partidaId)
        ? current.filter((item) => item !== partidaId)
        : [...current, partidaId]
    );
  };

  const updateMaterialRequestProductQuantity = (
    chapterId,
    partidaId,
    productId,
    quantity
  ) => {
    const normalizedChapterId = String(chapterId);
    const normalizedPartidaId = String(partidaId);
    const normalizedProductId = String(productId);

    setMaterialRequestEditor((current) => ({
      ...current,
      capitulos: (current.capitulos || []).map((chapter) =>
        String(chapter.capitulo_id) !== normalizedChapterId
          ? chapter
          : {
              ...chapter,
              partidas: (chapter.partidas || []).map((partida) =>
                String(partida.partida_id) !== normalizedPartidaId
                  ? partida
                  : {
                      ...partida,
                      productos: (partida.productos || []).map((product) =>
                        String(product.obra_producto_id) !== normalizedProductId
                          ? product
                          : {
                              ...product,
                              cantidad_seleccionada: quantity,
                            }
                      ),
                    }
              ),
            }
      ),
    }));
  };

  const handleSelectWholePartida = (chapterId, partidaId) => {
    const normalizedChapterId = String(chapterId);
    const normalizedPartidaId = String(partidaId);

    setMaterialRequestEditor((current) => ({
      ...current,
      capitulos: (current.capitulos || []).map((chapter) =>
        String(chapter.capitulo_id) !== normalizedChapterId
          ? chapter
          : {
              ...chapter,
              partidas: (chapter.partidas || []).map((partida) =>
                String(partida.partida_id) !== normalizedPartidaId
                  ? partida
                  : {
                      ...partida,
                      productos: (partida.productos || []).map((product) => ({
                        ...product,
                        cantidad_seleccionada: parseDecimal(product.cantidad_pendiente),
                      })),
                    }
              ),
            }
      ),
    }));
  };

  const handleSelectWholeChapter = (chapterId) => {
    setMaterialRequestEditor((current) => ({
      ...current,
      capitulos: (current.capitulos || []).map((chapter) =>
        chapter.capitulo_id !== chapterId
          ? chapter
          : {
              ...chapter,
              partidas: (chapter.partidas || []).map((partida) => ({
                ...partida,
                productos: (partida.productos || []).map((product) => ({
                  ...product,
                  cantidad_seleccionada: parseDecimal(product.cantidad_pendiente),
                })),
              })),
            }
      ),
    }));
  };

  const handleRemoveSelectedMaterialLine = (line) => {
    if (line.isExtra) {
      setMaterialRequestEditor((current) => ({
        ...current,
        material_adicional: (current.material_adicional || []).filter(
          (item) =>
            item.plantilla_producto_original_id !==
            line.plantilla_producto_original_id
        ),
      }));
      return;
    }

    updateMaterialRequestProductQuantity(
      line.capitulo_id,
      line.partida_id,
      line.isMaterialGroup
        ? line.obra_agrupacion_material_id
        : line.obra_producto_id,
      0
    );
  };

  const handleOpenMaterialQuantityDialog = (chapterId, partidaId, product) => {
    setMaterialQuantityDraft({
      mode: "material",
      chapterId,
      partidaId,
      productId: product.obra_producto_id,
      maxQuantity: parseDecimal(product.cantidad_pendiente),
      quantity:
        parseDecimal(product.cantidad_seleccionada) > 0
          ? String(product.cantidad_seleccionada)
          : String(product.cantidad_pendiente),
      description: product.descripcion,
    });
    setOpenMaterialQuantityDialog(true);
  };

  const handleOpenSelectedLineEditor = (line) => {
    if (line.isExtra) {
      setSelectedExtraProduct({
        id: line.plantilla_producto_original_id,
        referencia: line.reference,
        descripcion: line.description,
        tipo_unidad: { descripcion: line.unit || "" },
      });
      setExtraMaterialQuantity(String(line.quantity));
      setExtraMaterialIndications(line.indicaciones || "");
      setOpenExtraMaterialDialog(true);
      return;
    }

    setMaterialQuantityDraft({
      mode: "material",
      chapterId: line.capitulo_id,
      partidaId: line.partida_id,
      productId: line.obra_producto_id,
      maxQuantity: parseDecimal(line.pending) + parseDecimal(line.quantity),
      quantity: String(line.quantity),
      description: line.description,
    });
    setOpenMaterialQuantityDialog(true);
  };

  const handleSaveMaterialQuantity = () => {
    const quantity = parseDecimal(materialQuantityDraft.quantity);
    if (quantity <= 0) {
      alertError({
        customMessage: "La cantidad debe ser superior a cero.",
      });
      return;
    }

    if (quantity > parseDecimal(materialQuantityDraft.maxQuantity)) {
      alertError({
        customMessage: "La cantidad no puede superar el pendiente actual.",
      });
      return;
    }

    updateMaterialRequestProductQuantity(
      materialQuantityDraft.chapterId,
      materialQuantityDraft.partidaId,
      materialQuantityDraft.productId,
      quantity
    );
    setOpenMaterialQuantityDialog(false);
    setMaterialQuantityDraft(getEmptyMaterialQuantityDraft());
  };

  const loadProductsIfNeeded = async () => {
    if (products.length) {
      return;
    }

    const res = await getProducts(accessToken);
    if (res.status === 200) {
      setProducts(res.data);
    }
  };

  const handleOpenExtraMaterialDialog = async () => {
    try {
      await loadProductsIfNeeded();
      setSelectedExtraProduct(null);
      setExtraMaterialQuantity("1");
      setExtraMaterialIndications("");
      setOpenExtraMaterialDialog(true);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se han podido cargar los materiales adicionales.",
      });
    }
  };

  const handleAddExtraMaterial = () => {
    if (!selectedExtraProduct) {
      return;
    }

    const quantity = parseDecimal(extraMaterialQuantity);
    if (quantity <= 0) {
      alertError({
        customMessage: "La cantidad debe ser superior a cero.",
      });
      return;
    }

    setMaterialRequestEditor((current) => ({
      ...current,
      material_adicional: (() => {
        const currentLines = [...(current.material_adicional || [])];
        const existingIndex = currentLines.findIndex(
          (item) =>
            item.plantilla_producto_original_id === selectedExtraProduct.id
        );

        if (existingIndex >= 0) {
          currentLines[existingIndex] = {
            ...currentLines[existingIndex],
            cantidad_seleccionada: quantity,
            indicaciones: extraMaterialIndications.trim(),
          };
          return currentLines;
        }

        return currentLines.concat({
          plantilla_producto_original_id: selectedExtraProduct.id,
          referencia: selectedExtraProduct.referencia,
          descripcion: selectedExtraProduct.descripcion,
          unidad: selectedExtraProduct?.tipo_unidad?.descripcion || "",
          cantidad_seleccionada: quantity,
          indicaciones: extraMaterialIndications.trim(),
        });
      })(),
    }));

    setOpenExtraMaterialDialog(false);
    setSelectedExtraProduct(null);
    setExtraMaterialQuantity("1");
    setExtraMaterialIndications("");
  };

  const handleOpenMaterialRequestDialog = useCallback(async (requestId = null) => {
    try {
      const res = await getObraMaterialRequestEditor(obraId, requestId, accessToken);
      if (res.status === 200) {
        setMaterialRequestEditor({
          ...getEmptyMaterialRequestEditor(),
          ...res.data,
        });
        setExpandedMaterialRequestChapters([]);
        setExpandedMaterialRequestPartidas([]);
        setOpenMaterialRequestDialog(true);
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar la solicitud de material.",
      });
    }
  }, [accessToken, obraId]);

  const handleSaveMaterialRequest = async () => {
    if (!materialRequestEditor.operario_solicita_id) {
      alertError({
        customMessage: "Debes indicar el operario que realiza la solicitud.",
      });
      return;
    }

    if (!selectedMaterialRequestLines.length) {
      alertError({
        customMessage: "Debes seleccionar al menos un material.",
      });
      return;
    }

    setSavingMaterialRequest(true);

    try {
      const payload = {
        operario_solicita_id: materialRequestEditor.operario_solicita_id,
        observaciones: materialRequestEditor.observaciones || null,
        lineas: selectedMaterialRequestLines.map((line) => ({
          capitulo_id: line.isExtra ? null : line.capitulo_id,
          partida_id: line.isExtra ? null : line.partida_id,
          obra_producto_id: line.isExtra ? null : line.obra_producto_id,
          obra_agrupacion_material_id: line.isExtra
            ? null
            : line.obra_agrupacion_material_id,
          plantilla_producto_original_id: line.plantilla_producto_original_id,
          es_material_extra: line.isExtra,
          referencia_snapshot: line.reference,
          descripcion_snapshot: line.description,
          unidad_snapshot: line.unit,
          cantidad_solicitada: line.quantity,
          indicaciones: line.isExtra ? line.indicaciones : null,
        })),
      };

      if (materialRequestEditor.solicitud_id) {
        await updateObraMaterialRequest(
          obraId,
          materialRequestEditor.solicitud_id,
          payload,
          accessToken
        );
      } else {
        await postObraMaterialRequest(obraId, payload, accessToken);
      }

      await loadObraPageData();
      alertSuccess({
        customMessage: "Solicitud de material guardada con éxito.",
      });
      setOpenMaterialRequestDialog(false);
      setMaterialRequestEditor(getEmptyMaterialRequestEditor());
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido guardar la solicitud de material.",
      });
    } finally {
      setSavingMaterialRequest(false);
    }
  };

  const handleChangeMaterialRequestStatus = useCallback(async (requestId, action) => {
    try {
      await updateObraMaterialRequestStatus(
        obraId,
        requestId,
        { accion: action },
        accessToken
      );
      await loadObraPageData();
      alertSuccess({
        customMessage:
          action === "APROBAR"
            ? "Solicitud aprobada con éxito."
            : "Solicitud rechazada con éxito.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido actualizar el estado de la solicitud.",
      });
    }
  }, [accessToken, loadObraPageData, obraId]);

  const toggleSupplierRequestChapter = (chapterId) => {
    setExpandedSupplierRequestChapters((current) =>
      current.includes(chapterId)
        ? current.filter((item) => item !== chapterId)
        : [...current, chapterId]
    );
  };

  const toggleSupplierRequestPartida = (partidaId) => {
    setExpandedSupplierRequestPartidas((current) =>
      current.includes(partidaId)
        ? current.filter((item) => item !== partidaId)
        : [...current, partidaId]
    );
  };

  const toggleSupplierRequestLine = (lineId) => {
    setSelectedSupplierRequestLineIds((current) =>
      current.includes(lineId)
        ? current.filter((item) => item !== lineId)
        : [...current, lineId]
    );
  };

  const handleSelectWholeSupplierPartida = (partida) => {
    const partidaLineIds = (partida.productos || []).map(
      (product) => product.linea_solicitud_material_obra_id
    );

    setSelectedSupplierRequestLineIds((current) => {
      const allSelected = partidaLineIds.every((lineId) => current.includes(lineId));
      if (allSelected) {
        return current.filter((lineId) => !partidaLineIds.includes(lineId));
      }

      return [...new Set([...current, ...partidaLineIds])];
    });
  };

  const handleSelectWholeSupplierChapter = (chapter) => {
    const chapterLineIds = (chapter.partidas || []).flatMap((partida) =>
      (partida.productos || []).map(
        (product) => product.linea_solicitud_material_obra_id
      )
    );

    setSelectedSupplierRequestLineIds((current) => {
      const allSelected = chapterLineIds.every((lineId) => current.includes(lineId));
      if (allSelected) {
        return current.filter((lineId) => !chapterLineIds.includes(lineId));
      }

      return [...new Set([...current, ...chapterLineIds])];
    });
  };

  const handleRemoveSelectedSupplierRequestLine = (lineId) => {
    setSelectedSupplierRequestLineIds((current) =>
      current.filter((item) => item !== lineId)
    );
  };

  const resetSupplierRequestDialog = useCallback(() => {
    setSupplierRequestEditor(getEmptySupplierRequestEditor());
    setExpandedSupplierRequestChapters([]);
    setExpandedSupplierRequestPartidas([]);
    setSelectedSupplierRequestLineIds([]);
    setSelectedSupplierItems([]);
  }, []);

  const handleOpenSupplierRequestDialog = useCallback(async (requestId = null) => {
    try {
      const requests = [getObraSupplierRequestEditor(obraId, requestId, accessToken)];

      if (requestId) {
        requests.push(getObraSupplierRequestById(obraId, requestId, accessToken));
      }

      const responses = await Promise.all(requests);
      const editorResponse = responses[0];
      const detailResponse = responses[1];

      if (editorResponse.status === 200) {
        const detail = detailResponse?.status === 200 ? detailResponse.data : null;
        const selectedSupplier = detail
          ? suppliers.find((item) => item.id === detail.proveedor_id) || {
              id: detail.proveedor_id,
              nombre: detail.proveedor_nombre || "Proveedor",
            }
          : null;

        setSupplierRequestEditor({
          ...getEmptySupplierRequestEditor(),
          ...editorResponse.data,
          requestId,
          observaciones: detail?.observaciones || "",
        });
        setExpandedSupplierRequestChapters([]);
        setExpandedSupplierRequestPartidas([]);
        setSelectedSupplierRequestLineIds(
          detail?.lineas?.map((line) => line.linea_solicitud_material_obra_id) || []
        );
        setSelectedSupplierItems(selectedSupplier ? [selectedSupplier] : []);
        setOpenSupplierRequestDialog(true);
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar la solicitud de presupuesto.",
      });
    }
  }, [accessToken, obraId, suppliers]);

  const handleOpenSupplierRequestGroupDialog = useCallback(async (group) => {
    const firstRequest = group?.requests?.[0];
    if (!firstRequest) {
      return;
    }

    try {
      const requests = [
        getObraSupplierRequestEditor(obraId, firstRequest.id, accessToken),
        ...group.requests.map((request) =>
          getObraSupplierRequestById(obraId, request.id, accessToken)
        ),
      ];

      const responses = await Promise.all(requests);
      const editorResponse = responses[0];
      const detailResponses = responses.slice(1).filter((response) => response?.status === 200);
      const details = detailResponses.map((response) => response.data);

      if (editorResponse.status === 200) {
        setSupplierRequestEditor({
          ...getEmptySupplierRequestEditor(),
          ...editorResponse.data,
          requestId: firstRequest.id,
          requestIds: group.requests.map((request) => request.id),
          groupId: group.id,
          observaciones: details[0]?.observaciones || "",
        });
        setExpandedSupplierRequestChapters([]);
        setExpandedSupplierRequestPartidas([]);
        setSelectedSupplierRequestLineIds(
          details[0]?.lineas?.map((line) => line.linea_solicitud_material_obra_id) || []
        );
        setSelectedSupplierItems(
          details.map((detail) => ({
            id: detail.proveedor_id,
            nombre: detail.proveedor_nombre || "Proveedor",
          }))
        );
        setOpenSupplierRequestDialog(true);
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar el grupo de solicitudes de presupuesto.",
      });
    }
  }, [accessToken, obraId]);

  const handleSaveSupplierRequest = async () => {
    if (!selectedSupplierItems.length) {
      alertError({
        customMessage: "Debes seleccionar al menos un proveedor.",
      });
      return;
    }

    if (!selectedSupplierRequestLines.length) {
      alertError({
        customMessage: "Debes seleccionar al menos un material.",
      });
      return;
    }

    setSavingSupplierRequest(true);

    try {
      const payload = {
        observaciones: supplierRequestEditor.observaciones || null,
        proveedor_ids: selectedSupplierItems.map((supplier) => supplier.id),
        linea_solicitud_material_obra_ids: selectedSupplierRequestLines.map(
          (line) => line.linea_solicitud_material_obra_id
        ),
      };

      if (supplierRequestEditor.requestIds?.length) {
        await Promise.all(
          supplierRequestEditor.requestIds.map((requestId) =>
            updateObraSupplierRequest(
              obraId,
              requestId,
              {
                observaciones: payload.observaciones,
                linea_solicitud_material_obra_ids:
                  payload.linea_solicitud_material_obra_ids,
              },
              accessToken
            )
          )
        );
      } else if (supplierRequestEditor.requestId) {
        await updateObraSupplierRequest(
          obraId,
          supplierRequestEditor.requestId,
          {
            observaciones: payload.observaciones,
            linea_solicitud_material_obra_ids: payload.linea_solicitud_material_obra_ids,
          },
          accessToken
        );
      } else {
        await postObraSupplierRequest(obraId, payload, accessToken);
      }

      await loadObraPageData();
      alertSuccess({
        customMessage: "Solicitud de presupuesto guardada con éxito.",
      });
      setOpenSupplierRequestDialog(false);
      setSupplierRequestEditor(getEmptySupplierRequestEditor());
      setSelectedSupplierItems([]);
      setSelectedSupplierRequestLineIds([]);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido guardar la solicitud de presupuesto.",
      });
    } finally {
      setSavingSupplierRequest(false);
    }
  };

  const handleChangeSupplierRequestStatus = useCallback(async (requestId, action) => {
    try {
      await updateObraSupplierRequestStatus(
        obraId,
        requestId,
        { accion: action },
        accessToken
      );
      await loadObraPageData();
      alertSuccess({
        customMessage: "Estado de la solicitud actualizado con éxito.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido actualizar el estado de la solicitud.",
      });
    }
  }, [accessToken, loadObraPageData, obraId]);

  const handleOpenSupplierRequestMailDialog = useCallback(async (request) => {
    try {
      const res = await getObraSupplierRequestById(obraId, request.id, accessToken);
      if (res.status !== 200) {
        return;
      }

      const detail = res.data;
      setSupplierRequestMailDraft({
        requestIds: [request.id],
        recipients: [
          {
            requestId: request.id,
            to_email: detail.proveedor_email || "",
            subject: buildSupplierRequestMailSubject(
              obraHeader.codigo_obra || "",
              detail.codigo || request.codigo || ""
            ),
            body: buildSupplierRequestMailBody(detail),
          },
        ],
        initialValues: {
          to_email: detail.proveedor_email || "",
          subject: `Petición de presupuesto de NEO 4 para ${obraHeader.codigo_obra || ""}`.trim(),
          body: buildSupplierRequestMailBody(detail),
        },
      });
      setSupplierRequestMailDraft((current) => ({
        ...current,
        initialValues: {
          ...(current?.initialValues || {}),
          subject: buildSupplierRequestMailSubject(
            obraHeader.codigo_obra || "",
            detail.codigo || request.codigo || ""
          ),
        },
      }));
      setSupplierRequestMailDraft((current) => ({
        ...current,
        initialValues: {
          ...(current?.initialValues || {}),
          subject: buildSupplierRequestMailSubject(
            obraHeader.codigo_obra || "",
            detail.codigo || request.codigo || ""
          ),
        },
      }));
      setOpenSupplierRequestMailDialog(true);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido preparar el mail de solicitud.",
      });
    }
  }, [accessToken, obraHeader.codigo_obra, obraId]);

  const handleOpenSupplierRequestGroupMailDialog = useCallback(async (group) => {
    const requests = group?.requests || [];
    if (!requests.length) {
      return;
    }

    try {
      const responses = await Promise.all(
        requests.map((request) => getObraSupplierRequestById(obraId, request.id, accessToken))
      );

      const details = responses
        .filter((response) => response.status === 200)
        .map((response) => response.data);

      if (!details.length) {
        return;
      }

      const firstDetail = details[0];

      setSupplierRequestMailDraft({
        requestIds: details.map((detail) => detail.id),
        recipients: details.map((detail) => ({
          requestId: detail.id,
          to_email: detail.proveedor_email || "",
          subject: buildSupplierRequestMailSubject(
            obraHeader.codigo_obra || "",
            detail.codigo || ""
          ),
          body: buildSupplierRequestMailBody(detail),
        })),
        initialValues: {
          to_email: firstDetail.proveedor_email || "",
          subject: `Petición de presupuesto de NEO 4 para ${obraHeader.codigo_obra || ""}`.trim(),
          body: buildSupplierRequestMailBody(firstDetail),
        },
        hideToEmailField: true,
        recipientPreviewList: details.map(
          (detail) => detail.proveedor_email || "Sin email"
        ),
        helperText:
          details.length > 1
            ? `Se enviará una copia individual a ${details.length} proveedores del grupo.`
            : null,
      });
      setOpenSupplierRequestMailDialog(true);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido preparar el mail del grupo.",
      });
    }
  }, [accessToken, obraHeader.codigo_obra, obraId]);

const handleSendSupplierRequestMail = useCallback(async (payload) => {
    if (!supplierRequestMailDraft?.requestIds?.length) {
      return;
    }

    setSendingSupplierRequestMail(true);

    try {
      const sentRequests = await Promise.all(
        (supplierRequestMailDraft.recipients || []).map(async (recipient) => {
          const recipientEmail = recipient.to_email || payload.to_email;
          const response = await sendObraSupplierRequestMail(
            obraId,
            recipient.requestId,
            {
              ...payload,
              to_email: recipientEmail,
              subject: recipient.subject || payload.subject,
              body: recipient.body || payload.body,
            },
            accessToken
          );

          return {
            requestId: recipient.requestId,
            recipientEmail,
            subject: recipient.subject || payload.subject,
            result: response.data || {},
          };
        })
      );
      await loadObraPageData();
      setSupplierRequestMailHistory((current) => {
        const next = { ...current };

        sentRequests.forEach((sent) => {
          if (!sent.result?.mail_id) {
            return;
          }

          const existingMessages = next[sent.requestId]?.messages || [];
          const alreadyRegistered = existingMessages.some(
            (mail) => mail.id === sent.result.mail_id
          );

          next[sent.requestId] = {
            loading: false,
            messages: alreadyRegistered
              ? existingMessages
              : [
                  ...existingMessages,
                  {
                    id: sent.result.mail_id,
                    tipo_mail: "Enviado",
                    fecha: new Date().toISOString(),
                    destinatarios: sent.recipientEmail,
                    asunto: sent.subject,
                  },
                ],
          };
        });

        return next;
      });
      alertSuccess({
        customMessage:
          supplierRequestMailDraft.requestIds.length > 1
            ? "Solicitudes enviadas por mail con éxito."
            : "Solicitud enviada por mail con éxito.",
      });
      setOpenSupplierRequestMailDialog(false);
      setSupplierRequestMailDraft(null);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido enviar el mail de solicitud.",
      });
    } finally {
      setSendingSupplierRequestMail(false);
    }
  }, [accessToken, loadObraPageData, obraId, supplierRequestMailDraft]);

  const toggleSupplierRequestGroup = useCallback((groupId) => {
    setExpandedSupplierRequestGroups((current) =>
      current.includes(groupId)
        ? current.filter((item) => item !== groupId)
        : [...current, groupId]
    );
  }, []);

  const loadSupplierRequestMailHistory = useCallback(async (requestId) => {
    setSupplierRequestMailHistory((current) => ({
      ...current,
      [requestId]: { loading: true, messages: current[requestId]?.messages || [] },
    }));

    try {
      const response = await getObraSupplierRequestMailHistory(obraId, requestId, accessToken);
      setSupplierRequestMailHistory((current) => ({
        ...current,
        [requestId]: { loading: false, messages: response.data || [] },
      }));
    } catch (error) {
      setSupplierRequestMailHistory((current) => ({
        ...current,
        [requestId]: {
          loading: false,
          messages: current[requestId]?.messages || [],
          error: true,
        },
      }));
    }
  }, [accessToken, obraId]);

  const toggleSupplierRequest = useCallback((requestId) => {
    const opening = !expandedSupplierRequests.includes(requestId);
    setExpandedSupplierRequests((current) =>
      current.includes(requestId)
        ? current.filter((item) => item !== requestId)
        : [...current, requestId]
    );

    if (opening) {
      loadSupplierRequestMailHistory(requestId);
    }
  }, [expandedSupplierRequests, loadSupplierRequestMailHistory]);

  useEffect(() => {
    let cancelled = false;

    const refreshSupplierMailActivity = async () => {
      try {
        const requestsResponse = await getObraSupplierRequests(obraId, accessToken);
        if (!cancelled && requestsResponse.status === 200) {
          setSupplierRequests(requestsResponse.data || []);
        }

        const historyResponses = await Promise.all(
          expandedSupplierRequests.map(async (requestId) => {
            const response = await getObraSupplierRequestMailHistory(
              obraId,
              requestId,
              accessToken
            );
            return { requestId, messages: response.data || [] };
          })
        );

        if (!cancelled && historyResponses.length) {
          setSupplierRequestMailHistory((current) => {
            const next = { ...current };
            historyResponses.forEach(({ requestId, messages }) => {
              next[requestId] = { loading: false, messages };
            });
            return next;
          });
        }
      } catch {
        // The background refresh must never interrupt the user's current work.
      }
    };

    const intervalId = window.setInterval(refreshSupplierMailActivity, 10000);
    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, [accessToken, expandedSupplierRequests, obraId]);

  const handleOpenSupplierRequestHistoryMail = useCallback(async (requestId, mailId, markAsReviewed) => {
    try {
      const response = await getMailboxMessage(mailId, accessToken);
      if (response.status === 200) {
        setSupplierRequestHistoryMail(response.data || null);
        setOpenSupplierRequestHistoryMailDialog(true);

        if (markAsReviewed) {
          try {
            const reviewResponse = await markObraSupplierRequestMailAsReviewed(
              obraId,
              requestId,
              mailId,
              accessToken
            );
            const pendingCount = reviewResponse.data?.respuestas_pendientes_revision;

            setSupplierRequests((current) =>
              (current || []).map((request) =>
                request.id === requestId
                  ? {
                      ...request,
                      respuestas_pendientes_revision:
                        typeof pendingCount === "number"
                          ? pendingCount
                          : Math.max(0, (request.respuestas_pendientes_revision || 0) - 1),
                    }
                  : request
              )
            );
            setSupplierRequestMailHistory((current) => ({
              ...current,
              [requestId]: {
                ...(current[requestId] || {}),
                messages: (current[requestId]?.messages || []).map((mail) =>
                  mail.id === mailId ? { ...mail, revisado: true } : mail
                ),
              },
            }));
          } catch (reviewError) {
            alertError({
              error: reviewError,
              customMessage: "El correo se ha abierto, pero no se ha podido marcar como revisado.",
            });
          }
        }
      }
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido abrir el mail seleccionado." });
    }
  }, [accessToken, obraId]);

  const handleDeleteSupplierRequest = useCallback(async (request) => {
    setConfirmationDialog({
      title: "Eliminar solicitud de presupuesto",
      message: `¿Quieres eliminar la solicitud de presupuesto para ${request.proveedor_nombre || "este proveedor"}?`,
      confirmLabel: "Eliminar",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraSupplierRequest(obraId, request.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Solicitud de presupuesto eliminada con éxito." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar la solicitud de presupuesto." });
        }
      },
    });
  }, [accessToken, loadObraPageData, obraId]);

  const handleDeleteSupplierRequestGroup = useCallback(async (group) => {
    setConfirmationDialog({
      title: "Eliminar grupo de solicitudes",
      message: `¿Quieres eliminar el grupo ${group.codigo || ""} y todas sus solicitudes?`,
      confirmLabel: "Eliminar grupo",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraSupplierRequestGroup(obraId, group.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Grupo de solicitudes eliminado con éxito." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar el grupo de solicitudes." });
        }
      },
    });
  }, [accessToken, loadObraPageData, obraId]);

  const handleOpenSupplierBudgetSelectionDialog = useCallback(async (group) => {
    setLoadingSupplierBudgetSelection(true);

    try {
      const res = await getObraSupplierRequestBudgetSelection(
        obraId,
        group.id,
        accessToken
      );

      if (res.status !== 200) {
        return;
      }

      const materiales = (res.data?.materiales || []).map((material) => {
        const precios = (material.precios || []).map((precio) => ({
          ...precio,
          precio_unitario: parseDecimal(precio.precio_unitario),
          precio_total: parseDecimal(precio.precio_total),
        }));
        const selected = availableBudgetPrices({ precios })[0];
        return {
          ...material,
          cantidad: parseDecimal(material.cantidad),
          precios,
          selectedSupplierRequestId: selected?.solicitud_presupuesto_cabecera_id || null,
        };
      });

      setSupplierBudgetSelection({
        groupId: res.data?.solicitud_presupuesto_grupo_id || group.id,
        groupCode: res.data?.grupo_codigo || group.codigo || "",
        materiales,
      });
      setOpenSupplierBudgetSelectionDialog(true);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar la selección de presupuesto.",
      });
    } finally {
      setLoadingSupplierBudgetSelection(false);
    }
  }, [accessToken, obraId]);

  const handleGeneratePurchaseOrders = useCallback(async () => {
    const selectedLines = (supplierBudgetSelection.materiales || []).map((material) => {
      const selectedPrice = (material.precios || []).find(
        (precio) => precio.solicitud_presupuesto_cabecera_id === material.selectedSupplierRequestId
      );
      return {
        solicitud_presupuesto_lineas_id: selectedPrice?.solicitud_presupuesto_lineas_id,
        solicitud_presupuesto_cabecera_id: selectedPrice?.solicitud_presupuesto_cabecera_id,
      };
    });
    const hasIncompleteSelection = selectedLines.some(
      (line) => !line.solicitud_presupuesto_lineas_id || !line.solicitud_presupuesto_cabecera_id
    );
    if (hasIncompleteSelection) {
      alertError({ customMessage: "Debes seleccionar un proveedor válido para cada material." });
      return;
    }
    if (!supplierBudgetSelection.groupId) {
      return;
    }
    setConfirmationDialog({
      title: "Generar pedidos en borrador",
      message: "Se creará un pedido en borrador por cada proveedor seleccionado. Podrás revisar el correo y el PDF antes de enviarlo.",
      confirmLabel: "Generar pedidos",
      onConfirm: async () => {
        setSavingSupplierBudgetSelection(true);
        try {
          const result = await generateObraPurchaseOrders(obraId, supplierBudgetSelection.groupId, { lineas: selectedLines }, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: `Pedidos borrador generados: ${result.data?.pedidos_generados || 0}.` });
          setOpenSupplierBudgetSelectionDialog(false);
          setSupplierBudgetSelection(getEmptySupplierBudgetSelection());
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido seleccionar el presupuesto." });
        } finally {
          setSavingSupplierBudgetSelection(false);
        }
      },
    });
  }, [accessToken, loadObraPageData, obraId, supplierBudgetSelection]);

  const handleDeleteMaterialRequest = useCallback(async (request) => {
    setConfirmationDialog({
      title: "Eliminar solicitud de material",
      message: `¿Quieres eliminar esta solicitud de material${request?.user_solicita_nombre ? ` de ${request.user_solicita_nombre}` : ""}?`,
      confirmLabel: "Eliminar",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraMaterialRequest(obraId, request.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Solicitud de material eliminada con éxito." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar la solicitud de material." });
        }
      },
    });
  }, [accessToken, loadObraPageData, obraId]);

  const handleEvaluateSupplierRequestResponsesPlaceholder = useCallback(() => {
    alertSuccess({
      customMessage: "La evaluación de respuestas por thread se implementará en el siguiente paso.",
    });
  }, []);

  void handleEvaluateSupplierRequestResponsesPlaceholder;

  const handleEvaluateSupplierRequestResponses = useCallback(async (request) => {
    try {
      await getMailboxThreads(accessToken);

      const responseRes = await getObraSupplierRequestResponse(
        obraId,
        request.id,
        accessToken
      );

      if (responseRes.status !== 200) {
        return;
      }

      const responseData = responseRes.data;

      if (!responseData?.mail_id_origen) {
        alertError({
          customMessage:
            "Esta solicitud todavia no tiene ninguna respuesta recibida en su hilo de correo.",
        });
        return;
      }

      if ((request?.estado?.descripcion || "") === "Enviado") {
        await updateObraSupplierRequestStatus(
          obraId,
          request.id,
          { accion: "RESPUESTA_RECIBIDA" },
          accessToken
        );
      }

      setSupplierResponseEditor({
        requestId: request.id,
        supplierName: responseData.proveedor_nombre || request.proveedor_nombre || "",
        fecha_respuesta: responseData.fecha_respuesta,
        mail_id_origen: responseData.mail_id_origen || null,
        observaciones: responseData.observaciones || "",
        referencia_oferta_proveedor: responseData.referencia_oferta_proveedor || "",
        precio_total: parseDecimal(responseData.precio_total),
        isAnalysed: !!responseData.id,
        lineas: (responseData.lineas || []).map((line, index) => ({
          key: line.id || `${line.obra_producto_id || "line"}-${index}`,
          id: line.id || null,
          capitulo_id: line.capitulo_id || null,
          partida_id: line.partida_id || null,
          obra_producto_id: line.obra_producto_id || null,
          plantilla_producto_original_id: line.plantilla_producto_original_id,
          es_material_extra: !!line.es_material_extra,
          referencia: line.referencia || "",
          descripcion: line.descripcion || "Material",
          unidad: line.unidad || "",
          cantidad_solicitada: parseDecimal(line.cantidad_solicitada),
          precio_unitario: parseDecimal(line.precio_unitario),
          precio_global: parseDecimal(line.precio_global),
          referencia_proveedor: line.referencia_proveedor || "",
          cantidad_disponible_inmediata:
            line.cantidad_disponible_inmediata == null
              ? null
              : parseDecimal(line.cantidad_disponible_inmediata),
          fecha_disponibilidad: line.fecha_disponibilidad || null,
          no_disponible: !!line.no_disponible,
          observacion_disponibilidad: line.observacion_disponibilidad || "",
        })),
      });

      try {
        await handleLoadSupplierResponseSourceMail(responseData.mail_id_origen);
      } catch {
        setSupplierResponseSourceMail(null);
      }

      await loadObraPageData();
      setOpenSupplierResponseDialog(true);
      // A saved response is already the worker's automatic valuation. Do not charge a second call.
      setAutoFillSupplierResponseOnOpen(!responseData?.id);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar la respuesta del proveedor.",
      });
    }
  }, [accessToken, handleLoadSupplierResponseSourceMail, loadObraPageData, obraId]);

  const handleSaveSupplierResponse = useCallback(async () => {
    if (!supplierResponseEditor.requestId) {
      return;
    }

    setSavingSupplierResponse(true);

    try {
      await updateObraSupplierRequestResponse(
        obraId,
        supplierResponseEditor.requestId,
        {
          observaciones: supplierResponseEditor.observaciones || null,
          referencia_oferta_proveedor: supplierResponseEditor.referencia_oferta_proveedor || null,
          lineas: (supplierResponseEditor.lineas || []).map((line) => ({
            capitulo_id: line.capitulo_id,
            partida_id: line.partida_id,
            obra_producto_id: line.obra_producto_id,
            plantilla_producto_original_id: line.plantilla_producto_original_id,
            es_material_extra: line.es_material_extra,
            referencia_snapshot: line.referencia || null,
            descripcion_snapshot: line.descripcion || null,
            unidad_snapshot: line.unidad || null,
            cantidad_solicitada: parseDecimal(line.cantidad_solicitada),
            precio_unitario: parseDecimal(line.precio_unitario),
            precio_global: parseDecimal(line.precio_global),
            referencia_proveedor: line.referencia_proveedor || "",
            cantidad_disponible_inmediata:
              line.cantidad_disponible_inmediata == null
                ? parseDecimal(line.cantidad_solicitada)
                : parseDecimal(line.cantidad_disponible_inmediata),
            fecha_disponibilidad: line.fecha_disponibilidad || null,
            no_disponible: !!line.no_disponible,
            observacion_disponibilidad: line.observacion_disponibilidad || "",
          })),
        },
        accessToken
      );

      await loadObraPageData();
      alertSuccess({
        customMessage: "Respuesta del proveedor guardada con exito.",
      });
      setOpenSupplierResponseDialog(false);
      setAutoFillSupplierResponseOnOpen(false);
      setOpenSupplierResponseSourceMailDialog(false);
      setSupplierResponseSourceMail(null);
      setDownloadingSupplierResponseAttachmentKey(null);
      setSupplierResponseEditor(getEmptySupplierResponseEditor());
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido guardar la respuesta del proveedor.",
      });
    } finally {
      setSavingSupplierResponse(false);
    }
  }, [accessToken, loadObraPageData, obraId, supplierResponseEditor]);

  const handleLoadSupplierResponseSourceMail = useCallback(
    async (mailId) => {
      if (!mailId) {
        setSupplierResponseSourceMail(null);
        return null;
      }

      const res = await getMailboxMessage(mailId, accessToken);
      if (res.status === 200) {
        setSupplierResponseSourceMail(res.data || null);
        return res.data || null;
      }

      return null;
    },
    [accessToken]
  );

  const handleOpenSupplierResponseSourceMail = useCallback(async () => {
    const mailId = supplierResponseEditor.mail_id_origen;
    if (!mailId) {
      return;
    }

    try {
      const mail =
        supplierResponseSourceMail?.id === mailId
          ? supplierResponseSourceMail
          : await handleLoadSupplierResponseSourceMail(mailId);

      if (!mail) {
        alertError({
          customMessage: "No se ha podido obtener el detalle del último mail del proveedor.",
        });
        return;
      }

      setOpenSupplierResponseSourceMailDialog(true);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido obtener el detalle del último mail del proveedor.",
      });
    }
  }, [
    handleLoadSupplierResponseSourceMail,
    supplierResponseEditor.mail_id_origen,
    supplierResponseSourceMail,
  ]);

  const handleDownloadSupplierResponseAttachment = useCallback(
    (mailId, attachment) => {
      const downloadKey = `${mailId}-${attachment.index}`;
      setDownloadingSupplierResponseAttachmentKey(downloadKey);

      downloadMailboxAttachment(mailId, attachment.index, accessToken)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: res.headers["content-type"] || attachment.content_type,
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = attachment.file_name || `adjunto-${attachment.index + 1}`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "No se ha podido descargar el adjunto.",
          });
        })
        .finally(() => {
          setDownloadingSupplierResponseAttachmentKey(null);
        });
    },
    [accessToken]
  );

  const handleAutoFillSupplierResponse = useCallback(async () => {
    if (!supplierResponseEditor.requestId) {
      return;
    }

    setAutoFillingSupplierResponse(true);

    try {
      const responseRes = await autoFillObraSupplierRequestResponse(
        obraId,
        supplierResponseEditor.requestId,
        accessToken
      );

      if (responseRes.status !== 200) {
        return;
      }

      const responseData = responseRes.data;

      setSupplierResponseEditor((current) => ({
        ...current,
        fecha_respuesta: responseData.fecha_respuesta,
        observaciones: responseData.observaciones || current.observaciones || "",
        referencia_oferta_proveedor:
          responseData.referencia_oferta_proveedor || current.referencia_oferta_proveedor || "",
        precio_total: parseDecimal(responseData.precio_total),
        isAnalysed: true,
        lineas: (responseData.lineas || []).map((line, index) => ({
          key: line.id || `${line.obra_producto_id || "line"}-${index}`,
          id: line.id || null,
          capitulo_id: line.capitulo_id || null,
          partida_id: line.partida_id || null,
          obra_producto_id: line.obra_producto_id || null,
          plantilla_producto_original_id: line.plantilla_producto_original_id,
          es_material_extra: !!line.es_material_extra,
          referencia: line.referencia || "",
          descripcion: line.descripcion || "Material",
          unidad: line.unidad || "",
            cantidad_solicitada: parseDecimal(line.cantidad_solicitada),
            precio_unitario: parseDecimal(line.precio_unitario),
            precio_global: parseDecimal(line.precio_global),
            referencia_proveedor: line.referencia_proveedor || null,
            cantidad_disponible_inmediata: line.no_disponible
              ? 0
              : parseDecimal(line.cantidad_disponible_inmediata),
            fecha_disponibilidad: line.no_disponible
              ? null
              : line.fecha_disponibilidad || null,
            no_disponible: !!line.no_disponible,
            observacion_disponibilidad: line.observacion_disponibilidad || null,
          })),
      }));

      alertSuccess({
        customMessage: "La IA ha rellenado la valoración. Revisa los datos antes de guardar.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido completar automáticamente la valoración del proveedor.",
      });
    } finally {
      setAutoFillingSupplierResponse(false);
    }
  }, [accessToken, obraId, supplierResponseEditor.requestId]);

  useEffect(() => {
    if (
      !autoFillSupplierResponseOnOpen
      || !openSupplierResponseDialog
      || !supplierResponseEditor.requestId
      || autoFillingSupplierResponse
    ) {
      return;
    }

    setAutoFillSupplierResponseOnOpen(false);
    handleAutoFillSupplierResponse();
  }, [
    autoFillSupplierResponseOnOpen,
    autoFillingSupplierResponse,
    handleAutoFillSupplierResponse,
    openSupplierResponseDialog,
    supplierResponseEditor.requestId,
  ]);

  const materialRequestColumns = useMemo(
    () => [
      {
        dataField: "codigo",
        text: "Código",
        sort: true,
        formatter: (cell) => cell || "-",
      },
      {
        dataField: "fecha_solicitud",
        text: "Fecha",
        sort: true,
        formatter: (cell) => formatDate(cell),
      },
      {
        dataField: "user_solicita_nombre",
        text: "Usuario",
        sort: true,
      },
      {
        dataField: "descripcion",
        text: "Descripción",
        sort: true,
        formatter: (cell) => cell || "-",
      },
      {
        dataField: "estado",
        text: "Estado",
        sort: true,
        formatter: (cell) => cell?.descripcion || "",
      },
      {
        dataField: "materiales_en_solicitudes_oferta",
        text: "Valorando",
        formatter: (cell, row) =>
          `${Math.trunc(parseDecimal(cell || 0))}/${Math.trunc(
            parseDecimal(row?.materiales_totales || 0)
          )}`,
      },
      {
        dataField: "materiales_recibidos",
        text: "Recibidos",
        formatter: (cell, row) =>
          `${Math.trunc(parseDecimal(cell || 0))}/${Math.trunc(
            parseDecimal(row?.materiales_totales || 0)
          )}`,
      },
      {
        dataField: "id",
        text: "",
        formatter: (cell, row) => (
          <div className="d-flex justify-content-end align-items-center" style={{ gap: "0.1rem" }}>
            <ActionIconButton
              title="Editar solicitud"
              onClick={() => handleOpenMaterialRequestDialog(row.id)}
              disabled={!row.permite_acciones}
            >
              <EditIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Aprobar solicitud"
              onClick={() => handleChangeMaterialRequestStatus(row.id, "APROBAR")}
              disabled={!row.permite_acciones}
              color="#2E7D32"
            >
              <CheckIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Rechazar solicitud"
              onClick={() => handleChangeMaterialRequestStatus(row.id, "RECHAZAR")}
              disabled={!row.permite_acciones}
              color="#C62828"
            >
              <CloseIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Eliminar solicitud"
              onClick={() => handleDeleteMaterialRequest(row)}
              color="#C62828"
            >
              <DeleteOutlineIcon fontSize="small" />
            </ActionIconButton>
          </div>
        ),
      },
    ],
    [
      handleChangeMaterialRequestStatus,
      handleDeleteMaterialRequest,
      handleOpenMaterialRequestDialog,
    ]
  );

  const purchaseOrderColumns = useMemo(
    () => [
      {
        dataField: "fecha",
        text: "Fecha",
        sort: true,
        formatter: (cell) => formatDate(cell),
      },
      {
        dataField: "codigo",
        text: "Código",
        sort: true,
        formatter: (cell) => cell || "-",
      },
      {
        dataField: "proveedor",
        text: "Proveedor",
        sort: true,
        formatter: (cell) => cell || "-",
      },
      {
        dataField: "materiales_solicitados",
        text: "Materiales recibidos / solicitados",
        formatter: (cell, row) =>
          `${Math.trunc(parseDecimal(row?.materiales_recibidos || 0))} / ${Math.trunc(
            parseDecimal(cell || 0)
          )}`,
      },
    ],
    []
  );

  const handleOpenPurchaseOrderReceipt = async (order) => {
    try {
      const response = await getObraPurchaseOrderReceiptEditor(obraId, order.id, accessToken);
      setPurchaseOrderReceipt({
        order: response.data,
        operario_id: assignedOperarios[0]?.operario_id || "",
        albaran_proveedor: "",
        lineas: (response.data.lineas || []).map((line) => ({ ...line, cantidad_actual: 0 })),
      });
    } catch (error) { alertError({ error, customMessage: "No se ha podido abrir la recepción del pedido." }); }
  };

  const handleAddSupplierToRequestGroup = async () => {
    if (!supplierRequestGroupToExtend || !supplierToAdd) return;

    setAddingSupplierToRequest(true);
    try {
      await addSupplierToObraSupplierRequestGroup(
        obraId,
        supplierRequestGroupToExtend.id,
        supplierToAdd.id,
        accessToken
      );
      await loadObraPageData();
      alertSuccess({
        customMessage: "Proveedor añadido. Ya puedes revisar y enviar su solicitud de presupuesto.",
      });
      setOpenAddSupplierDialog(false);
      setSupplierRequestGroupToExtend(null);
      setSupplierToAdd(null);
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido añadir el proveedor a la solicitud." });
    } finally {
      setAddingSupplierToRequest(false);
    }
  };

  const handleOpenPurchaseOrderEditor = async (order) => {
    try {
      const response = await getObraPurchaseOrder(obraId, order.id, accessToken);
      setPurchaseOrderEditor({ ...response.data, fecha_entrega_prevista: formatDateForInput(response.data?.fecha_entrega_prevista) });
      setPurchaseOrderEmailBodyDraft(response.data?.cuerpo_email || "");
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido abrir el pedido." });
    }
  };

  const getPurchaseOrderSavePayload = (order) => ({
    proveedor_email: order.proveedor_email || null,
    referencia_oferta_proveedor: order.referencia_oferta_proveedor || null,
    direccion_entrega: order.direccion_entrega || null,
    contacto_entrega: order.contacto_entrega || null,
    telefono_entrega: order.telefono_entrega || null,
    horario_entrega: order.horario_entrega || null,
    fecha_entrega_prevista: order.fecha_entrega_prevista || null,
    observaciones: order.observaciones || null,
    condiciones: order.condiciones || null,
    asunto_email: order.asunto_email || null,
    cuerpo_email: order.cuerpo_email || null,
    ignorar_modo_prueba: !!order.ignorar_modo_prueba,
  });

  const handleSavePurchaseOrder = async ({ showSuccess = true } = {}) => {
    if (!purchaseOrderEditor) return false;
    setSavingPurchaseOrder(true);
    try {
      const orderToSave = { ...purchaseOrderEditor, cuerpo_email: purchaseOrderEmailBodyDraft };
      await updateObraPurchaseOrder(obraId, purchaseOrderEditor.id, getPurchaseOrderSavePayload(orderToSave), accessToken);
      await loadObraPageData();
      if (showSuccess) alertSuccess({ customMessage: "Pedido guardado. Puedes previsualizarlo o enviarlo cuando esté listo." });
      return true;
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido guardar el pedido." });
      return false;
    } finally {
      setSavingPurchaseOrder(false);
    }
  };

  const handlePreviewPurchaseOrderPdf = async () => {
    if (!purchaseOrderEditor) return;
    try {
      const saved = await handleSavePurchaseOrder({ showSuccess: false });
      if (!saved) return;
      const response = await previewObraPurchaseOrderPdf(obraId, purchaseOrderEditor.id, accessToken);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      window.open(url, "_blank", "noopener,noreferrer");
      window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido generar el PDF del pedido." });
    }
  };

  const handleSendPurchaseOrder = async () => {
    if (!purchaseOrderEditor) return;
    const realSend = !!purchaseOrderEditor.ignorar_modo_prueba;
    const message = realSend
      ? `Se enviará el pedido ${purchaseOrderEditor.codigo} al proveedor real: ${purchaseOrderEditor.proveedor_email}. ¿Confirmas el envío?`
      : `El pedido ${purchaseOrderEditor.codigo} se enviará respetando el modo de prueba global. ¿Confirmas el envío?`;
    setConfirmationDialog({
      title: realSend ? "Enviar pedido al proveedor real" : "Enviar pedido en modo prueba",
      message,
      confirmLabel: "Enviar pedido",
      onConfirm: async () => {
        setSavingPurchaseOrderSend(true);
        try {
          const saved = await handleSavePurchaseOrder({ showSuccess: false });
          if (!saved) return;
          const result = await sendObraPurchaseOrder(obraId, purchaseOrderEditor.id, accessToken);
          await loadObraPageData();
          setPurchaseOrderEditor(null);
          alertSuccess({ customMessage: result.data?.message || "Pedido enviado correctamente." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido enviar el pedido." });
        } finally {
          setSavingPurchaseOrderSend(false);
        }
      },
    });
  };

  const handleOpenDeliveryDataDialog = () => {
    setDeliveryDataDraft({
      direccion_entrega: obraHeader.direccion_entrega || "",
      contacto_entrega: obraHeader.contacto_entrega || "",
      telefono_entrega: obraHeader.telefono_entrega || "",
      horario_entrega: obraHeader.horario_entrega || "",
      observaciones_pedido: obraHeader.observaciones_pedido || "",
      condiciones_pedido: obraHeader.condiciones_pedido || "",
    });
    setOpenDeliveryDataDialog(true);
  };

  const handleSaveDeliveryData = async () => {
    if (!deliveryDataDraft) return;
    setSavingDeliveryData(true);
    try {
      await updateObraHeader(obraId, { ...obraHeader, ...deliveryDataDraft }, accessToken);
      await loadObraPageData();
      setOpenDeliveryDataDialog(false);
      alertSuccess({ customMessage: "Datos base de entrega actualizados." });
    } catch (error) {
      alertError({ error, customMessage: "No se han podido guardar los datos de entrega." });
    } finally {
      setSavingDeliveryData(false);
    }
  };

  // React 16 libera los eventos sintéticos tras el onChange. Guardamos el valor
  // antes de programar la actualización funcional del estado.
  const handleDeliveryDataChange = (field) => (event) => {
    const value = event.target.value;
    setDeliveryDataDraft((current) => ({ ...current, [field]: value }));
  };

  const handlePurchaseOrderChange = (field, isCheckbox = false) => (event) => {
    const value = isCheckbox ? event.target.checked : event.target.value;
    setPurchaseOrderEditor((current) => ({ ...current, [field]: value }));
  };

  const applyPurchaseOrderDeliveryDate = (date) => {
    setPurchaseOrderEditor((current) => ({ ...current, fecha_entrega_prevista: formatDateForInput(date) }));
  };

  const handlePurchaseOrderEmailBodyInput = (event) => {
    const value = event.currentTarget.innerHTML;
    setPurchaseOrderEmailBodyDraft(value);
  };

  const applyPurchaseOrderEmailFormat = (command, value = null) => {
    const editor = purchaseOrderEmailBodyEditorRef.current;
    if (!editor || purchaseOrderEditor?.fecha_envio) return;
    editor.focus();
    document.execCommand(command, false, value);
    setPurchaseOrderEmailBodyDraft(editor.innerHTML);
  };

  const addPurchaseOrderEmailLink = () => {
    setEmailLinkDialog({ open: true, url: "https://" });
  };

  const handleConfirmDialog = async () => {
    const action = confirmationDialog?.onConfirm;
    setConfirmationDialog(null);
    if (action) await action();
  };

  const handleConfirmEmailLink = () => {
    const url = emailLinkDialog.url.trim();
    if (url) applyPurchaseOrderEmailFormat("createLink", url);
    setEmailLinkDialog({ open: false, url: "https://" });
  };

  const handleSavePurchaseOrderReceipt = async () => {
    const receipt = purchaseOrderReceipt;
    if (!receipt?.operario_id || !receipt.lineas.some((line) => Number(line.cantidad_actual || 0) > 0)) {
      alertError({ customMessage: "Selecciona el operario e indica al menos un material recibido." });
      return;
    }
    setSavingPurchaseOrderReceipt(true);
    try {
      await postObraPurchaseOrderReceipt(obraId, receipt.order.id, { operario_id: receipt.operario_id, albaran_proveedor: receipt.albaran_proveedor, lineas: receipt.lineas.map((line) => ({ pedido_obra_linea_id: line.id, cantidad_recibida: Number(line.cantidad_actual || 0) })) }, accessToken);
      await loadObraPageData();
      setPurchaseOrderReceipt(null);
      alertSuccess({ customMessage: "Recepción guardada y materiales añadidos al almacén de la obra." });
    } catch (error) { alertError({ error, customMessage: "No se ha podido guardar la recepción." }); }
    finally { setSavingPurchaseOrderReceipt(false); }
  };

  const handleOpenPurchaseOrderQuantityDialog = (line) => {
    setPurchaseOrderQuantityDraft({
      id: line.id,
      descripcion: line.descripcion_snapshot,
      cantidad: Math.max(0, Number(line.cantidad || 0) - Number(line.cantidad_recibida || 0)),
    });
  };

  const handleOpenDeliveryNoteDialog = () => {
    setDeliveryNoteFile(null);
    setDeliveryNoteDragActive(false);
    setOpenDeliveryNoteDialog(true);
  };

  const handleSelectDeliveryNoteFile = (file) => {
    if (!file) return;
    const extension = file.name.split(".").pop()?.toLowerCase();
    if (!["pdf", "xlsx", "xls"].includes(extension)) {
      alertError({ customMessage: "Selecciona un archivo PDF o Excel." });
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      alertError({ customMessage: "El albarán no puede superar 15 MB." });
      return;
    }
    setDeliveryNoteFile(file);
  };

  const handleAnalyzeDeliveryNote = async () => {
    if (!deliveryNoteFile || !purchaseOrderReceipt?.order?.id) return;
    setAnalyzingDeliveryNote(true);
    try {
      const response = await analyzeObraPurchaseOrderDeliveryNote(
        obraId,
        purchaseOrderReceipt.order.id,
        deliveryNoteFile,
        accessToken
      );
      const receivedByLineId = new Map(
        (response.data?.lineas || []).map((line) => [line.pedido_obra_linea_id, Number(line.cantidad_recibida || 0)])
      );
      setPurchaseOrderReceipt((current) => ({
        ...current,
        albaran_proveedor: response.data?.albaran_proveedor || current.albaran_proveedor,
        materiales_no_identificados: response.data?.materiales_no_identificados || [],
        lineas: current.lineas.map((line) => receivedByLineId.has(line.id)
          ? { ...line, cantidad_actual: receivedByLineId.get(line.id) }
          : line),
      }));
      setOpenDeliveryNoteDialog(false);
      setDeliveryNoteFile(null);
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido analizar el albarán." });
    } finally {
      setAnalyzingDeliveryNote(false);
    }
  };

  const handleConfirmPurchaseOrderQuantity = () => {
    if (!purchaseOrderQuantityDraft) return;
    setPurchaseOrderReceipt((current) => ({
      ...current,
      lineas: current.lineas.map((line) =>
        line.id === purchaseOrderQuantityDraft.id
          ? { ...line, cantidad_actual: Math.max(0, Number(purchaseOrderQuantityDraft.cantidad || 0)) }
          : line
      ),
    }));
    setPurchaseOrderQuantityDraft(null);
  };

  const handleDeletePurchaseOrderReceipt = async (receipt) => {
    setConfirmationDialog({
      title: "Eliminar recepción",
      message: "¿Quieres eliminar esta recepción y sus entradas de almacén?",
      confirmLabel: "Eliminar recepción",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraPurchaseOrderReceipt(obraId, receipt.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Recepción eliminada correctamente." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar la recepción." });
        }
      },
    });
  };

  const renderPurchaseOrderCard = (order) => {
    const expanded = expandedPurchaseOrders.includes(order.id);
    return <div key={order.id} className="mt-3" style={{ border: "1px solid #176B4A", borderRadius: "8px", overflow: "hidden", background: "#FFFFFF" }}>
      <div className="d-flex align-items-center justify-content-between px-3 py-3" style={{ backgroundColor: "#176B4A", gap: "1rem" }}>
        <button type="button" className="border-0 text-left p-0" style={{ background: "transparent", color: "#FFFFFF" }} onClick={() => setExpandedPurchaseOrders((current) => current.includes(order.id) ? current.filter((item) => item !== order.id) : [...current, order.id])}>
          <div className="d-flex flex-wrap align-items-center" style={{ gap: "0.75rem" }}>
            {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            <span className="font-weight-bolder">{order.proveedor || "Proveedor"}</span>
            <span style={{ opacity: 0.88 }}>Pedido {order.codigo}</span>
            <span style={{ opacity: 0.78 }}>{formatDate(order.fecha)}</span>
          </div>
          <div className="mt-1" style={{ fontSize: "0.85rem", opacity: 0.82 }}>Estado: {order.estado?.toLowerCase() || "registrado"}</div>
        </button>
        <div className="d-flex" style={{ gap: "0.5rem" }}>
          <Button variant="outlined" onClick={() => handleOpenPurchaseOrderEditor(order)} style={{ color: "#FFFFFF", borderColor: "rgba(255,255,255,0.75)" }}>{order.estado === "Enviado" ? "Ver pedido" : "Revisar y enviar"}</Button>
          <Button
            variant="contained"
            disabled={!order.fecha_envio}
            title={!order.fecha_envio ? "El pedido debe enviarse antes de registrar una recepción." : "Registrar recepción"}
            onClick={() => handleOpenPurchaseOrderReceipt(order)}
            style={{ backgroundColor: "#FFC107", color: "#1A1A1A", fontWeight: 700 }}
          >
            Recibir material
          </Button>
        </div>
      </div>
      <div className="px-3 py-2 text-muted" style={{ background: "#FFFFFF" }}>
        {order.materiales_recibidos}/{order.materiales_solicitados} materiales recibidos
      </div>
      {expanded && <div className="border-top px-3 py-2" style={{ background: "#F9FAFC" }}>{(order.recepciones || []).length ? order.recepciones.map((receipt) => <div key={receipt.id} className="d-flex justify-content-between align-items-center py-2"><span>{formatDate(receipt.fecha_recepcion)} · {receipt.albaran_proveedor || "Sin albarán"} · {receipt.operario} · {receipt.materiales_recibidos} materiales</span><ActionIconButton title="Eliminar recepción" color="#C62828" onClick={() => handleDeletePurchaseOrderReceipt(receipt)}><DeleteOutlineIcon fontSize="small" /></ActionIconButton></div>) : <span className="text-muted">Sin recepciones registradas.</span>}</div>}
    </div>;
  };

  const renderSupplierPurchaseOrderSummary = (order) => (
    <div
      key={order.id}
      className="d-flex align-items-center justify-content-between mt-2 px-3 py-2"
      style={{ border: "1px solid #DFE5F1", borderRadius: "6px", background: "#FFFFFF", gap: "1rem" }}
    >
      <div>
        <span className="font-weight-bolder text-dark">{order.codigo}</span>
        <span className="text-muted ml-2">{formatDate(order.fecha)} · Pedido {order.estado?.toLowerCase() || "registrado"}</span>
      </div>
      <Button
        size="small"
        variant="contained"
        disabled={!order.fecha_envio}
        title={!order.fecha_envio ? "El pedido debe enviarse antes de registrar una recepción." : "Registrar recepción"}
        onClick={() => handleOpenPurchaseOrderReceipt(order)}
        style={{ backgroundColor: "#FFC107", color: "#1A1A1A", fontWeight: 700, whiteSpace: "nowrap" }}
      >
        Recibir material
      </Button>
    </div>
  );

  const handleOpenMaterialAssignmentDialog = async () => {
    try {
      const response = await getObraMaterialAssignmentEditor(obraId, accessToken);
      setMaterialAssignmentEditor({
        operario_id: assignedOperarios.find((item) => !item.bloqueado)?.operario_id || "",
        fecha_instalacion: formatDateForInput(new Date()),
        capitulos: response.data?.capitulos || [],
      });
      setExpandedMaterialAssignmentChapters([]);
      setExpandedMaterialAssignmentPartidas([]);
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido abrir la asignación de materiales." });
    }
  };

  const handleOpenMaterialAssignmentQuantity = (partida, product) => {
    setMaterialAssignmentDraft({
      partida,
      producto: product,
      cantidad: Math.max(0, Number(product.cantidad_disponible || 0)),
    });
  };

  const handleConfirmMaterialAssignment = async () => {
    const draft = materialAssignmentDraft;
    if (!draft || Number(draft.cantidad || 0) <= 0) {
      setMaterialAssignmentDraft(null);
      return;
    }
    if (!materialAssignmentEditor?.operario_id) {
      alertError({ customMessage: "Selecciona el operario que asigna el material." });
      return;
    }
    setSavingMaterialAssignments(true);
    try {
      await postObraMaterialAssignments(obraId, {
        operario_id: materialAssignmentEditor.operario_id,
        fecha_instalacion: materialAssignmentEditor.fecha_instalacion,
        asignaciones: [{ producto_id: draft.producto.producto_id, cantidad: Number(draft.cantidad) }],
      }, accessToken);
      const response = await getObraMaterialAssignmentEditor(obraId, accessToken);
      setMaterialAssignmentEditor((current) => ({ ...current, capitulos: response.data?.capitulos || [] }));
      setMaterialAssignmentDraft(null);
      await loadObraPageData();
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido asignar el material." });
    } finally {
      setSavingMaterialAssignments(false);
    }
  };

  const handleOpenOperariosDialog = () => {
    setSelectedOperariosToAssign([]);
    setOpenOperariosDialog(true);
  };

  const handleAssignOperarios = async () => {
    if (!selectedOperariosToAssign.length) {
      return;
    }

    setSavingOperarios(true);

    try {
      await Promise.all(
        selectedOperariosToAssign.map((operario) =>
          assignOperarioToObra(obraId, operario.id, accessToken)
        )
      );

      await loadObraPageData();

      alertSuccess({
        customMessage: "Operarios asignados con éxito.",
      });
      setOpenOperariosDialog(false);
      setSelectedOperariosToAssign([]);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se han podido asignar los operarios a la obra.",
      });
    } finally {
      setSavingOperarios(false);
    }
  };

  const handleRemoveOperario = async (operarioId) => {
    try {
      await removeOperarioFromObra(obraId, operarioId, accessToken);
      await loadObraPageData();
      alertSuccess({
        customMessage: "Operario quitado de la obra con éxito.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido quitar el operario de la obra.",
      });
    }
  };

  const handleSetOperarioBlocked = async (operario, blocked) => {
    try {
      if (blocked) {
        await blockOperarioInObra(obraId, operario.operario_id, accessToken);
      } else {
        await unblockOperarioInObra(obraId, operario.operario_id, accessToken);
      }

      await loadObraPageData();
      alertSuccess({
        customMessage: blocked
          ? "Operario bloqueado correctamente."
          : "Operario desbloqueado correctamente.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido actualizar el bloqueo del operario.",
      });
    }
  };

  const handleUpdateProductCompletion = useCallback(async (chapterId, partidaId, product) => {
    const nextCompleted = !product.completado;

    try {
      await updateObraProductCompletion(
        obraId,
        chapterId,
        partidaId,
        product.producto_id,
        nextCompleted,
        accessToken
      );
      await loadObraPageData();
      alertSuccess({
        customMessage: nextCompleted
          ? "Tarea marcada como completada. El avance de obra se ha actualizado."
          : "Tarea reabierta. El avance de obra se ha actualizado.",
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido actualizar el estado de la tarea.",
      });
    }
  }, [accessToken, loadObraPageData, obraId]);

  const handleDeleteTaskReport = (report) => {
    setConfirmationDialog({
      title: "Eliminar parte de tareas",
      message: "Se eliminarán todas sus líneas e imputaciones. El avance de la obra volverá automáticamente al estado anterior.",
      confirmLabel: "Eliminar parte",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraTaskReport(obraId, report.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Parte de tareas eliminado correctamente." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar el parte de tareas." });
        }
      },
    });
  };

  const handleDeleteTaskReportLine = (report, line) => {
    setConfirmationDialog({
      title: "Eliminar tarea reportada",
      message: "Se eliminará esta línea y sus imputaciones. Si era la última, también se eliminará el parte completo.",
      confirmLabel: "Eliminar tarea",
      danger: true,
      onConfirm: async () => {
        try {
          await deleteObraTaskReportLine(obraId, report.id, line.id, accessToken);
          await loadObraPageData();
          alertSuccess({ customMessage: "Tarea reportada eliminada correctamente." });
        } catch (error) {
          alertError({ error, customMessage: "No se ha podido eliminar la tarea reportada." });
        }
      },
    });
  };

  const loadOperarioJornada = async (operario, fecha) => {
    try {
      const response = await getObraOperarioHours(
        obraId,
        operario.operario_id,
        accessToken
      );
      const jornada = (response.data || []).find(
        (row) => formatDateForInput(row.fecha) === fecha
      );

      setOperarioHoursEntry((current) => {
        if (
          current.operario?.operario_id !== operario.operario_id ||
          current.fecha !== fecha
        ) {
          return current;
        }

        return {
          ...current,
          horas: Number(jornada?.horas || 0),
          minutos: Number(jornada?.minutos || 0),
          observaciones: jornada?.observaciones || "",
        };
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar el parte diario del operario.",
      });
    }
  };

  const handleOpenOperarioHoursDialog = (operario) => {
    const fecha = formatDateForInput(new Date());
    setOperarioHoursEntry({
      operario,
      fecha,
      horas: 0,
      minutos: 0,
      observaciones: "",
    });
    setOpenOperarioHoursDialog(true);
    loadOperarioJornada(operario, fecha);
  };

  const handleOpenTaskReportDialog = async (operario) => {
    try {
      const response = await getObraOperarioTaskReportEditor(
        obraId,
        operario.operario_id,
        accessToken
      );
      setTaskReportEditor({
        operario,
        fecha: formatDateForInput(new Date()),
        capitulos: response.data?.capitulos || [],
        lineas: [],
        ai_resultado: null,
        ai_historial: [],
      });
      setExpandedTaskReportChapters([]);
      setExpandedTaskReportPartidas([]);
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido abrir el parte de tareas." });
    }
  };

  const stopTaskVoiceRecorder = (discard = false) => {
    const recorder = taskVoiceRecorderRef.current;
    taskVoiceRecorderRef.current = null;
    if (!recorder) return;
    if (discard) recorder.onstop = null;
    if (recorder.state !== "inactive") recorder.stop();
    if (recorder.stream) recorder.stream.getTracks().forEach((track) => track.stop());
  };

  const startTaskVoiceRecording = async () => {
    stopTaskVoiceRecorder();
    taskVoiceDialogActiveRef.current = true;
    setTaskVoiceDialog((current) => ({
      phase: "requesting",
      recordings: current?.recordings || [],
      error: null,
    }));

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
      setTaskVoiceDialog((current) => current ? { ...current, phase: "ready", error: "Este navegador no permite grabar audio." } : current);
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (!taskVoiceDialogActiveRef.current) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }
      const chunks = [];
      const recorder = new MediaRecorder(stream);
      recorder.ondataavailable = (event) => {
        if (event.data?.size) chunks.push(event.data);
      };
      recorder.onstop = () => {
        stream.getTracks().forEach((track) => track.stop());
        taskVoiceRecorderRef.current = null;
        if (!taskVoiceDialogActiveRef.current) return;
        const recording = chunks.length ? new Blob(chunks, { type: recorder.mimeType || "audio/webm" }) : null;
        setTaskVoiceDialog((current) => current ? {
          ...current,
          phase: "ready",
          recordings: recording ? [...(current.recordings || []), recording] : current.recordings || [],
          error: recording ? null : "No se ha podido guardar la grabación.",
        } : current);
      };
      taskVoiceRecorderRef.current = recorder;
      recorder.start();
      setTaskVoiceDialog((current) => current ? { ...current, phase: "listening" } : current);
    } catch {
      if (!taskVoiceDialogActiveRef.current) return;
      setTaskVoiceDialog((current) => current ? { ...current, phase: "ready", error: "No se ha podido acceder al micrófono." } : current);
    }
  };

  const finishTaskVoiceRecording = () => {
    const recorder = taskVoiceRecorderRef.current;
    if (recorder?.state !== "inactive") {
      setTaskVoiceDialog((current) => current ? { ...current, phase: "finishing" } : current);
      recorder.stop();
    }
  };

  const closeTaskVoiceDialog = () => {
    taskVoiceDialogActiveRef.current = false;
    stopTaskVoiceRecorder(true);
    setTaskVoiceDialog(null);
  };

  const handleSendTaskVoiceToAssistant = async () => {
    const recordings = taskVoiceDialog?.recordings || [];
    if (!recordings.length || !taskReportEditor?.operario) {
      alertError({ customMessage: "Graba al menos un audio antes de enviarlo." });
      return;
    }

    setSendingTaskVoice(true);
    try {
      const previousHistory = taskReportEditor.ai_historial || [];
      const response = await postObraOperarioTaskAssistantAudio(
        obraId,
        taskReportEditor.operario.operario_id,
        recordings,
        {
          conclusion_anterior: taskReportEditor.ai_resultado?.resumen || null,
          historial: previousHistory,
        },
        accessToken
      );
      const result = response.data || {};
      const products = (taskReportEditor.capitulos || []).flatMap((chapter) =>
        (chapter.partidas || []).flatMap((partida) =>
          (partida.productos || []).map((product) => ({ chapter, partida, product }))
        )
      );
      const aiLines = (result.tareas_propuestas || []).map((proposal) => {
        const match = products.find((item) => item.product.producto_id === proposal.producto_id);
        if (!match) return null;
        return {
          capitulo_id: proposal.capitulo_id,
          partida_id: proposal.partida_id,
          producto_id: proposal.producto_id,
          descripcion: match.product.descripcion,
          cantidad: Number(proposal.cantidad),
          companero_ids: (proposal.operario_ids || []).filter((workerId) => workerId !== taskReportEditor.operario.operario_id),
          ai: true,
        };
      }).filter(Boolean);

      setTaskReportEditor((current) => ({
        ...current,
        lineas: [
          ...(current.lineas || []).filter((line) => !aiLines.some((aiLine) => aiLine.producto_id === line.producto_id)),
          ...aiLines,
        ],
        ai_resultado: result,
        ai_historial: [
          ...previousHistory,
          { rol: "usuario", contenido: result.transcripcion || "Grabación de voz enviada." },
          { rol: "asistente", contenido: result.resumen || "Propuesta de parte generada." },
        ].slice(-20),
      }));
      closeTaskVoiceDialog();
      alertSuccess({ customMessage: "El agente ha analizado el relato y ha preparado la propuesta de parte." });
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido interpretar el relato con el agente de partes." });
    } finally {
      setSendingTaskVoice(false);
    }
  };

  const handleOpenTaskReportLine = (chapter, partida, product, completed) => {
    const selectedLine = (taskReportEditor?.lineas || []).find(
      (line) => line.producto_id === product.producto_id
    );
    setTaskReportLineDraft({
      chapter,
      partida,
      product,
      isMaterialGroup: Boolean(product.es_agrupacion_material),
      cantidad: selectedLine?.cantidad ?? (completed ? Number(product.cantidad_disponible_para_reportar || 0) : ""),
      companero_ids: selectedLine?.companero_ids || (selectedLine?.companero_id ? [selectedLine.companero_id] : []),
    });
  };

  const handleAddTaskReportLine = () => {
    const draft = taskReportLineDraft;
    const quantity = Number(String(draft?.cantidad || "").replace(",", "."));
    const available = Number(draft?.product?.cantidad_disponible_para_reportar || 0);
    if (!draft || !Number.isFinite(quantity) || quantity <= 0 || quantity > available) {
      alertError({ customMessage: "Indica una cantidad realizada entre cero y el material recibido disponible." });
      return;
    }
    setTaskReportEditor((current) => ({
      ...current,
      lineas: [
        ...(current.lineas || []).filter((line) => line.producto_id !== draft.product.producto_id),
        {
          capitulo_id: draft.chapter.capitulo_id,
          partida_id: draft.partida.partida_id,
          producto_id: draft.product.producto_id,
          obra_agrupacion_material_id: draft.isMaterialGroup
            ? draft.product.obra_agrupacion_material_id
            : null,
          es_agrupacion_material: draft.isMaterialGroup,
          descripcion: draft.product.descripcion,
          cantidad: quantity,
          companero_ids: draft.companero_ids || [],
        },
      ],
    }));
    setTaskReportLineDraft(null);
  };

  const handleSaveTaskReport = async () => {
    if (!(taskReportEditor?.lineas || []).length) {
      alertError({ customMessage: "Añade al menos una tarea al parte antes de enviarlo." });
      return;
    }
    setSavingTaskReport(true);
    try {
      await postObraOperarioTaskReport(obraId, taskReportEditor.operario.operario_id, {
        fecha: taskReportEditor.fecha,
        lineas: taskReportEditor.lineas.map((line) => ({
          capitulo_id: line.capitulo_id,
          partida_id: line.partida_id,
          producto_id: line.producto_id,
          obra_agrupacion_material_id: line.obra_agrupacion_material_id || null,
          cantidad: Number(line.cantidad),
          companero_ids: line.companero_ids || [],
        })),
      }, accessToken);
      alertSuccess({ customMessage: "Parte de tareas enviado correctamente." });
      setTaskReportEditor(null);
      await loadObraPageData();
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido enviar el parte de tareas." });
    } finally {
      setSavingTaskReport(false);
    }
  };

  const handleOperarioHoursDateChange = (fecha) => {
    setOperarioHoursEntry((current) => ({
      ...current,
      fecha,
      horas: 0,
      minutos: 0,
      observaciones: "",
    }));

    if (operarioHoursEntry.operario && fecha) {
      loadOperarioJornada(operarioHoursEntry.operario, fecha);
    }
  };

  const handleOpenOperarioHoursHistory = async (operario) => {
    setOperarioHoursHistory({ operario, rows: [] });
    setExpandedOperarioTaskHourDates([]);
    setOpenOperarioHoursHistoryDialog(true);
    setLoadingOperarioHoursHistory(true);

    try {
      const response = await getObraOperarioTaskHours(
        obraId,
        operario.operario_id,
        accessToken
      );
      setOperarioHoursHistory({
        operario,
        rows: (response.data || []).map((row) => ({
          ...row,
          segundos: Number(row.segundos ?? row.segundos_teoricos ?? row.segundosTeoricos ?? 0),
          tareas: (row.tareas || []).map((tarea) => ({
            ...tarea,
            segundos: Number(tarea.segundos ?? tarea.segundos_teoricos ?? tarea.segundosTeoricos ?? 0),
          })),
        })),
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar el historial de horas imputadas a tareas.",
      });
      setOpenOperarioHoursHistoryDialog(false);
    } finally {
      setLoadingOperarioHoursHistory(false);
    }
  };

  const handleOpenOperarioRealHoursHistory = async (operario) => {
    setOperarioRealHoursHistory({ operario, rows: [] });
    setOpenOperarioRealHoursHistoryDialog(true);
    setLoadingOperarioRealHoursHistory(true);

    try {
      const response = await getObraOperarioHours(
        obraId,
        operario.operario_id,
        accessToken
      );
      setOperarioRealHoursHistory({
        operario,
        rows: (response.data || []).map((row) => ({
          ...row,
          segundos: Number(
            row.segundos_reales ??
              row.segundosReales ??
              (Number(row.horas || 0) * 3600 + Number(row.minutos || 0) * 60)
          ),
        })),
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido cargar el historial de horas reales.",
      });
      setOpenOperarioRealHoursHistoryDialog(false);
    } finally {
      setLoadingOperarioRealHoursHistory(false);
    }
  };

  const adjustOperarioHours = (minutes) => {
    setOperarioHoursEntry((current) => {
      const totalMinutes = Math.max(
        0,
        Number(current?.horas || 0) * 60 + Number(current?.minutos || 0) + minutes
      );

      return {
        ...current,
        horas: Math.floor(totalMinutes / 60),
        minutos: totalMinutes % 60,
      };
    });
  };

  const setOperarioHoursUnit = (unit, value) => {
    const numericValue = Math.max(
      0,
      Number.parseInt(String(value).replace(/\D/g, ""), 10) || 0
    );

    setOperarioHoursEntry((current) => {
      if (!current) return current;

      const totalMinutes =
        (unit === "hours" ? numericValue : Number(current?.horas || 0)) * 60 +
        (unit === "minutes" ? numericValue : Number(current?.minutos || 0));

      return {
        ...current,
        horas: Math.floor(totalMinutes / 60),
        minutos: totalMinutes % 60,
      };
    });
  };

  const handleSaveOperarioHours = async () => {
    const totalMinutes =
      Number(operarioHoursEntry.horas || 0) * 60 +
      Number(operarioHoursEntry.minutos || 0);

    if (totalMinutes <= 0) {
      alertError({ customMessage: "Indica una duración mayor que cero." });
      return;
    }

    setSavingOperarioHours(true);

    try {
      await postObraOperarioHours(
        obraId,
        operarioHoursEntry.operario.operario_id,
        {
          fecha: operarioHoursEntry.fecha,
          horas: Number(operarioHoursEntry.horas || 0),
          minutos: Number(operarioHoursEntry.minutos || 0),
          observaciones: operarioHoursEntry.observaciones?.trim() || null,
        },
        accessToken
      );
      await loadObraPageData();
      setOpenOperarioHoursDialog(false);
      alertSuccess({ customMessage: "Parte diario guardado con éxito." });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se han podido imputar las horas del operario.",
      });
    } finally {
      setSavingOperarioHours(false);
    }
  };

  const handleOpenHitosDialog = () => {
    setHitosDraft({
      fecha_inicio: formatDateForInput(obraHeader.fecha_inicio),
      fecha_fin: formatDateForInput(obraHeader.fecha_fin),
      hitos: getSortedHitos(obraHeader.hitos || []).map((hito) => ({
        id: hito.id,
        completado_tiempo: Number(hito.completado_tiempo || 0),
        fecha_prevista: formatDateForInput(hito.fecha_prevista),
      })),
    });
    setOpenHitosDialog(true);
  };

  const handleOpenHitoEditor = (mode, item = null) => {
    setHitoEditorMode(mode);

    if (mode.type === "start") {
      setHitoEditorDraft({
        id: null,
        completado_tiempo: "",
        fecha_prevista: hitosDraft.fecha_inicio,
      });
    } else if (mode.type === "end") {
      setHitoEditorDraft({
        id: null,
        completado_tiempo: "",
        fecha_prevista: hitosDraft.fecha_fin,
      });
    } else if (item) {
      setHitoEditorDraft({
        id: item.id || null,
        completado_tiempo: item.completado_tiempo,
        fecha_prevista: item.fecha_prevista,
      });
    } else {
      setHitoEditorDraft(getDefaultHitoDraft());
    }

    setOpenHitoEditorDialog(true);
  };

  const validateLocalHitoEditor = () => {
    if (!hitoEditorDraft.fecha_prevista) {
      return "La fecha es obligatoria.";
    }

    const selectedDate = new Date(hitoEditorDraft.fecha_prevista);
    const startDate = new Date(hitosDraft.fecha_inicio);
    const endDate = new Date(hitosDraft.fecha_fin);

    if (hitoEditorMode.type === "start") {
      if (selectedDate >= endDate) {
        return "La fecha de inicio debe ser inferior a la fecha de fin.";
      }

      const invalidHito = hitosDraft.hitos.find(
        (hito) => new Date(hito.fecha_prevista) < selectedDate
      );
      if (invalidHito) {
        return "La fecha de inicio no puede ser posterior a la fecha de ningún hito.";
      }
    }

    if (hitoEditorMode.type === "end") {
      if (selectedDate <= startDate) {
        return "La fecha de fin debe ser superior a la fecha de inicio.";
      }

      const invalidHito = hitosDraft.hitos.find(
        (hito) => new Date(hito.fecha_prevista) > selectedDate
      );
      if (invalidHito) {
        return "La fecha de fin no puede ser anterior a la fecha de ningún hito.";
      }
    }

    if (hitoEditorMode.type === "hito") {
      if (selectedDate < startDate || selectedDate > endDate) {
        return "La fecha del hito debe estar comprendida entre la fecha de inicio y la fecha de fin.";
      }

      const percentValue = Number(hitoEditorDraft.completado_tiempo);
      if (
        Number.isNaN(percentValue) ||
        percentValue < 0 ||
        percentValue > 100
      ) {
        return "El porcentaje del hito debe estar entre 0 y 100.";
      }
    }

    return null;
  };

  const handleSaveHitoEditor = () => {
    const validationError = validateLocalHitoEditor();

    if (validationError) {
      alertError({
        customMessage: validationError,
      });
      return;
    }

    if (hitoEditorMode.type === "start") {
      setHitosDraft((current) => ({
        ...current,
        fecha_inicio: hitoEditorDraft.fecha_prevista,
      }));
    } else if (hitoEditorMode.type === "end") {
      setHitosDraft((current) => ({
        ...current,
        fecha_fin: hitoEditorDraft.fecha_prevista,
      }));
    } else {
      const mappedHito = {
        id: hitoEditorDraft.id || null,
        tempId: hitoEditorDraft.id ? undefined : `temp-${Date.now()}`,
        completado_tiempo: Number(hitoEditorDraft.completado_tiempo),
        fecha_prevista: hitoEditorDraft.fecha_prevista,
      };

      setHitosDraft((current) => {
        const nextHitos = hitoEditorMode.id
          ? current.hitos.map((hito) =>
              (hito.id || hito.tempId) === hitoEditorMode.id ? mappedHito : hito
            )
          : [...current.hitos, mappedHito];

        return {
          ...current,
          hitos: getSortedHitos(nextHitos),
        };
      });
    }

    setOpenHitoEditorDialog(false);
    setHitoEditorDraft(getDefaultHitoDraft());
  };

  const handleDeleteDraftHito = (hitoId) => {
    setHitosDraft((current) => ({
      ...current,
      hitos: current.hitos.filter((hito) => (hito.id || hito.tempId) !== hitoId),
    }));
  };

  const toggleChapter = (chapterId) => {
    setExpandedChapters((current) =>
      current.includes(chapterId)
        ? current.filter((item) => item !== chapterId)
        : [...current, chapterId]
    );
  };

  const togglePartida = (partidaId) => {
    setExpandedPartidas((current) =>
      current.includes(partidaId)
        ? current.filter((item) => item !== partidaId)
        : [...current, partidaId]
    );
  };

  const validateFullHitosDraft = () => {
    if (!hitosDraft.fecha_inicio || !hitosDraft.fecha_fin) {
      return "La fecha de inicio y la fecha de fin son obligatorias.";
    }

    const startDate = new Date(hitosDraft.fecha_inicio);
    const endDate = new Date(hitosDraft.fecha_fin);

    if (startDate >= endDate) {
      return "La fecha de inicio debe ser inferior a la fecha de fin.";
    }

    const sortedHitos = getSortedHitos(hitosDraft.hitos);

    for (const hito of sortedHitos) {
      const hitoDate = new Date(hito.fecha_prevista);
      if (hitoDate < startDate || hitoDate > endDate) {
        return "Todas las fechas de los hitos deben estar comprendidas entre la fecha de inicio y la fecha de fin.";
      }
    }

    for (let index = 1; index < sortedHitos.length; index += 1) {
      if (
        Number(sortedHitos[index].completado_tiempo) <
        Number(sortedHitos[index - 1].completado_tiempo)
      ) {
        return "No se puede informar un porcentaje de avance inferior en una fecha posterior a otro hito con un porcentaje mayor.";
      }
    }

    return null;
  };

  const handleSaveHitos = async () => {
    const validationError = validateFullHitosDraft();

    if (validationError) {
      alertError({
        customMessage: validationError,
      });
      return;
    }

    setSavingHitos(true);

    try {
      await updateObraHitos(
        obraId,
        {
          fecha_inicio: new Date(hitosDraft.fecha_inicio).toISOString(),
          fecha_fin: new Date(hitosDraft.fecha_fin).toISOString(),
          hitos: getSortedHitos(hitosDraft.hitos).map((hito) => ({
            id: hito.id || null,
            completado_tiempo: Number(hito.completado_tiempo),
            fecha_prevista: new Date(hito.fecha_prevista).toISOString(),
          })),
        },
        accessToken
      );

      await loadObraPageData();
      alertSuccess({
        customMessage: "Hitos guardados con éxito.",
      });
      setOpenHitosDialog(false);
    } catch (error) {
      alertError({
        error,
        customMessage: "No se han podido guardar los hitos de la obra.",
      });
    } finally {
      setSavingHitos(false);
    }
  };

  if (isLoadingData) return <ContentSkeleton />;

  const operariosConHoras = assignedOperarios.map((operario) => ({
    ...operario,
    horasInvertidas: Number(operario.horas_invertidas || 0),
    horasTeoricasImputadas: Number(operario.horas_teoricas_imputadas || 0),
    costeReal: Number(operario.coste_real || 0),
  }));
  const totalHorasTeoricasImputadas = operariosConHoras.reduce(
    (total, operario) => total + operario.horasTeoricasImputadas,
    0
  );
  const costeRealManoObra = Number(obraHeader.coste_mano_de_obra_real || 0);
  const pvpActualManoObra = Number(obraHeader.pvp_mano_de_obra_actual || 0);
  const porcentajeBeneficioManoObra = pvpActualManoObra > 0
    ? ((pvpActualManoObra - costeRealManoObra) / pvpActualManoObra) * 100
    : 0;
  const beneficioManoObraPositivo = porcentajeBeneficioManoObra >= 0;
  const porcentajeBeneficioTexto = `${beneficioManoObraPositivo ? "+" : ""}${parsePercent(porcentajeBeneficioManoObra)}%`;
  const costeRealMateriales = Number(obraHeader.coste_materiales_real || 0);
  const costePrevistoMateriales = Number(obraHeader.coste_materiales_previsto_actual || 0);
  const porcentajeMargenMateriales = costePrevistoMateriales > 0
    ? ((costePrevistoMateriales - costeRealMateriales) / costePrevistoMateriales) * 100
    : costeRealMateriales > 0 ? -100 : 0;
  const margenMaterialesPositivo = porcentajeMargenMateriales >= 0;
  const porcentajeMargenMaterialesTexto = `${margenMaterialesPositivo ? "+" : ""}${parsePercent(porcentajeMargenMateriales)}%`;
  const operarioHoursValues = [
    {
      label: "Horas",
      value: Number(operarioHoursEntry.horas || 0),
      increment: 60,
      unit: "hours",
    },
    {
      label: "Minutos",
      value: Number(operarioHoursEntry.minutos || 0),
      increment: 1,
      unit: "minutes",
    },
  ];
  const taskReportHistoryRows = taskReportHistoryDialog
    ? taskReports
        .map((report) => ({
          ...report,
          lineas: (report.lineas || []).filter((line) =>
            taskReportHistoryDialog.scope === "partida"
              ? String(line.partida_id) === String(taskReportHistoryDialog.partidaId)
              : String(line.producto_id) === String(taskReportHistoryDialog.productId)
          ),
        }))
        .filter((report) => report.lineas.length > 0)
    : [];

  return (
    <>
      <Card>
        <CardHeader title="Obra" sticky={false}>
          <CardHeaderToolbar className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
            <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
              <span className="text-muted font-weight-bold text-uppercase" style={{ fontSize: "0.72rem" }}>
                Estado
              </span>
              <span className="font-weight-bolder text-dark">
                {selectedObraStatus?.descripcion || "-"}
              </span>
            </div>
            <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
              <span className="text-muted font-weight-bold text-uppercase" style={{ fontSize: "0.72rem" }}>
                Situación
              </span>
              <PlanningStatusBadge value={selectedPlanningStatus?.descripcion} />
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-xl-7">
              <div ref={obraOverviewRef}>
              <div className="card card-custom mb-4">
                <div className="card-body py-4">
                  <div className="row">
                    <SummaryField
                      label="Código obra"
                      value={obraHeader.codigo_obra || ""}
                    />
                    <SummaryField label="Cliente" value={customer?.nombre || ""} />
                    <SummaryField
                      label="Localización"
                      value={obraHeader.localizacion || ""}
                    />
                    <SummaryField
                      label="Oferta origen / revisión"
                      value={`${obraHeader.oferta_num_oferta || ""}${
                        obraHeader.oferta_revision_num != null
                          ? ` / Rev. ${obraHeader.oferta_revision_num}`
                          : ""
                      }`}
                    />
                    <SummaryField
                      label="Referencia oferta"
                      value={obraHeader.oferta_referencia || ""}
                      className="col-md-8"
                    />
                    <SummaryField
                      label="Fecha inicio"
                      value={formatDate(obraHeader.fecha_inicio)}
                    />
                    <SummaryField
                      label="Fecha fin"
                      value={formatDate(obraHeader.fecha_fin)}
                    />
                    <div className="col-md-4 d-flex align-items-center pt-4">
                      <button
                        type="button"
                        className="btn btn-outline-primary d-flex align-items-center justify-content-center mr-2"
                        style={{ gap: "0.5rem", whiteSpace: "nowrap" }}
                        onClick={handleOpenDeliveryDataDialog}
                      >
                        Entrega
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center justify-content-center"
                        style={{ gap: "0.5rem", whiteSpace: "nowrap" }}
                        onClick={handleOpenHitosDialog}
                      >
                        <EventIcon fontSize="small" />
                        Hitos
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card card-custom mb-4">
                <div className="card-body py-4">
                  <div className="row">
                    <InfoBadge
                      label={
                        <>
                          <span style={{ color: beneficioManoObraPositivo ? "#63738C" : "#E34A4A" }}>
                            {parseMoney(costeRealManoObra)} €
                          </span>
                          {` / ${parseMoney(pvpActualManoObra)} €`}
                        </>
                      }
                      value="Mano de obra"
                      icon={BuildIcon}
                      accentColor="#3311CC"
                      rightContent={
                        <div className="text-right text-nowrap">
                          <div className="font-weight-bolder text-dark" style={{ fontSize: "0.8rem" }}>
                            {parseMoney(obraHeader.coste_mano_de_obra)} €
                          </div>
                          <div
                            className="font-weight-bolder"
                            style={{
                              color: beneficioManoObraPositivo ? "#18A957" : "#E34A4A",
                              fontSize: "18px",
                              lineHeight: 1.1,
                            }}
                          >
                            {porcentajeBeneficioTexto}
                          </div>
                        </div>
                      }
                    />
                    <InfoBadge
                      label="Coste subcontrata"
                      value={`${parseMoney(obraHeader.coste_subcontrata)} €`}
                      icon={BusinessIcon}
                      accentColor="#1587E8"
                    />
                    <InfoBadge
                      label={
                        <>
                          <span style={{ color: margenMaterialesPositivo ? "#63738C" : "#E34A4A" }}>
                            {parseMoney(costeRealMateriales)} €
                          </span>
                          {` / ${parseMoney(costePrevistoMateriales)} €`}
                        </>
                      }
                      value="Materiales"
                      icon={CategoryIcon}
                      accentColor="#18A9C0"
                      rightContent={
                        <div className="text-right text-nowrap">
                          <div className="font-weight-bolder text-dark" style={{ fontSize: "0.8rem" }}>
                            {parseMoney(obraHeader.coste_materiales)} €
                          </div>
                          <div
                            className="font-weight-bolder"
                            style={{
                              color: margenMaterialesPositivo ? "#00A651" : "#E34A4A",
                              fontSize: "18px",
                            }}
                          >
                            {porcentajeMargenMaterialesTexto}
                          </div>
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="card card-custom">
                <div className="card-body py-4">
                  <div
                    className="d-flex flex-nowrap justify-content-between py-5"
                    style={{ gap: "0.25rem", overflowX: "auto" }}
                  >
                    <ProgressCircle
                      label="Progreso principal"
                      value={obraHeader.porcentaje_completado}
                      accentColor="#3311CC"
                      prominent
                    />
                    <ProgressCircle
                      label="Importe"
                      value={obraHeader.completado_importe}
                      accentColor="#20C997"
                      detail={`${parseMoney(obraProgressTotals.importeInvertido)} € / ${parseMoney(obraProgressTotals.importeTotal)} €`}
                    />
                    <ProgressCircle
                      label="Tiempo"
                      value={obraHeader.completado_tiempo}
                      accentColor="#2F80ED"
                      detail={`${formatInstallationTime(obraProgressTotals.tiempoParaAvance)} / ${formatInstallationTime(obraProgressTotals.tiempoTotal)}`}
                      secondaryDetail={`Reales: ${formatInstallationTime(obraProgressTotals.tiempoReal)}`}
                    />
                    <ProgressCircle
                      label="Tareas"
                      value={obraHeader.completado_tareas}
                      accentColor="#F2A93B"
                      detail={`${Math.trunc(obraProgressTotals.tareasCompletadas)} / ${Math.trunc(obraProgressTotals.tareasTotales)}`}
                    />
                    <ProgressCircle
                      label="Materiales"
                      value={obraHeader.completado_material}
                      accentColor="#18A9C0"
                      detail={`${parsePercent(obraProgressTotals.materialesAsignados)} / ${parsePercent(obraProgressTotals.materialesTotales)}`}
                    />
                  </div>
                </div>
              </div>
              </div>
            </div>
            <div className="col-xl-5 d-flex">
              <div
                className="card card-custom d-flex flex-column w-100"
                style={{ height: obraOverviewHeight ? `${obraOverviewHeight}px` : "auto" }}
              >
                <div className="card-header border-0 pt-6">
                  <div className="card-title">
                    <h3 className="card-label">Operarios</h3>
                  </div>
                  <div className="card-toolbar">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={handleOpenOperariosDialog}
                    >
                      Asignar operarios
                    </button>
                  </div>
                </div>
                <div
                  className="card-body pt-2 pb-6 flex-grow-1"
                  style={{ minHeight: 0, overflowY: "auto" }}
                >
                  <div className="d-flex flex-column" style={{ gap: "0.75rem" }}>
                    {operariosConHoras.length ? (
                      operariosConHoras.map((operario) => {
                        const porcentajeHoras = totalHorasTeoricasImputadas
                          ? (operario.horasTeoricasImputadas / totalHorasTeoricasImputadas) * 100
                          : 0;
                        const isExternal = operario.esExterno;
                        const externalAccentColor = "#A8B0BA";

                        return (
                          <div
                            key={operario.operario_id}
                            className="d-flex align-items-center"
                            style={{
                              gap: "0.85rem",
                              padding: "0.85rem",
                              borderRadius: "0.5rem",
                              backgroundColor: isExternal ? "#F7F8FA" : "#F4FAFF",
                              border: `1px solid ${isExternal ? "#E1E4E8" : "#D6E6F4"}`,
                            }}
                          >
                            <OperarioHoursCircle
                              value={porcentajeHoras}
                              accentColor={isExternal ? externalAccentColor : undefined}
                            />
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                              <div className="font-weight-bolder text-dark text-truncate">
                                {operario.nombreCompleto}
                              </div>
                              <div
                                className="text-muted text-truncate mb-2"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {operario.categoria || "Sin categoría"}
                                {operario.esExterno && operario.proveedorNombre
                                  ? ` · ${operario.proveedorNombre}`
                                  : ""}
                              </div>
                              <div className="d-flex align-items-center font-weight-bold" style={{ color: isExternal ? "#6C757D" : "#1587E8", fontSize: "0.86rem" }}>
                                <span>
                                  {parseMoney(operario.horasInvertidas)} h{" "}
                                  <span className="font-weight-normal text-muted">reales</span>
                                </span>
                                <span className="font-weight-normal text-muted ml-2">
                                  · {parseMoney(operario.costeHora)} €/h · {parseMoney(operario.costeReal)} €
                                </span>
                                {operario.horasInvertidas > 0 && (
                                  <Tooltip title="Ver horas reales reportadas">
                                    <button
                                      type="button"
                                      aria-label={`Ver horas reales reportadas de ${operario.nombreCompleto}`}
                                      onClick={() => handleOpenOperarioRealHoursHistory(operario)}
                                      className="border-0 bg-transparent p-0 ml-2 d-flex align-items-center"
                                      style={{ color: isExternal ? "#6C757D" : "#1587E8" }}
                                    >
                                      <EventIcon fontSize="small" />
                                    </button>
                                  </Tooltip>
                                )}
                                {operario.horasTeoricasImputadas > 0 && (
                                  <Tooltip title="Ver horas imputadas a tareas">
                                    <button
                                      type="button"
                                      aria-label={`Ver horas imputadas a tareas de ${operario.nombreCompleto}`}
                                      onClick={() => handleOpenOperarioHoursHistory(operario)}
                                      className="border-0 bg-transparent p-0 ml-2 d-flex align-items-center"
                                      style={{ color: isExternal ? "#6C757D" : "#1587E8" }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </button>
                                  </Tooltip>
                                )}
                              </div>
                            </div>
                            <div className="d-flex flex-column" style={{ gap: "0.4rem" }}>
                              <div className="d-flex" style={{ gap: "0.4rem" }}>
                                <button
                                  type="button"
                                  className="btn btn-light-primary btn-sm"
                                  disabled={operario.bloqueado}
                                  onClick={() => handleOpenTaskReportDialog(operario)}
                                >
                                  <BuildIcon fontSize="small" className="mr-1" />
                                  Tareas
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-light-primary btn-sm"
                                  disabled={operario.bloqueado}
                                  onClick={() => handleOpenOperarioHoursDialog(operario)}
                                >
                                  <ScheduleIcon fontSize="small" className="mr-1" />
                                  Horas
                                </button>
                              </div>
                              <button
                                type="button"
                                className={`btn btn-sm ${operario.bloqueado ? "btn-light-primary" : operario.horasInvertidas > 0 ? "btn-light-warning" : "btn-light-danger"}`}
                                onClick={() => {
                                  if (operario.bloqueado) {
                                    handleSetOperarioBlocked(operario, false);
                                  } else if (operario.horasInvertidas > 0) {
                                    handleSetOperarioBlocked(operario, true);
                                  } else {
                                    handleRemoveOperario(operario.operario_id);
                                  }
                                }}
                              >
                                {operario.bloqueado
                                  ? "Desbloquear"
                                  : operario.horasInvertidas > 0
                                    ? "Bloquear"
                                    : "Eliminar"}
                              </button>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center py-5" style={{ color: "#63738C" }}>
                        Sin operarios asignados
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      <Card className="mt-6">
        <CardHeader title="Gestión de obra" />
        <CardBody>
          <div
            className="d-flex flex-wrap mb-6"
            role="tablist"
            style={{ borderBottom: "1px solid #E4E6EF", gap: "0.25rem" }}
          >
            <TabButton
              active={selectedTab === "detalle"}
              label="Detalle"
              onClick={() => setSelectedTab("detalle")}
            />
            <TabButton
              active={selectedTab === "materiales"}
              label="Materiales"
              onClick={() => setSelectedTab("materiales")}
            />
            <TabButton
              active={selectedTab === "tareas"}
              label="Tareas"
              onClick={() => setSelectedTab("tareas")}
            />
            <div className="ml-auto d-flex align-items-center">
              <button
                type="button"
                className="btn btn-sm font-weight-bolder"
                onClick={handleOpenMaterialAssignmentDialog}
                style={{ backgroundColor: "#FFC107", color: "#1F1F1F" }}
              >
                Recepción de materiales
              </button>
            </div>
          </div>

        </CardBody>
      </Card>

          {selectedTab === "detalle" && (
            <Card className="mt-6">
              <CardBody>
                <div>
              {detailChapters.length ? (
                detailChapters.map((chapter) => {
                  const isChapterExpanded = expandedChapters.includes(
                    chapter.capitulo_id
                  );

                  return (
                    <div
                      key={chapter.capitulo_id}
                      className="mb-5"
                      style={{
                        border: "1px solid #E4E6EF",
                        borderRadius: 0,
                        overflow: "hidden",
                      }}
                    >
                      <button
                        type="button"
                        className="w-100 text-left px-5 py-4 border-0"
                        onClick={() => toggleChapter(chapter.capitulo_id)}
                        style={{
                          backgroundColor: DETAIL_SECTION_BLUE,
                          color: "#FFFFFF",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="font-weight-bolder text-white text-uppercase">
                            Capítulo {chapter.ordinal}.{" "}
                            {chapter.titulo_efectivo || chapter.titulo || chapter.partida_categoria?.descripcion || "Capítulo"}
                          </div>
                          <div className="d-flex align-items-center text-white">
                            {isChapterExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </div>
                        </div>
                        <div className="d-flex flex-wrap align-items-start mt-4" style={{ gap: "1.5rem" }}>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">PVP total</DetailLabel>
                            <div>{parseMoney(chapter.total_precio)} €</div>
                          </div>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">PVP invertido</DetailLabel>
                            <div>{parseMoney(chapter.pvp_invertido)} €</div>
                          </div>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">Tiempo total</DetailLabel>
                            <div>{formatInstallationTime(chapter.tiempo_total)}</div>
                          </div>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">Tiempo invertido</DetailLabel>
                            <div>{formatInstallationTime(chapter.tiempo_invertido)}</div>
                          </div>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">Avance importe</DetailLabel>
                            <ProgressMetric
                              label=""
                              value={chapter.avance_importe}
                              width="220px"
                              trackColor="rgba(228, 230, 239, 0.45)"
                              fillColor="#FFFFFF"
                              valueColor="#FFFFFF"
                            />
                          </div>
                          <div>
                            <DetailLabel color="rgba(255, 255, 255, 0.78)">Avance tiempo</DetailLabel>
                            <ProgressMetric
                              label=""
                              value={chapter.avance_tiempo}
                              width="220px"
                              trackColor="rgba(228, 230, 239, 0.45)"
                              fillColor="#FFFFFF"
                              valueColor="#FFFFFF"
                            />
                          </div>
                        </div>
                      </button>

                      {isChapterExpanded && (
                        <div className="px-5 pb-4" style={{ backgroundColor: "#F9FAFC" }}>
                          {(chapter.partidas || []).map((partida) => {
                            const isPartidaExpanded = expandedPartidas.includes(
                              partida.partida_id
                            );
                            const partidaType = getPartidaTypeInfo(
                              partida.def_tipo_impotacion_partida
                            );
                            const directProducts = (partida.productos || []).filter(
                              (producto) => !producto.agrupacion_material_id
                            );
                            const materialGroups = partida.agrupaciones_materiales || [];

                            return (
                              <div
                                key={partida.partida_id}
                                className="mt-4"
                                style={{
                                  border: "1px solid #E4E6EF",
                                  borderRadius: "0.42rem",
                                  overflow: "hidden",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <div
                                  className="w-100 text-left px-4 py-4 bg-white border-0"
                                  onClick={() => togglePartida(partida.partida_id)}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter" || event.key === " ") {
                                      event.preventDefault();
                                      togglePartida(partida.partida_id);
                                    }
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <div className="font-weight-bolder text-dark">
                                        {partida.ordinal}. {partida.descripcion || "Partida"}
                                      </div>
                                      <div className="text-muted mt-1">
                                        {partida.referencia || ""}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<VisibilityIcon />}
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          setTaskReportHistoryDialog({
                                            scope: "partida",
                                            partidaId: partida.partida_id,
                                            title: `${partida.ordinal}. ${partida.descripcion || "Partida"}`,
                                          });
                                        }}
                                      >
                                        Ver partes
                                      </Button>
                                      {isPartidaExpanded ? (
                                        <ExpandLessIcon />
                                      ) : (
                                        <ExpandMoreIcon />
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-flex flex-wrap mt-4" style={{ gap: "1.5rem" }}>
                                    <div>
                                      <DetailLabel>Tipo de partida</DetailLabel>
                                      <div
                                        style={{
                                          color: partidaType?.color || "#3F4254",
                                          fontWeight: 700,
                                        }}
                                      >
                                        {partidaType?.label || "-"}
                                      </div>
                                    </div>
                                    <div>
                                      <DetailLabel>PVP total</DetailLabel>
                                      <div>{parseMoney(partida.precio_total)} €</div>
                                    </div>
                                    <div>
                                      <DetailLabel>PVP invertido</DetailLabel>
                                      <div>{parseMoney(partida.pvp_invertido)} €</div>
                                    </div>
                                    <div>
                                      <DetailLabel>Tiempo total</DetailLabel>
                                      <div>
                                        {formatInstallationTime(
                                          partida.avance_tiempo_valor_total
                                        )}
                                      </div>
                                    </div>
                                    <div>
                                      <DetailLabel>Tiempo invertido</DetailLabel>
                                      <div>
                                        {formatInstallationTime(
                                          partida.tiempo_invertido_real
                                        )}
                                      </div>
                                    </div>
                                    <div>
                                      <DetailLabel>Avance importe</DetailLabel>
                                      <ProgressMetric
                                        label=""
                                        value={partida.avance_importe}
                                        width="220px"
                                        trackColor="#E4EAF7"
                                        fillColor="#2F80ED"
                                        valueColor="#2F80ED"
                                      />
                                    </div>
                                    <div>
                                      <DetailLabel>Avance tiempo</DetailLabel>
                                      <ProgressMetric
                                        label=""
                                        value={partida.avance_tiempo}
                                        width="220px"
                                        trackColor="#E4EAF7"
                                        fillColor="#2F80ED"
                                        valueColor="#2F80ED"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {isPartidaExpanded && (
                                  <div className="px-4 pb-4" style={{ backgroundColor: "#F9FAFC" }}>
                                    <div
                                      className="font-weight-bolder text-white text-uppercase mb-3 px-4 py-3"
                                      style={{
                                        backgroundColor: DETAIL_SECTION_BLUE,
                                        borderRadius: 0,
                                      }}
                                    >
                                      Descompuesto
                                    </div>

                                    {materialGroups.length || directProducts.length ? (
                                      <>
                                        {materialGroups.map((agrupacion) => {
                                          const groupImportProgress = getProgressFromTotals(
                                            agrupacion.pvp_completado,
                                            agrupacion.precio_total
                                          );

                                          return (
                                            <div
                                              key={agrupacion.id}
                                              className="mb-3 px-4 py-3"
                                              style={{
                                                border: "1px solid #9CC9F2",
                                                borderRadius: "0.42rem",
                                                backgroundColor: "#EEF7FF",
                                              }}
                                            >
                                              <div
                                                className="text-uppercase font-weight-bolder mb-1"
                                                style={{ color: "#1769AA", fontSize: "0.72rem" }}
                                              >
                                                Agrupación de materiales
                                              </div>
                                              <div className="font-weight-bolder text-dark">
                                                {agrupacion.descripcion || "Agrupación"}
                                              </div>
                                              {agrupacion.referencia && (
                                                <div className="text-muted mb-3">
                                                  {agrupacion.referencia}
                                                </div>
                                              )}
                                              <div
                                                className="d-flex flex-wrap align-items-start"
                                                style={{ gap: "1.5rem" }}
                                              >
                                                <div>
                                                  <DetailLabel>Unidades</DetailLabel>
                                                  <div>{parsePercent(agrupacion.unidades_total)}</div>
                                                </div>
                                                <div>
                                                  <DetailLabel>Total PVP</DetailLabel>
                                                  <div>{parseMoney(agrupacion.precio_total)} €</div>
                                                </div>
                                                <div>
                                                  <DetailLabel>Unidades completadas</DetailLabel>
                                                  <div>
                                                    {parsePercent(
                                                      agrupacion.unidades_completadas
                                                    )}
                                                  </div>
                                                </div>
                                                <div>
                                                  <DetailLabel>PVP completado</DetailLabel>
                                                  <div>
                                                    {parseMoney(agrupacion.pvp_completado)} €
                                                  </div>
                                                </div>
                                                <div>
                                                  <DetailLabel>Avance importe</DetailLabel>
                                                  <ProgressMetric
                                                    label=""
                                                    value={groupImportProgress}
                                                    width="220px"
                                                    trackColor="#D8E9F8"
                                                    fillColor="#1769AA"
                                                    valueColor="#1769AA"
                                                  />
                                                </div>
                                              </div>
                                              <div className="mt-3">
                                                <DetailLabel>Incluye</DetailLabel>
                                                {(agrupacion.productos || []).map((producto) => (
                                                  <div
                                                    key={producto.producto_id}
                                                    className="d-flex justify-content-between py-1"
                                                    style={{ borderTop: "1px solid #D8E9F8" }}
                                                  >
                                                    <span>
                                                      {producto.descripcion || "Producto"}
                                                      {producto.referencia
                                                        ? ` · ${producto.referencia}`
                                                        : ""}
                                                    </span>
                                                    <span className="font-weight-bolder">
                                                      {parsePercent(producto.unidades_total)}
                                                    </span>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          );
                                        })}

                                        {directProducts.length > 0 && materialGroups.length > 0 && (
                                          <div
                                            className="text-uppercase font-weight-bolder mt-4 mb-2"
                                            style={{ color: "#6C757D", fontSize: "0.72rem" }}
                                          >
                                            Materiales sin agrupación
                                          </div>
                                        )}

                                        {directProducts.map((producto) => {
                                        const productImportProgress =
                                          getProgressFromTotals(
                                            producto.pvp_completado,
                                            producto.precio_total
                                          );

                                        return (
                                        <div
                                          key={producto.producto_id}
                                          className="mb-3 px-4 py-3 bg-white"
                                          style={{
                                            border: "1px solid #E4E6EF",
                                            borderRadius: "0.42rem",
                                          }}
                                        >
                                          <div className="font-weight-bolder text-dark">
                                            {producto.descripcion || "Producto"}
                                          </div>
                                          <div className="text-muted mb-3">
                                            {producto.referencia || ""}
                                          </div>
                                          <div
                                            className="d-flex flex-wrap align-items-start"
                                            style={{ gap: "1.5rem" }}
                                          >
                                            <div>
                                              <DetailLabel>Unidades</DetailLabel>
                                              <div>{parsePercent(producto.unidades_total)}</div>
                                            </div>
                                            <div>
                                              <DetailLabel>Total PVP</DetailLabel>
                                              <div>{parseMoney(producto.precio_total)} €</div>
                                            </div>
                                            <div>
                                              <DetailLabel>Unidades completadas</DetailLabel>
                                              <div>
                                                {parsePercent(
                                                  producto.unidades_completadas
                                                )}
                                              </div>
                                            </div>
                                            <div>
                                              <DetailLabel>PVP completado</DetailLabel>
                                              <div>
                                                {parseMoney(producto.pvp_completado)} €
                                              </div>
                                            </div>
                                            <div>
                                              <DetailLabel>Avance importe</DetailLabel>
                                              <ProgressMetric
                                                label=""
                                                value={productImportProgress}
                                                width="220px"
                                                trackColor="#E4EAF7"
                                                fillColor="#2F80ED"
                                                valueColor="#2F80ED"
                                              />
                                            </div>
                                            <div className="d-flex flex-wrap align-items-end ml-auto" style={{ gap: "0.5rem", marginLeft: "auto" }}>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                color="primary"
                                                startIcon={<VisibilityIcon />}
                                                onClick={() => setTaskReportHistoryDialog({
                                                  scope: "producto",
                                                  productId: producto.producto_id,
                                                  title: producto.descripcion || "Producto",
                                                })}
                                              >
                                                Ver partes
                                              </Button>
                                              <Button
                                                size="small"
                                                color="primary"
                                                variant="contained"
                                                startIcon={<CheckIcon />}
                                                disabled={producto.completado}
                                                onClick={() => handleUpdateProductCompletion(
                                                    chapter.capitulo_id,
                                                    partida.partida_id,
                                                    producto
                                                  )}
                                              >
                                                Marcar completada
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                        );
                                        })}
                                      </>
                                    ) : (
                                      <div className="text-muted">
                                        No hay productos en el descompuesto.
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="text-muted">No hay detalle disponible para esta obra.</div>
              )}
                </div>
              </CardBody>
            </Card>
          )}

          {selectedTab === "materiales" && (
            <Card className="mt-6">
              <CardBody>
                <div>
              <div className="d-flex align-items-center justify-content-between mb-5">
                <div>
                  <div className="font-weight-bolder text-dark" style={{ fontSize: "1.15rem" }}>Solicitudes de material</div>
                  <div className="text-muted">Líneas de material pendientes de gestionar para la obra.</div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleOpenMaterialRequestDialog()}
                >
                  Nueva solicitud de material
                </button>
              </div>

              {materialRequests.length ? (
                <Table data={materialRequests} columns={materialRequestColumns} />
              ) : (
                <div className="text-muted">
                  No hay solicitudes de material registradas para esta obra.
                </div>
              )}
                </div>
              </CardBody>
            </Card>
          )}

          {selectedTab === "tareas" && (
            <Card className="mt-6">
              <CardBody>
                <div>
              <div className="mb-5">
                <div className="font-weight-bolder text-dark" style={{ fontSize: "1.15rem" }}>Partes de tareas</div>
                <div className="text-muted">Avances reportados por operarios o registrados desde administración.</div>
              </div>
              {taskReports.length ? taskReports.map((report) => {
                const chapters = (report.lineas || []).reduce((result, line) => {
                  const chapterKey = line.capitulo_id;
                  if (!result[chapterKey]) {
                    result[chapterKey] = {
                      key: chapterKey,
                      ordinal: line.capitulo_ordinal,
                      descripcion: line.capitulo_descripcion,
                      partidas: {},
                    };
                  }
                  if (!result[chapterKey].partidas[line.partida_id]) {
                    result[chapterKey].partidas[line.partida_id] = {
                      key: line.partida_id,
                      ordinal: line.partida_ordinal,
                      descripcion: line.partida_descripcion,
                      lineas: [],
                    };
                  }
                  result[chapterKey].partidas[line.partida_id].lineas.push(line);
                  return result;
                }, {});
                return <div key={report.id} className="mb-5" style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden", background: "#FFFFFF" }}>
                  <div className="d-flex flex-wrap justify-content-between align-items-center px-4 py-3" style={{ background: "#EEF4F0", borderBottom: "1px solid #CFE0D3", gap: "12px" }}>
                    <div>
                      <div className="font-weight-bolder text-dark">{report.responsable}</div>
                      <div className="text-muted mt-1" style={{ fontSize: "13px" }}>{report.responsable_tipo} · {formatDate(report.fecha)} · {report.origen === "ADMINISTRACION" ? "Registro administrativo" : "Parte de operario"}</div>
                    </div>
                    <Button size="small" color="secondary" variant="outlined" startIcon={<DeleteOutlineIcon />} onClick={() => handleDeleteTaskReport(report)} style={{ color: "#D92D20", borderColor: "#F2B8B5" }}>Eliminar parte</Button>
                  </div>
                  <div className="p-4">
                    {Object.values(chapters).sort((a, b) => Number(a.ordinal) - Number(b.ordinal)).map((chapter) => <div key={chapter.key} className="mb-4" style={{ border: "1px solid #E4EAF2", borderRadius: "6px", overflow: "hidden" }}>
                      <div className="px-3 py-2 font-weight-bolder" style={{ background: DETAIL_SECTION_BLUE, color: "#FFFFFF" }}>Capítulo {chapter.ordinal}. {chapter.descripcion}</div>
                      {Object.values(chapter.partidas).sort((a, b) => Number(a.ordinal) - Number(b.ordinal)).map((partida) => <div key={partida.key} style={{ borderTop: "1px solid #E4EAF2" }}>
                        <div className="px-3 py-2 font-weight-bolder text-dark" style={{ background: "#F7F9FC" }}>{partida.ordinal}. {partida.descripcion}</div>
                        {partida.lineas.map((line) => <div key={line.id} className="d-flex flex-wrap justify-content-between align-items-center px-3 py-3" style={{ borderTop: "1px solid #EEF1F5", gap: "18px" }}>
                          <div>
                            <div className="font-weight-bolder text-dark">{line.producto_descripcion}</div>
                            {line.producto_referencia && <div className="text-muted" style={{ fontSize: "13px" }}>{line.producto_referencia}</div>}
                            {(line.operarios || []).length > 0 && <div className="text-muted mt-1" style={{ fontSize: "13px" }}>{line.operarios.map((operario) => `${operario.nombre} (${formatInstallationTime(operario.segundos_teoricos)})`).join(" · ")}</div>}
                          </div>
                          <div className="d-flex align-items-center ml-auto" style={{ gap: "18px" }}>
                            <div className="text-right" style={{ color: "#187A42" }}>
                              <div className="text-uppercase font-weight-bolder" style={{ fontSize: "0.68rem", color: "#6C757D" }}>Realizado</div>
                              <div className="font-weight-bolder" style={{ fontSize: "1.1rem" }}>{parsePercent(line.cantidad)}</div>
                            </div>
                            <Tooltip title="Eliminar tarea reportada"><IconButton size="small" onClick={() => handleDeleteTaskReportLine(report, line)} style={{ color: "#D92D20" }}><DeleteOutlineIcon fontSize="small" /></IconButton></Tooltip>
                          </div>
                        </div>)}
                      </div>)}
                    </div>)}
                  </div>
                </div>;
              }) : <div className="text-muted">Todavía no se ha registrado ningún parte de tareas en esta obra.</div>}
                </div>
              </CardBody>
            </Card>
          )}

          {selectedTab === "materiales" && (
            <Card className="mt-6">
              <CardBody>
                <div>
              <div className="d-flex align-items-center justify-content-between mb-5">
                <div>
                  <div className="font-weight-bolder text-dark" style={{ fontSize: "1.15rem" }}>Ofertas y pedidos a proveedores</div>
                  <div className="text-muted">Solicitudes de presupuesto, respuestas de proveedores y pedidos asociados.</div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleOpenSupplierRequestDialog()}
                >
                  Nueva solicitud de oferta
                </button>
              </div>

              {supplierRequests.length ? (
                <div>
                  {supplierRequestGroups.map((group) => {
                    const expanded = expandedSupplierRequestGroups.includes(group.id);
                    const canEditGroup = group.requests.every(
                      (request) => (request?.estado?.descripcion || "") === "Generado"
                    );
                    const canSendGroup = canEditGroup && group.requests.length > 0;
                    const canSelectBudgetGroup =
                      group.requests.length > 0 &&
                      group.requests.some(
                        (request) => request?.listo_para_comparacion
                      );

                    return (
                      <div
                        key={group.id}
                        className="mb-4"
                        style={{
                          border: "1px solid #E4E6EF",
                          borderRadius: 0,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          className="d-flex justify-content-between align-items-center px-4 py-3"
                          style={{ backgroundColor: DETAIL_SECTION_BLUE, color: "#FFFFFF" }}
                          role="button"
                          tabIndex={0}
                          onClick={() => toggleSupplierRequestGroup(group.id)}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              toggleSupplierRequestGroup(group.id);
                            }
                          }}
                        >
                          <div className="text-white text-left">
                            <div className="font-weight-bolder">
                              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}{" "}
                              {group.codigo}
                            </div>
                            <div style={{ fontSize: "0.9rem", opacity: 0.9 }}>
                              Solicitud de presupuesto
                            </div>
                            {!!group.descripcion && group.descripcion !== "Solicitud de material" && (
                              <div style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                                {group.descripcion}
                              </div>
                            )}
                            <div style={{ fontSize: "0.9rem", opacity: 0.9 }}>
                              {formatDate(group.fecha_solicitud)}
                            </div>
                          </div>

                          <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={{ color: "#FFFFFF", border: "1px solid rgba(255, 255, 255, 0.75)", backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                handleOpenSupplierRequestGroupDialog(group);
                              }}
                              disabled={!canEditGroup}
                            >
                              Ver solicitud
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={{ color: "#FFFFFF", border: "1px solid rgba(255, 255, 255, 0.75)", backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                handleOpenSupplierRequestGroupMailDialog(group);
                              }}
                              disabled={!canSendGroup}
                            >
                              Enviar solicitudes
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={{ color: "#FFFFFF", border: "1px solid rgba(255, 255, 255, 0.75)", backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                setSupplierRequestGroupToExtend(group);
                                setSupplierToAdd(null);
                                setOpenAddSupplierDialog(true);
                              }}
                            >
                              Añadir proveedor
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={{ color: "#FFFFFF", border: "1px solid rgba(255, 255, 255, 0.75)", backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                if (!canSelectBudgetGroup) {
                                  return;
                                }
                                handleOpenSupplierBudgetSelectionDialog(group);
                              }}
                              disabled={!canSelectBudgetGroup || loadingSupplierBudgetSelection}
                            >
                              Generar pedidos
                            </button>
                            <ActionIconButton
                              title="Eliminar grupo"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleDeleteSupplierRequestGroup(group);
                              }}
                              color="#FFFFFF"
                            >
                              <DeleteOutlineIcon fontSize="small" />
                            </ActionIconButton>
                          </div>
                        </div>

                        {expanded && (
                          <div style={{ backgroundColor: "#F9FAFC" }}>
                            {group.requests.map((request) => {
                              const status = request?.estado?.descripcion || "";
                              const isGenerated = status === "Generado";
                              const requestExpanded = expandedSupplierRequests.includes(request.id);
                              const statusStyle = getSupplierRequestStatusStyle(status, request);
                              const attentionStyle = request.requiere_atencion
                                ? {
                                    label: `${request.analizado_por_usuario ? "Analizado por usuario" : "Analizado por IA"} · requiere atención`,
                                    backgroundColor: "#FFF5D9",
                                    color: "#9A6700",
                                  }
                                : statusStyle;
                              const mailHistory = supplierRequestMailHistory[request.id] || {
                                loading: false,
                                messages: [],
                              };
                              const pendingReviewCount = Math.max(
                                request.respuestas_pendientes_revision || 0,
                                (mailHistory.messages || []).filter(
                                  (mail) => mail.tipo_mail === "Recibido" && !mail.revisado
                                ).length
                              );
                              const canEvaluate =
                                (status === "Enviado" ||
                                  status === "Respuesta recibida" ||
                                  status === "Precios asignados") &&
                                !!request?.mail_thread_id;
                              const hasSavedSupplierResponse =
                                status === "Precios asignados" || status === "Aprobado";
                              const relatedOrders = purchaseOrders.filter(
                                (order) =>
                                  String(order.solicitud_presupuesto_grupo_id || "") === String(group.id) &&
                                  String(order.proveedor_id || "") === String(request.proveedor_id || "")
                              );
                              return (
                                <div
                                  key={request.id}
                                  className="border-top"
                                  style={{ backgroundColor: "#FFFFFF" }}
                                >
                                  <div
                                    className="d-flex justify-content-between align-items-center px-4 py-3"
                                    style={{ gap: "1rem", cursor: "pointer" }}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => toggleSupplierRequest(request.id)}
                                    onKeyDown={(event) => {
                                      if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        toggleSupplierRequest(request.id);
                                      }
                                    }}
                                  >
                                    <div className="text-left">
                                      <div className="d-flex align-items-center font-weight-bolder text-dark">
                                        {requestExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                        <span className="ml-1">{request.proveedor_nombre || "Proveedor"}</span>
                                        {pendingReviewCount > 0 && (
                                          <Tooltip
                                            title={`${pendingReviewCount} respuesta${pendingReviewCount === 1 ? "" : "s"} pendiente${pendingReviewCount === 1 ? "" : "s"} de revisar`}
                                          >
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center ml-2"
                                              style={{ color: "#D92D20" }}
                                              aria-label={`${pendingReviewCount} respuestas pendientes de revisar`}
                                            >
                                              <WarningIcon fontSize="small" />
                                              <span className="ml-1" style={{ fontSize: "0.8rem" }}>
                                                {pendingReviewCount}
                                              </span>
                                            </span>
                                          </Tooltip>
                                        )}
                                      </div>
                                      <div className="text-muted ml-4">
                                        {request.codigo || "-"} · {formatDate(request.fecha_solicitud)}
                                      </div>
                                    </div>

                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: "1.5rem" }}>
                                      <div>
                                        <div className="font-weight-bolder text-dark">Estado</div>
                                        <span
                                          className="d-inline-block px-2 py-1 font-weight-bolder"
                                          style={{
                                            borderRadius: "999px",
                                            backgroundColor: attentionStyle.backgroundColor,
                                            color: attentionStyle.color,
                                            fontSize: "0.8rem",
                                          }}
                                        >
                                          {attentionStyle.label}
                                        </span>
                                        {request.listo_para_comparacion && (
                                          <span
                                            className="d-inline-block px-2 py-1 ml-2 font-weight-bolder"
                                            style={{ borderRadius: "999px", backgroundColor: "#E5F8EC", color: "#187A42", fontSize: "0.8rem" }}
                                          >
                                            Oferta recibida
                                          </span>
                                        )}
                                      </div>
                                      <div style={{ minWidth: "140px" }}>
                                        <div className="font-weight-bolder text-dark">Valoración</div>
                                        <div className="text-muted">
                                          {status === "Precios asignados" ? `${parseMoney(request?.precio_total)} €` : "-"}
                                        </div>
                                      </div>
                                      <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            handleOpenSupplierRequestMailDialog(request);
                                          }}
                                          disabled={!isGenerated}
                                        >
                                          Enviar solicitud
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            handleEvaluateSupplierRequestResponses(request);
                                          }}
                                          disabled={!canEvaluate || hasSavedSupplierResponse}
                                        >
                                          Valorar
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            handleEvaluateSupplierRequestResponses(request);
                                          }}
                                          disabled={!canEvaluate || !hasSavedSupplierResponse}
                                        >
                                          Ver valoración
                                        </Button>
                                        <ActionIconButton title="Eliminar solicitud" onClick={(event) => {
                                          event.stopPropagation();
                                          handleDeleteSupplierRequest(request);
                                        }} color="#FF4D6D">
                                          <DeleteOutlineIcon fontSize="small" />
                                        </ActionIconButton>
                                      </div>
                                    </div>
                                  </div>

                                  {requestExpanded && (
                                    <div className="border-top px-4 py-3" style={{ backgroundColor: "#F9FAFC" }}>
                                      <div className="font-weight-bolder text-dark">Histórico de actividad</div>
                                      {!request.mail_thread_id ? (
                                        <div className="text-muted mt-2">
                                          La solicitud todavía no se ha enviado por correo.
                                        </div>
                                      ) : mailHistory.loading ? (
                                        <div className="d-flex align-items-center text-muted mt-2" style={{ gap: "0.5rem" }}>
                                          <CircularProgress size={16} /> Cargando historial de correos...
                                        </div>
                                      ) : mailHistory.error ? (
                                        <div className="text-danger mt-2">
                                          No se ha podido cargar el historial de correos.
                                        </div>
                                      ) : mailHistory.messages.length ? (
                                        <div className="mt-2" style={{ border: "1px solid #E4E6EF", borderRadius: "0.42rem", overflow: "hidden" }}>
                                          {mailHistory.messages.map((mail) => {
                                            const outgoing = mail.tipo_mail === "Enviado";
                                            return (
                                              <div key={mail.id} className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom" style={{ backgroundColor: "#FFFFFF", gap: "1rem" }}>
                                                <div>
                                                  <div className="font-weight-bolder" style={{ color: outgoing ? "#187A42" : "#0F6CBD" }}>
                                                    {outgoing ? "Mail enviado" : "Respuesta recibida"}
                                                    {!outgoing && String(mail.id) === String(request.mail_id_analizado) && (
                                                      <span className="ml-2" style={{ color: request.analizado_por_usuario ? "#187A42" : "#9A6700" }}>
                                                        {request.analizado_por_usuario ? "Analizado por usuario" : "Analizado por IA"}
                                                      </span>
                                                    )}
                                                    {!outgoing && String(mail.id) === String(request.mail_id_analizado) && request.requiere_atencion && (
                                                      <Tooltip title={request.motivo_atencion || "La IA necesita más información para completar la respuesta."}>
                                                        <span className="ml-2" style={{ color: "#9A6700" }}>Analizado por IA · faltan datos</span>
                                                      </Tooltip>
                                                    )}
                                                    {!outgoing && !mail.revisado && String(mail.id) !== String(request.mail_id_analizado) && (
                                                      <span className="ml-2" style={{ color: "#D92D20" }}>Pendiente de revisar</span>
                                                    )}
                                                  </div>
                                                  <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                    {formatDateTime(mail.fecha)} · {outgoing ? mail.destinatarios || "Sin destinatario" : mail.remitente || "Remitente no informado"}
                                                  </div>
                                                  {!!mail.asunto && <div className="text-muted" style={{ fontSize: "0.85rem" }}>{mail.asunto}</div>}
                                                </div>
                                                <Button size="small" variant="outlined" color="primary" onClick={(event) => {
                                                  event.stopPropagation();
                                                  handleOpenSupplierRequestHistoryMail(request.id, mail.id, !outgoing);
                                                }}>
                                                  Ver mail
                                                </Button>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : (
                                        <div className="text-muted mt-2">No hay correos registrados todavía para esta solicitud.</div>
                                      )}

                                      <div className="font-weight-bolder text-dark mt-4">Pedidos</div>
                                      {relatedOrders.length ? (
                                        relatedOrders.map((order) => renderSupplierPurchaseOrderSummary(order))
                                      ) : (
                                        <div className="text-muted mt-2">No se han generado pedidos para este proveedor.</div>
                                      )}

                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-muted">
                  No hay solicitudes de presupuesto registradas para esta obra.
                </div>
              )}

                </div>
              </CardBody>
            </Card>
          )}

          {selectedTab === "materiales" && (
            <Card className="mt-6">
              <CardBody>
                <div>
                <div className="font-weight-bolder text-dark" style={{ fontSize: "1.15rem" }}>Pedidos</div>
                <div className="text-muted">Pedidos generados a partir de las ofertas seleccionadas.</div>
                {purchaseOrders.length ? (
                  <div className="mt-3">
                    {purchaseOrders.map((order) => renderPurchaseOrderCard(order))}
                  </div>
                ) : (
                  <div className="text-muted mt-3">No se han generado pedidos todavía.</div>
                )}
                </div>
              </CardBody>
            </Card>
          )}

      <Dialog
        open={openDeliveryDataDialog}
        onClose={() => !savingDeliveryData && setOpenDeliveryDataDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Datos base para pedido</DialogTitle>
        <DialogContent dividers>
          <div className="text-muted mb-3">Estos datos se propondrán en cada pedido nuevo. Cada pedido podrá modificarlos de forma independiente antes de enviarse.</div>
          <TextField fullWidth margin="dense" label="Dirección de entrega" value={deliveryDataDraft?.direccion_entrega || ""} onChange={handleDeliveryDataChange("direccion_entrega")} />
          <TextField fullWidth margin="dense" label="Contacto de entrega" value={deliveryDataDraft?.contacto_entrega || ""} onChange={handleDeliveryDataChange("contacto_entrega")} />
          <TextField fullWidth margin="dense" label="Teléfono de entrega" value={deliveryDataDraft?.telefono_entrega || ""} onChange={handleDeliveryDataChange("telefono_entrega")} />
          <TextField fullWidth margin="dense" label="Horario de entrega" value={deliveryDataDraft?.horario_entrega || ""} onChange={handleDeliveryDataChange("horario_entrega")} />
          <TextField fullWidth margin="dense" multiline rows={3} label="Observaciones base para pedidos" value={deliveryDataDraft?.observaciones_pedido || ""} onChange={handleDeliveryDataChange("observaciones_pedido")} />
          <TextField fullWidth margin="dense" multiline rows={3} label="Condiciones base" value={deliveryDataDraft?.condiciones_pedido || ""} onChange={handleDeliveryDataChange("condiciones_pedido")} />
        </DialogContent>
        <DialogActions><Button onClick={() => setOpenDeliveryDataDialog(false)} disabled={savingDeliveryData}>Cancelar</Button><Button color="primary" variant="contained" disabled={savingDeliveryData} onClick={handleSaveDeliveryData}>{savingDeliveryData ? "Guardando..." : "Guardar"}</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(purchaseOrderEditor)}
        onClose={() => !savingPurchaseOrder && !savingPurchaseOrderSend && setPurchaseOrderEditor(null)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Pedido {purchaseOrderEditor?.codigo}</DialogTitle>
        <DialogContent dividers>
          <div className="d-flex flex-wrap mb-3" style={{ gap: "0.75rem" }}>
            <MaterialMetricBox label="Proveedor" value={purchaseOrderEditor?.proveedor || "-"} width="260px" />
            <MaterialMetricBox label="Estado" value={purchaseOrderEditor?.fecha_envio ? "Enviado" : "Borrador"} width="170px" />
          </div>
          <div className="row">
            <div className="col-md-6"><TextField fullWidth margin="dense" label="Email del proveedor" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.proveedor_email || ""} onChange={handlePurchaseOrderChange("proveedor_email")} /></div>
            <div className="col-md-6"><TextField fullWidth margin="dense" label="Referencia de la oferta del proveedor" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.referencia_oferta_proveedor || ""} onChange={handlePurchaseOrderChange("referencia_oferta_proveedor")} /></div>
            <div className="col-md-8"><TextField fullWidth margin="dense" label="Dirección de entrega" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.direccion_entrega || ""} onChange={handlePurchaseOrderChange("direccion_entrega")} /></div>
            <div className="col-md-4">
              <TextField fullWidth margin="dense" type="date" label="Fecha prevista de entrega" disabled={!!purchaseOrderEditor?.fecha_envio} InputLabelProps={{ shrink: true }} value={purchaseOrderEditor?.fecha_entrega_prevista || ""} onChange={handlePurchaseOrderChange("fecha_entrega_prevista")} />
              {!purchaseOrderEditor?.fecha_envio && purchaseOrderEditor?.propuesta_entrega && <div className="mt-1">
                {purchaseOrderEditor.propuesta_entrega.fecha_entrega_propuesta && <Button size="small" color="primary" variant="outlined" onClick={() => applyPurchaseOrderDeliveryDate(purchaseOrderEditor.propuesta_entrega.fecha_entrega_propuesta)}>Aplicar entrega {formatDate(purchaseOrderEditor.propuesta_entrega.fecha_entrega_propuesta)}</Button>}
                <div className="text-muted mt-1" style={{ fontSize: "11px", lineHeight: 1.25 }}>{purchaseOrderEditor.propuesta_entrega.mensaje}</div>
              </div>}
            </div>
            <div className="col-md-4"><TextField fullWidth margin="dense" label="Contacto de entrega" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.contacto_entrega || ""} onChange={handlePurchaseOrderChange("contacto_entrega")} /></div>
            <div className="col-md-4"><TextField fullWidth margin="dense" label="Teléfono" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.telefono_entrega || ""} onChange={handlePurchaseOrderChange("telefono_entrega")} /></div>
            <div className="col-md-4"><TextField fullWidth margin="dense" label="Horario" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.horario_entrega || ""} onChange={handlePurchaseOrderChange("horario_entrega")} /></div>
          </div>
          <div className="mt-3" style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden" }}>
            {(purchaseOrderEditor?.lineas || []).map((line) => {
              const availability = getPurchaseOrderLineAvailabilityDisplay(line);
              return <div key={line.id} className="d-flex justify-content-between align-items-center p-2 border-bottom"><div><div className="font-weight-bolder">{line.descripcion_snapshot}</div><div className="text-muted small">{line.referencia_proveedor_snapshot || line.referencia_snapshot || "Sin referencia"}</div><div className="small font-weight-bolder mt-1" style={{ color: availability.color }}>{availability.text}</div></div><div>{line.cantidad} {line.unidad_snapshot}</div><div className="font-weight-bolder">{parseMoney(line.precio_total)} €</div></div>;
            })}
          </div>
          <TextField fullWidth margin="dense" multiline rows={3} label="Observaciones del pedido" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.observaciones || ""} onChange={handlePurchaseOrderChange("observaciones")} />
          <TextField fullWidth margin="dense" multiline rows={3} label="Condiciones" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.condiciones || ""} onChange={handlePurchaseOrderChange("condiciones")} />
          <TextField fullWidth margin="dense" label="Asunto del correo" disabled={!!purchaseOrderEditor?.fecha_envio} value={purchaseOrderEditor?.asunto_email || ""} onChange={handlePurchaseOrderChange("asunto_email")} />
          <div className="mt-3" style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden" }}>
            <div className="d-flex align-items-center justify-content-between px-3 py-2" style={{ background: "#F7F9FC" }}>
              <span className="font-weight-bolder">Mensaje para el proveedor</span>
              {!purchaseOrderEditor?.fecha_envio && <div className="d-flex" style={{ gap: "0.35rem" }}>
                <Button size="small" onClick={() => applyPurchaseOrderEmailFormat("bold")}><strong>N</strong></Button>
                <Button size="small" onClick={() => applyPurchaseOrderEmailFormat("italic")}><em>C</em></Button>
                <Button size="small" onClick={() => applyPurchaseOrderEmailFormat("insertUnorderedList")}>Lista</Button>
                <Button size="small" onClick={addPurchaseOrderEmailLink}>Enlace</Button>
              </div>}
            </div>
            <div
              ref={purchaseOrderEmailBodyEditorRef}
              key={purchaseOrderEditor?.id}
              contentEditable={!purchaseOrderEditor?.fecha_envio}
              suppressContentEditableWarning
              onInput={handlePurchaseOrderEmailBodyInput}
              dangerouslySetInnerHTML={{ __html: purchaseOrderEditor?.cuerpo_email || "<p>Sin contenido.</p>" }}
              style={{ minHeight: "220px", padding: "18px", background: "#FFFFFF", outline: "none", cursor: purchaseOrderEditor?.fecha_envio ? "default" : "text", lineHeight: 1.6 }}
            />
          </div>
          {!purchaseOrderEditor?.fecha_envio && <label className="d-flex align-items-start mt-3 p-3" style={{ gap: "0.65rem", border: "1px solid #FFB74D", borderRadius: "8px", background: "#FFF8E8", cursor: "pointer" }}><input type="checkbox" checked={!!purchaseOrderEditor?.ignorar_modo_prueba} onChange={handlePurchaseOrderChange("ignorar_modo_prueba", true)} /><span><span className="font-weight-bolder">Ignorar modo prueba</span><br /><span className="text-muted">Envía este pedido al proveedor real aunque el modo prueba global esté activo.</span></span></label>}
        </DialogContent>
        <DialogActions><Button onClick={() => setPurchaseOrderEditor(null)}>Cerrar</Button><Button color="primary" onClick={handlePreviewPurchaseOrderPdf}>Previsualizar PDF</Button>{!purchaseOrderEditor?.fecha_envio && <><Button onClick={handleSavePurchaseOrder} disabled={savingPurchaseOrder || savingPurchaseOrderSend}>Guardar borrador</Button><Button color="primary" variant="contained" onClick={handleSendPurchaseOrder} disabled={savingPurchaseOrder || savingPurchaseOrderSend}>{savingPurchaseOrderSend ? "Enviando..." : "Enviar pedido"}</Button></>}</DialogActions>
      </Dialog>

      <Dialog open={Boolean(confirmationDialog)} onClose={() => setConfirmationDialog(null)} fullWidth maxWidth="xs">
        <DialogTitle>{confirmationDialog?.title}</DialogTitle>
        <DialogContent dividers><div style={{ lineHeight: 1.55 }}>{confirmationDialog?.message}</div></DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmationDialog(null)}>Cancelar</Button>
          <Button color={confirmationDialog?.danger ? "secondary" : "primary"} variant="contained" onClick={handleConfirmDialog}>{confirmationDialog?.confirmLabel || "Confirmar"}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={emailLinkDialog.open} onClose={() => setEmailLinkDialog({ open: false, url: "https://" })} fullWidth maxWidth="xs">
        <DialogTitle>Añadir enlace al mensaje</DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            fullWidth
            label="Dirección del enlace"
            value={emailLinkDialog.url}
            onChange={(event) => {
              const url = event.target.value;
              setEmailLinkDialog((current) => ({ ...current, url }));
            }}
          />
        </DialogContent>
        <DialogActions><Button onClick={() => setEmailLinkDialog({ open: false, url: "https://" })}>Cancelar</Button><Button color="primary" variant="contained" onClick={handleConfirmEmailLink}>Añadir enlace</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(materialAssignmentDraft)}
        onClose={() => !savingMaterialAssignments && setMaterialAssignmentDraft(null)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Cantidad a asignar</DialogTitle>
        <DialogContent>
          <div className="font-weight-bolder text-dark mb-2">{materialAssignmentDraft?.producto?.descripcion}</div>
          <div className="text-muted mb-4">Disponible en almacén: {materialAssignmentDraft?.producto?.cantidad_disponible ?? 0}. Puedes indicar una cantidad superior si es necesario.</div>
          <div className="d-flex align-items-center justify-content-between" style={{ border: "1px solid #DFE5F1", borderRadius: "10px", padding: "12px" }}>
            <Button aria-label="Restar una unidad" variant="outlined" onClick={() => setMaterialAssignmentDraft((current) => ({ ...current, cantidad: Math.max(0, Number(current?.cantidad || 0) - 1) }))} style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}><RemoveIcon /></Button>
            <input aria-label="Cantidad asignada" inputMode="decimal" value={String(materialAssignmentDraft?.cantidad ?? 0)} onFocus={(event) => event.target.select()} onChange={(event) => { const value = event.target.value; setMaterialAssignmentDraft((current) => ({ ...current, cantidad: value === "" ? "" : Math.max(0, Number(value.replace(",", ".")) || 0) })); }} className="obra-hours-duration-input font-weight-bolder text-center" style={{ width: "140px", border: 0, background: "transparent", fontSize: "22px", fontWeight: 700, outline: "none" }} />
            <Button aria-label="Sumar una unidad" color="primary" variant="contained" onClick={() => setMaterialAssignmentDraft((current) => ({ ...current, cantidad: Number(current?.cantidad || 0) + 1 }))} style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}><AddIcon /></Button>
          </div>
        </DialogContent>
        <DialogActions><Button onClick={() => setMaterialAssignmentDraft(null)}>Cancelar</Button><Button color="primary" variant="contained" disabled={savingMaterialAssignments} onClick={handleConfirmMaterialAssignment}>Asignar</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(materialAssignmentEditor)}
        onClose={() => !savingMaterialAssignments && setMaterialAssignmentEditor(null)}
        fullWidth
        maxWidth={false}
        PaperProps={{ style: { width: "430px", maxWidth: "calc(100vw - 24px)", height: "min(760px, calc(100vh - 24px))" } }}
      >
        <DialogTitle>Imputar materiales</DialogTitle>
        <DialogContent dividers style={{ padding: "16px", overflowY: "auto" }}>
          <div className="mb-3 p-3" style={{ backgroundColor: "#F3F6FF", borderRadius: "8px" }}>
            <div className="font-weight-bolder">{obraHeader.codigo_obra || "Obra"}</div>
            <div className="text-muted">{obraHeader.oferta_referencia || obraHeader.localizacion || ""}</div>
          </div>
          <Autocomplete options={assignedOperarios.filter((item) => !item.bloqueado)} value={assignedOperarios.find((item) => item.operario_id === materialAssignmentEditor?.operario_id) || null} onChange={(event, value) => setMaterialAssignmentEditor((current) => ({ ...current, operario_id: value?.operario_id || "" }))} getOptionLabel={(item) => item?.nombreCompleto || ""} renderOption={(item) => <span style={{ color: "#17203A", fontSize: "14px" }}>{item?.nombreCompleto || "-"}</span>} renderInput={(params) => <TextField {...params} label="Operario que asigna" variant="outlined" margin="dense" InputProps={{ ...params.InputProps, style: { color: "#17203A" } }} />} />
          <TextField fullWidth margin="dense" variant="outlined" type="date" label="Fecha de instalación" value={materialAssignmentEditor?.fecha_instalacion || ""} onChange={(event) => { const fecha_instalacion = event.target.value; setMaterialAssignmentEditor((current) => ({ ...current, fecha_instalacion })); }} InputLabelProps={{ shrink: true }} />
          <div className="mt-4 mb-2 font-weight-bolder text-dark">Línea de descompuesto</div>
          <div style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden" }}>
            {(materialAssignmentEditor?.capitulos || []).map((chapter) => {
              const activePartidas = (chapter.partidas || []).filter((partida) =>
                (partida.productos || []).some((product) => product.puede_imputar)
              );
              const enabled = activePartidas.length > 0;
              const expanded = expandedMaterialAssignmentChapters.includes(chapter.capitulo_id);
              return <div key={chapter.capitulo_id} style={{ borderBottom: "1px solid #DFE5F1" }}>
                <button type="button" disabled={!enabled} onClick={() => setExpandedMaterialAssignmentChapters((current) => current.includes(chapter.capitulo_id) ? current.filter((item) => item !== chapter.capitulo_id) : [...current, chapter.capitulo_id])} className="w-100 border-0 text-left px-3 py-3 d-flex align-items-center justify-content-between" style={{ background: enabled ? DETAIL_SECTION_BLUE : "#B6C6E5", color: "#FFF", opacity: enabled ? 1 : 0.65, cursor: enabled ? "pointer" : "not-allowed" }}><span className="font-weight-bolder">Capítulo {chapter.ordinal}. {chapter.descripcion}</span>{enabled && (expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)}</button>
                {expanded && (chapter.partidas || []).map((partida) => {
                  const selectable = (partida.productos || []).some((product) => product.puede_imputar);
                  const partidaExpanded = expandedMaterialAssignmentPartidas.includes(partida.partida_id);
                  return <div key={partida.partida_id} style={{ background: selectable ? "#FFF" : "#F4F5F8", opacity: selectable ? 1 : 0.55 }}>
                    <button type="button" disabled={!selectable} onClick={() => setExpandedMaterialAssignmentPartidas((current) => current.includes(partida.partida_id) ? current.filter((item) => item !== partida.partida_id) : [...current, partida.partida_id])} className="w-100 text-left border-0 px-3 py-3 d-flex justify-content-between align-items-center" style={{ background: "transparent", cursor: selectable ? "pointer" : "not-allowed" }}><span className="font-weight-bolder">{partida.ordinal}. {partida.descripcion}</span>{selectable && (partidaExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)}</button>
                    {partidaExpanded && (partida.productos || []).map((product) => {
                      const available = Boolean(product.puede_imputar);
                      const completed = Number(product.cantidad_pendiente || 0) === 0;
                      return <button key={product.producto_id} type="button" disabled={!available} onClick={() => handleOpenMaterialAssignmentQuantity(partida, product)} className="w-100 border-0 text-left px-4 py-3" style={{ background: available ? "#F9FAFC" : "#F4F5F8", borderTop: "1px solid #E9EDF5", color: available ? "#17203A" : "#9AA5B5", cursor: available ? "pointer" : "not-allowed", opacity: available ? 1 : 0.62 }}><div className="font-weight-bolder">{product.descripcion}</div><div className="mt-1" style={{ fontSize: "13px" }}><span className={available ? "text-primary font-weight-bolder" : "font-weight-bolder"}>Disponible: {product.cantidad_disponible}</span><span className="mx-2">·</span><span>Pendiente: {product.cantidad_pendiente}</span></div>{completed && <div className="small mt-1">Material completo</div>}{!completed && !available && <div className="small mt-1">Sin existencias en almacén</div>}</button>;
                    })}
                  </div>;
                })}
              </div>;
            })}
          </div>
        </DialogContent>
        <DialogActions><Button onClick={() => setMaterialAssignmentEditor(null)}>Cerrar</Button></DialogActions>
      </Dialog>

      <Dialog
        open={openMaterialRequestDialog}
        onClose={() => !savingMaterialRequest && setOpenMaterialRequestDialog(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          {materialRequestEditor.solicitud_id
            ? "Editar solicitud de material"
            : "Nueva solicitud de material"}
        </DialogTitle>
        <DialogContent>
          {!!materialRequestEditor.codigo && (
            <div className="d-flex flex-wrap mb-4" style={{ gap: "0.75rem" }}>
              <MaterialMetricBox
                label="Código"
                value={materialRequestEditor.codigo}
                width="260px"
              />
              <MaterialMetricBox
                label="Estado"
                value={materialRequestEditor.estado_descripcion || "Recibida"}
                width="220px"
              />
              <MaterialMetricBox
                label="Valorando"
                value={`${parsePercent(
                  materialRequestEditor.materiales_en_solicitudes_oferta
                )}/${parsePercent(materialRequestEditor.materiales_totales)}`}
                width="160px"
              />
              <MaterialMetricBox
                label="Recibidos"
                value={`${parsePercent(
                  materialRequestEditor.materiales_recibidos
                )}/${parsePercent(materialRequestEditor.materiales_totales)}`}
                width="160px"
              />
            </div>
          )}

          <Autocomplete
            options={assignedOperarios.filter((item) => !item.bloqueado)}
            value={
              assignedOperarios.find(
                (item) =>
                  item.operario_id === materialRequestEditor.operario_solicita_id
              ) || null
            }
            onChange={(_, value) => {
              setMaterialRequestEditor((current) => ({
                ...current,
                operario_solicita_id: value?.operario_id || null,
              }));
            }}
            getOptionLabel={(item) => item?.nombreCompleto || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                margin="normal"
                variant="outlined"
                label="Operario solicitante"
                required
                InputLabelProps={{ shrink: true }}
              />
            )}
            disabled={!materialRequestEditor.permite_acciones}
          />

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="text-muted">
              Selecciona materiales de la obra o añade material adicional.
            </div>
            <div className="d-flex" style={{ gap: "0.75rem" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={handleOpenExtraMaterialDialog}
                disabled={!materialRequestEditor.permite_acciones}
              >
                Solicitar material extra
              </Button>
            </div>
          </div>

          <div
            className="px-4 py-4 mb-5"
            style={{
              border: "1px solid #E4E6EF",
              borderRadius: "0.42rem",
              maxHeight: "380px",
              overflowY: "auto",
            }}
          >
            {(materialRequestEditor.capitulos || []).length ? (
              materialRequestEditor.capitulos.map((chapter) => {
                const expanded = expandedMaterialRequestChapters.includes(
                  chapter.capitulo_id
                );

                return (
                  <div
                    key={chapter.capitulo_id}
                    className="mb-4"
                    style={{
                      border: "1px solid #E4E6EF",
                      borderRadius: 0,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center px-4 py-3"
                      style={{ backgroundColor: DETAIL_SECTION_BLUE, color: "#FFF" }}
                    >
                      <button
                        type="button"
                        className="border-0 bg-transparent text-white font-weight-bolder text-uppercase text-left"
                        onClick={() => toggleMaterialRequestChapter(chapter.capitulo_id)}
                      >
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />} Capítulo{" "}
                        {chapter.ordinal}. {chapter.descripcion}
                      </button>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => handleSelectWholeChapter(chapter.capitulo_id)}
                        disabled={!materialRequestEditor.permite_acciones}
                      >
                        Seleccionar todo
                      </Button>
                    </div>

                    {expanded && (
                      <div className="px-4 py-4" style={{ backgroundColor: "#F9FAFC" }}>
                        {(chapter.partidas || []).map((partida) => {
                          const partidaExpanded =
                            expandedMaterialRequestPartidas.includes(
                              partida.partida_id
                            );

                          return (
                            <div
                              key={partida.partida_id}
                              className="mb-4 bg-white"
                              style={{
                                border: "1px solid #E4E6EF",
                                borderRadius: "0.42rem",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center px-4 py-3">
                                <button
                                  type="button"
                                  className="border-0 bg-transparent text-left"
                                  onClick={() =>
                                    toggleMaterialRequestPartida(partida.partida_id)
                                  }
                                >
                                  <span className="font-weight-bolder text-dark">
                                    {partidaExpanded ? (
                                      <ExpandLessIcon />
                                    ) : (
                                      <ExpandMoreIcon />
                                    )}{" "}
                                    {partida.ordinal}. {partida.descripcion}
                                  </span>
                                  {!!partida.referencia && (
                                    <div className="text-muted">{partida.referencia}</div>
                                  )}
                                </button>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    handleSelectWholePartida(
                                      chapter.capitulo_id,
                                      partida.partida_id
                                    )
                                  }
                                  disabled={!materialRequestEditor.permite_acciones}
                                >
                                  Seleccionar todo
                                </Button>
                              </div>

                              {partidaExpanded && (
                                <div className="px-4 pb-4">
                                  {(partida.productos || []).map((product) => (
                                    <div
                                      key={product.obra_producto_id}
                                      className="d-flex justify-content-between align-items-center py-3 border-top"
                                      style={{ gap: "1rem" }}
                                    >
                                      <div>
                                        <div className="font-weight-bold text-dark">
                                          {product.descripcion}
                                          {product.es_agrupacion_material && (
                                            <span className="ml-2 badge badge-light-primary">
                                              Agrupación completa
                                            </span>
                                          )}
                                        </div>
                                        <div className="text-muted">
                                          {product.referencia || "-"}{" "}
                                          {!!product.unidad && `· ${product.unidad}`}
                                        </div>
                                      </div>
                                      <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                                        <MaterialMetricBox
                                          label="Cantidad necesaria"
                                          value={parsePercent(
                                            product.cantidad_total_obra
                                          )}
                                        />
                                        <MaterialMetricBox
                                          label="Cantidad solicitada"
                                          value={parsePercent(
                                            product.cantidad_solicitada_acumulada
                                          )}
                                        />
                                        <MaterialMetricBox
                                          label="Cantidad pendiente"
                                          value={parsePercent(
                                            product.cantidad_pendiente
                                          )}
                                        />
                                        {parseDecimal(product.cantidad_seleccionada) > 0 && (
                                          <div className="text-primary font-weight-bold">
                                            {parsePercent(product.cantidad_seleccionada)}
                                          </div>
                                        )}
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          onClick={() =>
                                            handleOpenMaterialQuantityDialog(
                                              chapter.capitulo_id,
                                              partida.partida_id,
                                              product
                                            )
                                          }
                                          disabled={!materialRequestEditor.permite_acciones}
                                        >
                                          {product.es_agrupacion_material
                                            ? "Seleccionar agrupación"
                                            : "Seleccionar material"}
                                        </Button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-muted">
                No hay materiales disponibles para solicitar en esta obra.
              </div>
            )}
          </div>

          <div className="mt-5">
            <div className="font-weight-bolder text-dark mb-3">
              Material seleccionado
            </div>
            <div
              className="px-4 py-4"
              style={{
                border: "1px solid #E4E6EF",
                borderRadius: "0.42rem",
                maxHeight: "260px",
                overflowY: "auto",
              }}
            >
              {selectedMaterialRequestLines.length ? (
                selectedMaterialRequestLines.map((line) => (
                  <div
                    key={line.key}
                    className="d-flex justify-content-between align-items-center py-3 border-bottom"
                    style={{ gap: "1rem" }}
                  >
                    <div>
                      <div className="font-weight-bold text-dark">
                        {line.description}
                        {line.isMaterialGroup && (
                          <span className="ml-2 badge badge-light-primary">
                            Agrupación completa
                          </span>
                        )}
                      </div>
                      <div className="text-muted">
                        {line.chapterDescription}
                        {!!line.partidaDescription && ` · ${line.partidaDescription}`}
                      </div>
                      <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                        {line.reference || "-"} {!!line.unit && `· ${line.unit}`}
                      </div>
                      {line.isExtra && !!line.indicaciones && (
                        <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                          Indicaciones: {line.indicaciones}
                        </div>
                      )}
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                      {!line.isExtra && (
                        <>
                          <MaterialMetricBox
                            label="Cantidad necesaria"
                            value={parsePercent(line.totalNeeded)}
                          />
                          <MaterialMetricBox
                            label="Cantidad solicitada"
                            value={parsePercent(line.requested)}
                          />
                          <MaterialMetricBox
                            label="Cantidad pendiente"
                            value={parsePercent(line.pending)}
                          />
                        </>
                      )}
                      <MaterialMetricBox
                        label="Solicitas ahora"
                        value={parsePercent(line.quantity)}
                        width="120px"
                      />
                      <Button
                        size="small"
                        onClick={() => handleOpenSelectedLineEditor(line)}
                        disabled={!materialRequestEditor.permite_acciones}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        size="small"
                        onClick={() => handleRemoveSelectedMaterialLine(line)}
                        disabled={!materialRequestEditor.permite_acciones}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted">
                  No has seleccionado materiales todavía.
                </div>
              )}
            </div>
          </div>

          <TextField
            fullWidth
            multiline
            rows={3}
            margin="normal"
            variant="outlined"
            label="Observaciones"
            value={materialRequestEditor.observaciones || ""}
            onChange={(event) => {
              const value = event.target.value;

              setMaterialRequestEditor((current) => ({
                ...current,
                observaciones: value,
              }));
            }}
            disabled={!materialRequestEditor.permite_acciones}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenMaterialRequestDialog(false)}
            color="default"
            disabled={savingMaterialRequest}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveMaterialRequest}
            color="primary"
            variant="contained"
            disabled={savingMaterialRequest || !materialRequestEditor.permite_acciones}
          >
            Guardar solicitud
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMaterialQuantityDialog}
        onClose={() => setOpenMaterialQuantityDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Seleccionar material</DialogTitle>
        <DialogContent>
          <div className="text-muted mb-4">{materialQuantityDraft.description}</div>
          <div className="d-flex justify-content-end mb-4">
            <Button
              color="primary"
              onClick={() =>
                setMaterialQuantityDraft((current) => ({
                  ...current,
                  quantity: String(current.maxQuantity),
                }))
              }
            >
              Todo
            </Button>
          </div>
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            type="number"
            label="Cantidad"
            value={materialQuantityDraft.quantity}
            onChange={(event) => {
              const value = event.target.value;

              setMaterialQuantityDraft((current) => ({
                ...current,
                quantity: value,
              }));
            }}
            inputProps={{
              min: 0,
              max: parseDecimal(materialQuantityDraft.maxQuantity),
            }}
            InputLabelProps={{ shrink: true }}
          />
          <div className="text-muted">
            Pendiente actual: {parsePercent(materialQuantityDraft.maxQuantity)}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMaterialQuantityDialog(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleSaveMaterialQuantity} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSupplierRequestDialog}
        onClose={() => {
          if (!savingSupplierRequest) {
            setOpenSupplierRequestDialog(false);
            resetSupplierRequestDialog();
          }
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          {supplierRequestEditor.requestId
            ? "Editar solicitud de presupuesto"
            : "Nueva solicitud de oferta"}
        </DialogTitle>
        <DialogContent>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="text-muted">
              Selecciona materiales pendientes y los proveedores a los que quieres solicitar oferta.
            </div>
            <div className="d-flex" style={{ gap: "0.75rem" }}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpenSupplierSelectionDialog(true)}
                disabled={!!supplierRequestEditor.requestId}
                style={{ backgroundColor: DETAIL_SECTION_BLUE, color: "#FFFFFF" }}
              >
                Selección de proveedores
              </Button>
            </div>
          </div>

          <div className="mb-5">
            <div className="font-weight-bolder text-dark mb-3">
              Proveedores seleccionados
            </div>
            <div
              className="px-4 py-4"
              style={{
                border: "1px solid #E4E6EF",
                borderRadius: "0.42rem",
                minHeight: "72px",
                backgroundColor: "#F9FAFC",
              }}
            >
              {selectedSupplierItems.length ? (
                <div className="d-flex flex-wrap" style={{ gap: "0.75rem" }}>
                  {selectedSupplierItems.map((supplier) => (
                    <div
                      key={supplier.id}
                      className="d-flex align-items-center px-3 py-2"
                      style={{
                        borderRadius: "999px",
                        backgroundColor: DETAIL_SECTION_BLUE,
                        color: "#FFFFFF",
                        gap: "0.5rem",
                      }}
                    >
                      <span>{supplier.nombre}</span>
                      <button
                        type="button"
                        className="border-0 bg-transparent text-white p-0"
                        disabled={!!supplierRequestEditor.requestId}
                        onClick={() =>
                          setSelectedSupplierItems((current) =>
                            current.filter((item) => item.id !== supplier.id)
                          )
                        }
                      >
                        <CloseIcon fontSize="small" />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-muted">No has seleccionado proveedores todavía.</div>
              )}
            </div>
          </div>

          <div
            className="px-4 py-4 mb-5"
            style={{
              border: "1px solid #E4E6EF",
              borderRadius: "0.42rem",
              maxHeight: "380px",
              overflowY: "auto",
            }}
          >
            {(supplierRequestEditor.capitulos || []).length ? (
              supplierRequestEditor.capitulos.map((chapter) => {
                const expanded = expandedSupplierRequestChapters.includes(
                  chapter.capitulo_id
                );

                return (
                  <div
                    key={chapter.capitulo_id}
                    className="mb-4"
                    style={{
                      border: "1px solid #E4E6EF",
                      borderRadius: 0,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center px-4 py-3"
                      style={{ backgroundColor: DETAIL_SECTION_BLUE, color: "#FFF" }}
                    >
                      <button
                        type="button"
                        className="border-0 bg-transparent text-white font-weight-bolder text-uppercase text-left"
                        onClick={() => toggleSupplierRequestChapter(chapter.capitulo_id)}
                      >
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />} Capítulo{" "}
                        {chapter.ordinal}. {chapter.descripcion}
                      </button>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => handleSelectWholeSupplierChapter(chapter)}
                      >
                        Seleccionar todo
                      </Button>
                    </div>

                    {expanded && (
                      <div className="px-4 py-4" style={{ backgroundColor: "#F9FAFC" }}>
                        {(chapter.partidas || []).map((partida) => {
                          const partidaExpanded =
                            expandedSupplierRequestPartidas.includes(
                              partida.partida_id
                            );

                          return (
                            <div
                              key={partida.partida_id}
                              className="mb-4 bg-white"
                              style={{
                                border: "1px solid #E4E6EF",
                                borderRadius: "0.42rem",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center px-4 py-3">
                                <button
                                  type="button"
                                  className="border-0 bg-transparent text-left"
                                  onClick={() =>
                                    toggleSupplierRequestPartida(partida.partida_id)
                                  }
                                >
                                  <span className="font-weight-bolder text-dark">
                                    {partidaExpanded ? (
                                      <ExpandLessIcon />
                                    ) : (
                                      <ExpandMoreIcon />
                                    )}{" "}
                                    {partida.ordinal}. {partida.descripcion}
                                  </span>
                                  {!!partida.referencia && (
                                    <div className="text-muted">{partida.referencia}</div>
                                  )}
                                </button>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => handleSelectWholeSupplierPartida(partida)}
                                >
                                  Seleccionar todo
                                </Button>
                              </div>

                              {partidaExpanded && (
                                <div className="px-4 pb-4">
                                  {(partida.productos || []).map((product) => {
                                    const isSelected = selectedSupplierRequestLineIds.includes(
                                      product.linea_solicitud_material_obra_id
                                    );

                                    return (
                                      <div
                                        key={product.linea_solicitud_material_obra_id}
                                        className="d-flex justify-content-between align-items-center py-3 border-top"
                                        style={{ gap: "1rem" }}
                                      >
                                        <div>
                                          <div className="font-weight-bold text-dark">
                                            {product.descripcion}
                                          </div>
                                          <div className="text-muted">
                                            {product.referencia || "-"}{" "}
                                            {!!product.unidad && `· ${product.unidad}`}
                                          </div>
                                        </div>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ gap: "0.75rem" }}
                                        >
                                          <MaterialMetricBox
                                            label="Cantidad solicitada"
                                            value={parsePercent(product.cantidad_solicitada)}
                                            width="140px"
                                          />
                                          <Button
                                            size="small"
                                            variant={isSelected ? "contained" : "outlined"}
                                            color="primary"
                                            onClick={() =>
                                              toggleSupplierRequestLine(
                                                product.linea_solicitud_material_obra_id
                                              )
                                            }
                                          >
                                            {isSelected ? "Quitar" : "Seleccionar"}
                                          </Button>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-muted">
                No hay materiales disponibles para solicitar presupuesto en esta obra.
              </div>
            )}
          </div>

          <TextField
            fullWidth
            multiline
            rows={3}
            margin="normal"
            variant="outlined"
            label="Observaciones"
            value={supplierRequestEditor.observaciones || ""}
            onChange={(event) => {
              const value = event.target.value;

              setSupplierRequestEditor((current) => ({
                ...current,
                observaciones: value,
              }));
            }}
            InputLabelProps={{ shrink: true }}
          />

          <div className="mt-5">
            <div className="font-weight-bolder text-dark mb-3">
              Material seleccionado
            </div>
            <div
              className="px-4 py-4"
              style={{
                border: "1px solid #E4E6EF",
                borderRadius: "0.42rem",
                maxHeight: "260px",
                overflowY: "auto",
              }}
            >
              {selectedSupplierRequestLines.length ? (
                selectedSupplierRequestLines.map((line) => (
                  <div
                    key={line.key}
                    className="d-flex justify-content-between align-items-center py-3 border-bottom"
                    style={{ gap: "1rem" }}
                  >
                    <div>
                      <div className="font-weight-bold text-dark">
                        {line.description}
                      </div>
                      <div className="text-muted">
                        {line.chapterDescription}
                        {!!line.partidaDescription && ` · ${line.partidaDescription}`}
                      </div>
                      <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                        {line.reference || "-"} {!!line.unit && `· ${line.unit}`}
                      </div>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                      <MaterialMetricBox
                        label="Cantidad solicitada"
                        value={parsePercent(line.quantity)}
                        width="140px"
                      />
                      <Button
                        size="small"
                        onClick={() =>
                          handleRemoveSelectedSupplierRequestLine(
                            line.linea_solicitud_material_obra_id
                          )
                        }
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted">
                  No has seleccionado materiales todavía.
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      <DialogActions>
          <Button
            onClick={() => {
              setOpenSupplierRequestDialog(false);
              resetSupplierRequestDialog();
            }}
            color="default"
            disabled={savingSupplierRequest}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveSupplierRequest}
            color="primary"
            variant="contained"
            disabled={savingSupplierRequest || !selectedSupplierItems.length}
          >
            Guardar solicitud
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddSupplierDialog}
        onClose={() => {
          if (!addingSupplierToRequest) {
            setOpenAddSupplierDialog(false);
            setSupplierRequestGroupToExtend(null);
            setSupplierToAdd(null);
          }
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Añadir proveedor a la solicitud</DialogTitle>
        <DialogContent>
          <div className="text-muted mb-4">
            Se añadirá con los mismos materiales y observaciones. Podrás revisar el correo antes de enviarlo.
          </div>
          <Autocomplete
            options={(suppliers || []).filter(
              (supplier) =>
                !(supplierRequestGroupToExtend?.requests || []).some(
                  (request) => String(request.proveedor_id) === String(supplier.id)
                )
            )}
            getOptionLabel={(supplier) => supplier?.nombre || ""}
            value={supplierToAdd}
            onChange={(_, value) => setSupplierToAdd(value)}
            renderInput={(params) => (
              <TextField {...params} label="Proveedor" variant="outlined" placeholder="Busca un proveedor" />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenAddSupplierDialog(false);
              setSupplierRequestGroupToExtend(null);
              setSupplierToAdd(null);
            }}
            disabled={addingSupplierToRequest}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleAddSupplierToRequestGroup}
            disabled={addingSupplierToRequest || !supplierToAdd}
          >
            Añadir proveedor
          </Button>
        </DialogActions>
      </Dialog>

      <MailComposeDialog
        open={openSupplierRequestMailDialog}
        title="Enviar solicitud de presupuesto"
        confirmLabel="Enviar"
        loading={sendingSupplierRequestMail}
        initialValues={supplierRequestMailDraft?.initialValues}
        helperText={supplierRequestMailDraft?.helperText}
        hideToEmailField={supplierRequestMailDraft?.hideToEmailField}
        recipientPreviewList={supplierRequestMailDraft?.recipientPreviewList || []}
        onClose={() => {
          if (!sendingSupplierRequestMail) {
            setOpenSupplierRequestMailDialog(false);
            setSupplierRequestMailDraft(null);
          }
        }}
        onSubmit={handleSendSupplierRequestMail}
      />

      <Dialog
        open={openSupplierResponseDialog}
        onClose={() => {
          if (!savingSupplierResponse) {
            setOpenSupplierResponseDialog(false);
            setAutoFillSupplierResponseOnOpen(false);
            setOpenSupplierResponseSourceMailDialog(false);
            setSupplierResponseEditor(getEmptySupplierResponseEditor());
            setSupplierResponseSourceMail(null);
            setDownloadingSupplierResponseAttachmentKey(null);
          }
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Valoracion de respuesta de proveedor</DialogTitle>
        <DialogContent>
          <div className="d-flex flex-wrap mb-4" style={{ gap: "0.75rem" }}>
            <MaterialMetricBox
              label="Proveedor"
              value={supplierResponseEditor.supplierName || "-"}
              width="260px"
            />
            <MaterialMetricBox
              label="Fecha respuesta"
              value={formatDate(supplierResponseEditor.fecha_respuesta)}
              width="180px"
            />
            <MaterialMetricBox
              label="Total respuesta"
              value={supplierResponseEditor.isAnalysed ? `${parseMoney(supplierResponseEditor.precio_total)} €` : "-"}
              width="180px"
            />
            <MaterialMetricBox
              label="Oferta proveedor"
              value={supplierResponseEditor.referencia_oferta_proveedor || "-"}
              width="210px"
            />
          </div>

          {!!supplierResponseEditor.observaciones && (
            <div className="mt-3 px-3 py-2" style={{ backgroundColor: "#F8FAFC", border: "1px solid #E4E6EF", borderRadius: "0.3rem" }}>
              <div className="font-weight-bolder text-muted" style={{ fontSize: "0.72rem" }}>OBSERVACIONES</div>
              <div className="text-dark mt-1">{supplierResponseEditor.observaciones}</div>
            </div>
          )}

          <div
            className="d-flex align-items-center justify-content-between flex-wrap mt-3 mb-4"
            style={{ gap: "0.75rem" }}
          >
            <div className="text-muted">
              <span className="font-weight-bold">Último mail del proveedor:</span>{" "}
              {supplierResponseSourceMail?.asunto || "-"}
            </div>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleOpenSupplierResponseSourceMail}
              disabled={!supplierResponseEditor.mail_id_origen}
            >
              Ver mail
            </Button>
          </div>

          <div
            className="mt-4"
            style={{
              border: "1px solid #E4E6EF",
              borderRadius: "0.42rem",
              maxHeight: "560px",
              overflowY: "auto",
            }}
          >
            <div
              className="d-flex align-items-center px-4 py-3 font-weight-bolder text-dark border-bottom"
              style={{ gap: "1rem", backgroundColor: "#F9FAFC" }}
            >
              <div style={{ flex: 1 }}>Material</div>
              <div style={{ width: "110px" }}>Cantidad</div>
              <div style={{ width: "140px" }}>Precio unitario</div>
              <div style={{ width: "140px" }}>Precio global</div>
            </div>

            {(supplierResponseEditor.lineas || []).length ? (
              supplierResponseEditor.lineas.map((line) => {
                const availabilityStyle = getSupplierResponseAvailabilityStyle(line, supplierResponseEditor.isAnalysed);
                const expectedDate = formatDate(line.fecha_disponibilidad);

                return (
                  <div
                    key={line.key}
                    className="px-4 py-3 border-bottom"
                    style={{ backgroundColor: availabilityStyle.backgroundColor, borderColor: availabilityStyle.borderColor }}
                  >
                    <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                      <div style={{ flex: 1 }}>
                        <div className="font-weight-bolder text-dark">
                          {line.descripcion}
                        </div>
                        <div className="text-muted">
                          {line.referencia || "-"}
                          {!!line.unidad && ` · ${line.unidad}`}
                        </div>
                      </div>
                      <div style={{ width: "110px" }}>
                        {parsePercent(line.cantidad_solicitada)}
                      </div>
                      <div className="font-weight-bolder" style={{ width: "140px" }}>
                        {supplierResponseEditor.isAnalysed ? `${parseMoney(line.precio_unitario)} €` : "-"}
                      </div>
                      <div className="font-weight-bolder" style={{ width: "140px" }}>
                        {supplierResponseEditor.isAnalysed ? `${parseMoney(line.precio_global)} €` : "-"}
                      </div>
                    </div>
                    {supplierResponseEditor.isAnalysed && (
                      <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: "0.85rem", color: availabilityStyle.color, fontSize: "0.82rem" }}>
                        <span><b>Ref. proveedor:</b> {line.referencia_proveedor || "-"}</span>
                        <span><b>Disponible ahora:</b> {parsePercent(line.cantidad_disponible_inmediata)} / {parsePercent(line.cantidad_solicitada)}</span>
                        {expectedDate && <span><b>Fecha prevista:</b> {expectedDate}</span>}
                        {!!line.observacion_disponibilidad && <span><b>Disponibilidad:</b> {line.observacion_disponibilidad}</span>}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="px-4 py-4 text-muted">
                No hay lineas disponibles para valorar.
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAutoFillSupplierResponse}
            color="primary"
            variant="outlined"
            disabled={savingSupplierResponse || autoFillingSupplierResponse}
          >
            {autoFillingSupplierResponse ? "Analizando..." : "Volver a analizar"}
          </Button>
          <Button
            onClick={() => {
              setOpenSupplierResponseDialog(false);
              setAutoFillSupplierResponseOnOpen(false);
              setOpenSupplierResponseSourceMailDialog(false);
              setSupplierResponseEditor(getEmptySupplierResponseEditor());
              setSupplierResponseSourceMail(null);
              setDownloadingSupplierResponseAttachmentKey(null);
            }}
            color="default"
            disabled={savingSupplierResponse || autoFillingSupplierResponse}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveSupplierResponse}
            color="primary"
            variant="contained"
            disabled={savingSupplierResponse || autoFillingSupplierResponse || !supplierResponseEditor.isAnalysed}
          >
            Guardar valoracion
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={autoFillingSupplierResponse}
        fullWidth
        maxWidth="xs"
        disableEscapeKeyDown
      >
        <DialogContent>
          <div
            className="d-flex flex-column align-items-center justify-content-center py-8"
            style={{ minHeight: "220px", gap: "1.5rem" }}
          >
            <CircularProgress size={56} />
            <div
              className="font-weight-bolder text-dark text-center"
              style={{ fontSize: "1rem" }}
            >
              Esperando respuesta de la IA
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <MailViewDialog
        open={openSupplierResponseSourceMailDialog}
        onClose={() => {
          setOpenSupplierResponseSourceMailDialog(false);
          setDownloadingSupplierResponseAttachmentKey(null);
        }}
        mail={supplierResponseSourceMail}
        onDownloadAttachment={handleDownloadSupplierResponseAttachment}
        downloadingAttachmentKey={downloadingSupplierResponseAttachmentKey}
      />

      <MailViewDialog
        open={openSupplierRequestHistoryMailDialog}
        onClose={() => {
          setOpenSupplierRequestHistoryMailDialog(false);
          setSupplierRequestHistoryMail(null);
          setDownloadingSupplierResponseAttachmentKey(null);
        }}
        mail={supplierRequestHistoryMail}
        onDownloadAttachment={handleDownloadSupplierResponseAttachment}
        downloadingAttachmentKey={downloadingSupplierResponseAttachmentKey}
      />

      <Dialog
        open={openSupplierBudgetSelectionDialog}
        onClose={() => !savingSupplierBudgetSelection && setOpenSupplierBudgetSelectionDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Selección de proveedores por material</DialogTitle>
        <DialogContent>
          <div className="mb-4">
            <div
              className="font-weight-bolder text-uppercase"
              style={{ color: DETAIL_SECTION_BLUE, fontSize: "0.8rem" }}
            >
              Grupo
            </div>
            <div className="font-weight-bolder text-dark">
              {supplierBudgetSelection.groupCode || "-"}
            </div>
          </div>

          {(supplierBudgetSelection.materiales || []).length ? (
            <>
            <div style={{ border: "1px solid #E4E6EF", borderRadius: "0.42rem", overflowX: "auto" }}>
              <table className="table table-hover mb-0" style={{ minWidth: "850px" }}>
                <thead style={{ backgroundColor: "#F4F7FB" }}>
                  <tr>
                    <th style={{ minWidth: "310px" }}>Material</th>
                    <th style={{ minWidth: "100px" }}>Unidades</th>
                    {(supplierBudgetSelection.materiales[0]?.precios || []).map((price) => (
                      <th key={price.proveedor_id} style={{ minWidth: "175px" }}>
                        {price.proveedor_nombre || "Proveedor"}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(supplierBudgetSelection.materiales || []).map((material) => (
                    <tr key={material.solicitud_presupuesto_lineas_id}>
                      <td>
                        <div className="font-weight-bolder text-dark">{material.descripcion}</div>
                        <div className="text-muted">{material.referencia || "-"}</div>
                      </td>
                      <td>{parsePercent(material.cantidad)} {material.unidad || ""}</td>
                      {(material.precios || []).map((price) => {
                        const selected = material.selectedSupplierRequestId === price.solicitud_presupuesto_cabecera_id;
                        const availability = getSupplierAvailabilityDisplay(price, material.cantidad);
                        return (
                          <td key={price.proveedor_id}>
                            {price.disponible ? (
                              <div>
                                <button
                                  type="button"
                                  className={`btn btn-sm ${selected ? "btn-success" : "btn-light"}`}
                                  style={{ minWidth: "145px" }}
                                  disabled={savingSupplierBudgetSelection}
                                  onClick={() => {
                                    setSupplierBudgetSelection((current) => ({
                                      ...current,
                                      materiales: (current.materiales || []).map((currentMaterial) =>
                                        currentMaterial.solicitud_presupuesto_lineas_id === material.solicitud_presupuesto_lineas_id
                                          ? { ...currentMaterial, selectedSupplierRequestId: price.solicitud_presupuesto_cabecera_id }
                                          : currentMaterial
                                      ),
                                    }));
                                  }}
                                  >
                                  <CheckIcon fontSize="small" className="mr-1" />
                                  {parseMoney(price.precio_total)} €
                                </button>
                                <div className="small text-muted mt-1">
                                  Precio unitario: {parseMoney(price.precio_unitario)} €
                                </div>
                                <div className="font-weight-bolder mt-1" style={{ color: availability.color, fontSize: "0.72rem" }}>
                                  {availability.text}
                                </div>
                              </div>
                            ) : (
                              <span className="text-muted">Sin precio</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
                <tfoot style={{ backgroundColor: "#F4F7FB" }}>
                  <tr>
                    <th colSpan={2}>Total por proveedor</th>
                    {budgetComparison.suppliers.map((supplier) => (
                      <th key={supplier.id}>
                        <div>{parseMoney(supplier.total)} €</div>
                        {supplier.pricedMaterials < budgetComparison.materialCount && (
                          <div className="small text-warning">
                            Parcial: {supplier.pricedMaterials}/{budgetComparison.materialCount} materiales
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                </tfoot>
              </table>
            </div>
            <div className="row mt-4">
              {[
                { label: "Más barato por material", summary: budgetComparison.cheapest },
                { label: "Más caro por material", summary: budgetComparison.mostExpensive },
                { label: "Selección actual", summary: budgetComparison.selected },
              ].map(({ label, summary }) => (
                <div className="col-md-4 mb-3" key={label}>
                  <div className="border rounded p-3 h-100" style={{ backgroundColor: "#F9FAFC" }}>
                    <div className="small text-muted">{label}</div>
                    <div className="font-weight-bolder text-dark">{parseMoney(summary.total)} €</div>
                    {summary.pricedMaterials < budgetComparison.materialCount && (
                      <div className="small text-warning">
                        Parcial: {summary.pricedMaterials}/{budgetComparison.materialCount} materiales
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            </>
          ) : (
            <div className="text-muted">No hay presupuestos disponibles para este grupo.</div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenSupplierBudgetSelectionDialog(false);
              setSupplierBudgetSelection(getEmptySupplierBudgetSelection());
            }}
            color="default"
            disabled={savingSupplierBudgetSelection}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={savingSupplierBudgetSelection}
            onClick={handleGeneratePurchaseOrders}
          >
            Generar pedidos
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSupplierSelectionDialog}
        onClose={() => setOpenSupplierSelectionDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Selección de proveedores</DialogTitle>
        <DialogContent>
          <Autocomplete
            multiple
            options={suppliers}
            value={selectedSupplierItems}
            onChange={(event, selected) => setSelectedSupplierItems(selected)}
            getOptionLabel={(option) => option?.nombre || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                label="Proveedores"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSupplierSelectionDialog(false)} color="default">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openExtraMaterialDialog}
        onClose={() => setOpenExtraMaterialDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Solicitar material extra</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={selectedExtraProduct && !availableExtraProducts.some((product) => product.id === selectedExtraProduct.id)
              ? [selectedExtraProduct, ...availableExtraProducts]
              : availableExtraProducts}
            value={selectedExtraProduct}
            onChange={(event, selected) => setSelectedExtraProduct(selected)}
            getOptionLabel={(option) =>
              `${option?.referencia || ""} ${option?.descripcion || ""}`.trim()
            }
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                label="Material"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            type="number"
            label="Cantidad"
            value={extraMaterialQuantity}
            onChange={(event) => setExtraMaterialQuantity(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            margin="normal"
            variant="outlined"
            label="Indicaciones / motivo (opcional)"
            value={extraMaterialIndications}
            onChange={(event) => setExtraMaterialIndications(event.target.value)}
            inputProps={{ maxLength: 1000 }}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenExtraMaterialDialog(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleAddExtraMaterial} color="primary" variant="contained">
            Añadir
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(purchaseOrderQuantityDraft)}
        onClose={() => setPurchaseOrderQuantityDraft(null)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Cantidad recibida</DialogTitle>
        <DialogContent>
          <div className="font-weight-bolder text-dark mb-4">{purchaseOrderQuantityDraft?.descripcion}</div>
          <div className="text-muted mb-3">Indica la cantidad entregada. Puedes usar punto o coma para los decimales.</div>
          <div className="d-flex align-items-center justify-content-between" style={{ border: "1px solid #DFE5F1", borderRadius: "10px", padding: "12px" }}>
            <Button aria-label="Restar una unidad" variant="outlined" onClick={() => setPurchaseOrderQuantityDraft((current) => ({ ...current, cantidad: Math.max(0, Number(current?.cantidad || 0) - 1) }))} style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}><RemoveIcon /></Button>
            <input aria-label="Cantidad recibida" inputMode="decimal" value={String(purchaseOrderQuantityDraft?.cantidad ?? 0)} onFocus={(event) => event.target.select()} onChange={(event) => { const value = event.target.value; setPurchaseOrderQuantityDraft((current) => ({ ...current, cantidad: value === "" ? "" : Math.max(0, Number(value.replace(",", ".")) || 0) })); }} className="obra-hours-duration-input font-weight-bolder text-center" style={{ width: "140px", border: 0, background: "transparent", fontSize: "22px", fontWeight: 700, outline: "none" }} />
            <Button aria-label="Sumar una unidad" color="primary" variant="contained" onClick={() => setPurchaseOrderQuantityDraft((current) => ({ ...current, cantidad: Number(current?.cantidad || 0) + 1 }))} style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}><AddIcon /></Button>
          </div>
        </DialogContent>
        <DialogActions><Button onClick={() => setPurchaseOrderQuantityDraft(null)}>Cancelar</Button><Button color="primary" variant="contained" onClick={handleConfirmPurchaseOrderQuantity}>Aceptar</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(purchaseOrderReceipt)} onClose={() => !savingPurchaseOrderReceipt && setPurchaseOrderReceipt(null)} fullWidth maxWidth={false}
        PaperProps={{ style: { width: "430px", maxWidth: "calc(100vw - 24px)", height: "min(760px, calc(100vh - 24px))" } }}
      >
        <DialogTitle>Recepción de pedido</DialogTitle>
        <DialogContent dividers style={{ padding: "16px" }}>
          <div className="mb-3 p-3" style={{ backgroundColor: "#F3F6FF", borderRadius: "8px" }}><div className="font-weight-bolder">{purchaseOrderReceipt?.order?.codigo}</div><div className="text-muted">{obraHeader.codigo_obra}</div></div>
          <Autocomplete options={assignedOperarios} value={assignedOperarios.find((item) => item.operario_id === purchaseOrderReceipt?.operario_id) || null} onChange={(event, value) => setPurchaseOrderReceipt((current) => ({ ...current, operario_id: value?.operario_id || "" }))} getOptionLabel={(item) => item?.nombreCompleto || ""} renderOption={(item) => <span style={{ color: "#17203A", fontSize: "14px" }}>{item?.nombreCompleto || "-"}</span>} renderInput={(params) => <TextField {...params} label="Operario que recibe" variant="outlined" margin="dense" InputProps={{ ...params.InputProps, style: { color: "#17203A" } }} />} />
          <TextField fullWidth margin="dense" variant="outlined" label="Albarán del proveedor" value={purchaseOrderReceipt?.albaran_proveedor || ""} onChange={(event) => { const albaran_proveedor = event.target.value; setPurchaseOrderReceipt((current) => ({ ...current, albaran_proveedor })); }} />
          {(purchaseOrderReceipt?.materiales_no_identificados || []).length > 0 && (
            <div className="mt-3 p-3" style={{ borderRadius: "8px", background: "#FFF4DE", color: "#7A4A00", fontSize: "13px" }}>
              <div className="font-weight-bolder mb-1">Materiales sin identificar en el albarán</div>
              {(purchaseOrderReceipt.materiales_no_identificados || []).map((material, index) => (
                <div key={`${material.descripcion}-${index}`}>• {material.descripcion}{Number(material.cantidad || 0) > 0 ? `: ${material.cantidad}` : ""}</div>
              ))}
            </div>
          )}
          {[...(purchaseOrderReceipt?.lineas || [])]
            .sort((left, right) => {
              const leftCompleted = Number(left.cantidad || 0) - Number(left.cantidad_recibida || 0) <= 0;
              const rightCompleted = Number(right.cantidad || 0) - Number(right.cantidad_recibida || 0) <= 0;
              return Number(leftCompleted) - Number(rightCompleted);
            })
            .map((line) => {
              const completed = Number(line.cantidad || 0) - Number(line.cantidad_recibida || 0) <= 0;
              return <button key={line.id} type="button" className="w-100 text-left border-0 mt-2 p-3" style={{ background: completed ? "#F4F5F8" : "#F9FAFC", borderRadius: "8px", opacity: completed ? 0.52 : 1 }} onClick={() => handleOpenPurchaseOrderQuantityDialog(line)}><div className="font-weight-bolder">{line.descripcion_snapshot}</div><div className="mt-1" style={{ fontSize: "15px" }}><span className="text-muted">Pendiente: </span><span className="font-weight-bolder text-dark">{Math.max(0, Number(line.cantidad || 0) - Number(line.cantidad_recibida || 0))}</span><span className="text-muted mx-2">·</span><span className="text-muted">Esta entrega: </span><span className="font-weight-bolder text-primary">{line.cantidad_actual}</span></div></button>;
            })}
        </DialogContent>
        <DialogActions><Button color="primary" onClick={handleOpenDeliveryNoteDialog} style={{ marginRight: "auto" }}>Albarán</Button><Button onClick={() => setPurchaseOrderReceipt(null)}>Cancelar</Button><Button color="primary" variant="contained" disabled={savingPurchaseOrderReceipt} onClick={handleSavePurchaseOrderReceipt}>Guardar recepción</Button></DialogActions>
      </Dialog>

      <Dialog open={openDeliveryNoteDialog} onClose={() => !analyzingDeliveryNote && setOpenDeliveryNoteDialog(false)} fullWidth maxWidth="xs">
        <DialogTitle>Cargar albarán</DialogTitle>
        <DialogContent>
          <input ref={deliveryNoteFileInputRef} type="file" accept=".pdf,.xlsx,.xls,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" className="d-none" onChange={(event) => handleSelectDeliveryNoteFile(event.target.files?.[0])} />
          <div
            role="button"
            tabIndex={0}
            onClick={() => { if (deliveryNoteFileInputRef.current) deliveryNoteFileInputRef.current.click(); }}
            onKeyDown={(event) => { if ((event.key === "Enter" || event.key === " ") && deliveryNoteFileInputRef.current) deliveryNoteFileInputRef.current.click(); }}
            onDragOver={(event) => { event.preventDefault(); setDeliveryNoteDragActive(true); }}
            onDragLeave={() => setDeliveryNoteDragActive(false)}
            onDrop={(event) => { event.preventDefault(); setDeliveryNoteDragActive(false); handleSelectDeliveryNoteFile(event.dataTransfer.files?.[0]); }}
            className="d-flex flex-column align-items-center justify-content-center text-center p-5"
            style={{ minHeight: "190px", border: `2px dashed ${deliveryNoteDragActive ? "#00B894" : "#C9D5E8"}`, borderRadius: "10px", cursor: "pointer", background: deliveryNoteDragActive ? "#F0FFFA" : "#F9FAFC" }}
          >
            <div className="font-weight-bolder text-dark">Arrastra aquí el albarán</div>
            <div className="text-muted mt-2">PDF o Excel, máximo 15 MB</div>
            <Button className="mt-4" color="primary" variant="outlined" onClick={(event) => { event.stopPropagation(); if (deliveryNoteFileInputRef.current) deliveryNoteFileInputRef.current.click(); }}>Seleccionar archivo</Button>
          </div>
          {deliveryNoteFile && <div className="mt-3 p-3 font-weight-bolder" style={{ background: "#F3F6FF", borderRadius: "8px" }}>{deliveryNoteFile.name}</div>}
          <div className="text-muted mt-4" style={{ fontSize: "13px" }}>La IA comparará el documento con las líneas del pedido y rellenará la recepción para que puedas revisarla antes de guardar.</div>
        </DialogContent>
        <DialogActions><Button onClick={() => setOpenDeliveryNoteDialog(false)} disabled={analyzingDeliveryNote}>Cancelar</Button><Button color="primary" variant="contained" disabled={!deliveryNoteFile || analyzingDeliveryNote} onClick={handleAnalyzeDeliveryNote}>{analyzingDeliveryNote ? "Analizando..." : "Analizar albarán"}</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(taskReportHistoryDialog)}
        onClose={() => setTaskReportHistoryDialog(null)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Partes de tareas: {taskReportHistoryDialog?.title || ""}</DialogTitle>
        <DialogContent dividers>
          {taskReportHistoryRows.length ? taskReportHistoryRows.map((report) => (
            <div key={report.id} className="mb-3" style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden" }}>
              <div className="d-flex flex-wrap justify-content-between align-items-center px-3 py-2" style={{ background: "#F4F7FB", gap: "10px" }}>
                <div>
                  <div className="font-weight-bolder text-dark">{report.responsable || "Sin responsable"}</div>
                  <div className="text-muted" style={{ fontSize: "13px" }}>{formatDate(report.fecha)} · {report.origen === "ADMINISTRACION" ? "Registro administrativo" : "Parte de operario"}</div>
                </div>
                <div className="text-muted" style={{ fontSize: "13px" }}>{report.responsable_tipo || ""}</div>
              </div>
              {(report.lineas || []).map((line) => (
                <div key={line.id} className="d-flex flex-wrap justify-content-between align-items-center px-3 py-3" style={{ borderTop: "1px solid #EEF1F5", gap: "14px" }}>
                  <div>
                    <div className="font-weight-bolder text-dark">{line.producto_descripcion}</div>
                    {line.producto_referencia && <div className="text-muted" style={{ fontSize: "13px" }}>{line.producto_referencia}</div>}
                    {(line.operarios || []).length > 0 && <div className="text-muted mt-1" style={{ fontSize: "13px" }}>{line.operarios.map((operario) => `${operario.nombre} (${formatInstallationTime(operario.segundos_teoricos)})`).join(" · ")}</div>}
                  </div>
                  <div className="text-right" style={{ color: "#187A42" }}>
                    <div className="text-uppercase font-weight-bolder" style={{ color: "#6C757D", fontSize: "0.68rem" }}>Realizado</div>
                    <div className="font-weight-bolder" style={{ fontSize: "1.1rem" }}>{parsePercent(line.cantidad)}</div>
                  </div>
                </div>
              ))}
            </div>
          )) : <div className="text-muted py-4">No hay partes reportados para este elemento.</div>}
        </DialogContent>
        <DialogActions><Button onClick={() => setTaskReportHistoryDialog(null)}>Cerrar</Button></DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(taskReportEditor)}
        onClose={() => !savingTaskReport && setTaskReportEditor(null)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { maxHeight: "calc(100vh - 32px)" } }}
      >
        <DialogTitle disableTypography>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Parte de tareas</h4>
            <Tooltip title="Dictar parte con IA">
              <IconButton
                color="primary"
                onClick={startTaskVoiceRecording}
                disabled={savingTaskReport || sendingTaskVoice}
                style={{ backgroundColor: "#EEF1FF" }}
              >
                <MicIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers style={{ padding: "16px", overflowY: "auto" }}>
          <div className="mb-3 p-3" style={{ backgroundColor: "#F3F6FF", borderRadius: "8px" }}>
            <div className="text-muted text-uppercase font-weight-bolder" style={{ fontSize: "0.68rem" }}>Operario</div>
            <div className="font-weight-bolder text-dark">{taskReportEditor?.operario?.nombreCompleto || "-"}</div>
            <div className="text-muted mt-2">{obraHeader.codigo_obra || "Obra"}</div>
          </div>
          <TextField fullWidth margin="dense" variant="outlined" type="date" label="Fecha del parte" value={taskReportEditor?.fecha || ""} onChange={(event) => setTaskReportEditor((current) => ({ ...current, fecha: event.target.value }))} InputLabelProps={{ shrink: true }} />
          <div className="mt-4 mb-2 font-weight-bolder text-dark">Capítulos, partidas y descompuesto</div>
          <div style={{ border: "1px solid #DFE5F1", borderRadius: "8px", overflow: "hidden" }}>
            {(taskReportEditor?.capitulos || []).map((chapter) => {
              const activePartidas = (chapter.partidas || []).filter((partida) => (partida.productos || []).some((product) => product.puede_reportar));
              const enabled = activePartidas.length > 0;
              const expanded = expandedTaskReportChapters.includes(chapter.capitulo_id);
              return <div key={chapter.capitulo_id} style={{ borderBottom: "1px solid #DFE5F1" }}>
                <button type="button" disabled={!enabled} onClick={() => setExpandedTaskReportChapters((current) => current.includes(chapter.capitulo_id) ? current.filter((item) => item !== chapter.capitulo_id) : [...current, chapter.capitulo_id])} className="w-100 border-0 text-left px-3 py-3 d-flex align-items-center justify-content-between" style={{ background: enabled ? DETAIL_SECTION_BLUE : "#B6C6E5", color: "#FFF", opacity: enabled ? 1 : 0.65, cursor: enabled ? "pointer" : "not-allowed" }}><span className="font-weight-bolder">Capítulo {chapter.ordinal}. {chapter.descripcion}</span>{enabled && (expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)}</button>
                {expanded && (chapter.partidas || []).map((partida) => {
                  const selectable = (partida.productos || []).some((product) => product.puede_reportar);
                  const partidaExpanded = expandedTaskReportPartidas.includes(partida.partida_id);
                  return <div key={partida.partida_id} style={{ background: selectable ? "#FFF" : "#F4F5F8", opacity: selectable ? 1 : 0.55 }}>
                    <button type="button" disabled={!selectable} onClick={() => setExpandedTaskReportPartidas((current) => current.includes(partida.partida_id) ? current.filter((item) => item !== partida.partida_id) : [...current, partida.partida_id])} className="w-100 text-left border-0 px-3 py-3 d-flex justify-content-between align-items-center" style={{ background: "transparent", cursor: selectable ? "pointer" : "not-allowed" }}><span className="font-weight-bolder">{partida.ordinal}. {partida.descripcion}</span>{selectable && (partidaExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)}</button>
                    {partidaExpanded && (partida.productos || []).map((product) => {
                      const selected = (taskReportEditor?.lineas || []).find((line) => line.producto_id === product.producto_id);
                      const enabledProduct = Boolean(product.puede_reportar);
                      const companionNames = getTaskCompanionNames(selected?.companero_ids);
                      return <div key={product.producto_id} className="px-4 py-3" style={{ background: enabledProduct ? "#F9FAFC" : "#F4F5F8", borderTop: "1px solid #E9EDF5", opacity: enabledProduct ? 1 : 0.6 }}>
                        <div className="d-flex align-items-start justify-content-between" style={{ gap: "12px" }}>
                          <div className="font-weight-bolder text-dark">
                            {product.descripcion}
                            {product.es_agrupacion_material && (
                              <span className="ml-2 badge badge-light-primary">
                                Agrupación completa
                              </span>
                            )}
                          </div>
                          {selected && <div style={{ background: "#187A42", color: "#FFF", borderRadius: "6px", padding: "6px 10px", fontSize: "12px", fontWeight: 700, lineHeight: 1.25, textAlign: "right", flexShrink: 0 }}>Preparada: {parsePercent(selected.cantidad)}{companionNames.length ? ` · Con ${companionNames.join(", ")}` : " · En solitario"}</div>}
                        </div>
                        <div className="text-muted mt-1" style={{ fontSize: "13px" }}>Pendiente: {parsePercent(product.cantidad_pendiente)} / {parsePercent(product.unidades_total)}</div>
                        <div className="mt-1" style={{ color: enabledProduct ? "#187A42" : "#A46B00", fontSize: "13px", fontWeight: 700 }}>Material recibido disponible: {parsePercent(product.cantidad_disponible_para_reportar || 0)} / {parsePercent(product.cantidad_recibida || 0)}</div>
                        <div className="d-flex mt-2" style={{ gap: "8px" }}>
                          <Button size="small" variant="outlined" color="primary" disabled={!enabledProduct} onClick={() => handleOpenTaskReportLine(chapter, partida, product, true)}>Todo disponible</Button>
                          <Button size="small" variant="outlined" disabled={!enabledProduct} onClick={() => handleOpenTaskReportLine(chapter, partida, product, false)}>{selected ? "Modificar" : "Parcial"}</Button>
                        </div>
                      </div>;
                    })}
                  </div>;
                })}
              </div>;
            })}
          </div>
          <div className="mt-4 p-3" style={{ border: "1px solid #DFE5F1", borderRadius: "8px", background: "#FFFFFF" }}>
            <div className="font-weight-bolder text-dark">Tareas preparadas para enviar ({(taskReportEditor?.lineas || []).length})</div>
            {(taskReportEditor?.lineas || []).length ? (taskReportEditor.lineas || []).map((line) => {
              const companionNames = getTaskCompanionNames(line.companero_ids);
              return <div key={line.producto_id} className="d-flex justify-content-between align-items-center mt-3 py-2" style={{ borderTop: "1px solid #EEF1F5", gap: "16px" }}><div><div className="font-weight-bolder text-dark">{line.descripcion}</div><div className="text-muted mt-1" style={{ fontSize: "13px" }}>{companionNames.length ? `Con ${companionNames.join(", ")}` : "En solitario"}</div></div><div className="d-flex align-items-center ml-auto" style={{ gap: "18px" }}><span className="font-weight-bolder" style={{ color: "#187A42", fontSize: "1.1rem" }}>{parsePercent(line.cantidad)}</span><Button size="small" color="secondary" onClick={() => setTaskReportEditor((current) => ({ ...current, lineas: current.lineas.filter((item) => item.producto_id !== line.producto_id) }))} style={{ color: "#D92D20" }}>Quitar</Button></div></div>;
            }) : <div className="text-muted mt-2">Aún no has añadido ninguna tarea al parte.</div>}
          </div>
          {taskReportEditor?.ai_resultado && <div className="mt-4 p-3" style={{ border: "1px solid #DCE7FF", borderRadius: "8px", background: "#F7FAFF" }}>
            <div className="font-weight-bolder text-dark">Resultado del agente de partes</div>
            {taskReportEditor.ai_resultado.resumen && <div className="text-muted mt-2">{taskReportEditor.ai_resultado.resumen}</div>}
            {(taskReportEditor.ai_resultado.dudas || []).length > 0 && <div className="mt-3"><div className="font-weight-bolder" style={{ color: "#B7791F" }}>Dudas que necesitamos aclarar</div>{taskReportEditor.ai_resultado.dudas.map((duda, index) => <div key={`duda-${index}`} className="mt-1">{duda}</div>)}</div>}
            {(taskReportEditor.ai_resultado.errores || []).length > 0 && <div className="mt-3"><div className="font-weight-bolder" style={{ color: "#D92D20" }}>Observaciones del agente</div>{taskReportEditor.ai_resultado.errores.map((error, index) => <div key={`error-${index}`} className="mt-1">{error}</div>)}</div>}
          </div>}
        </DialogContent>
        <DialogActions><Button onClick={() => setTaskReportEditor(null)} disabled={savingTaskReport}>Cancelar</Button><Button color="primary" variant="contained" disabled={savingTaskReport || !(taskReportEditor?.lineas || []).length} onClick={handleSaveTaskReport}>{savingTaskReport ? "Enviando..." : "Enviar parte"}</Button></DialogActions>
      </Dialog>

      <Dialog open={Boolean(taskVoiceDialog)} onClose={() => !sendingTaskVoice && closeTaskVoiceDialog()} fullWidth maxWidth="sm">
        <DialogTitle>Dictar parte de tareas</DialogTitle>
        <DialogContent dividers>
          {sendingTaskVoice ? <div className="text-center py-5">
            <CircularProgress color="primary" size={46} />
            <div className="font-weight-bolder text-dark mt-4">Enviando grabación</div>
            <div className="text-muted mt-2">Estamos transcribiendo el audio y preparando las tareas propuestas.</div>
            <div className="task-voice-wave mt-4" aria-label="Grabación en proceso de envío"><span /><span /><span /><span /><span /><span /><span /></div>
          </div> : ["requesting", "listening", "finishing"].includes(taskVoiceDialog?.phase) ? <>
            <div className="text-center py-4">
              <CircularProgress color="primary" />
              <div className="font-weight-bolder text-dark mt-3">{taskVoiceDialog?.phase === "requesting" ? "Preparando la grabación" : taskVoiceDialog?.phase === "finishing" ? "Guardando la grabación" : "Grabando audio"}</div>
              <div className="text-muted mt-2">Explica qué has realizado, cantidades y compañeros que han participado. El audio se transcribirá al enviarlo.</div>
              {taskVoiceDialog?.phase === "listening" && <div className="task-voice-wave mt-4" aria-label="Audio en curso"><span /><span /><span /><span /><span /><span /><span /></div>}
            </div>
          </> : <div className="text-center py-4">
            <MicIcon color="primary" style={{ fontSize: 42 }} />
            <div className="font-weight-bolder text-dark mt-3">{(taskVoiceDialog?.recordings || []).length ? "Grabación lista" : "Sin grabaciones"}</div>
            <div className="text-muted mt-2">{(taskVoiceDialog?.recordings || []).length ? `${taskVoiceDialog.recordings.length} grabación(es) preparada(s). Puedes añadir otra antes de enviar.` : "Crea una grabación para enviar el parte al agente."}</div>
            {taskVoiceDialog?.error && <div className="text-danger mt-3">{taskVoiceDialog.error}</div>}
          </div>}
        </DialogContent>
        <DialogActions>
          {sendingTaskVoice ? null : taskVoiceDialog?.phase === "listening" ? <Button onClick={finishTaskVoiceRecording} color="primary" variant="contained">Finalizar grabación</Button> : ["requesting", "finishing"].includes(taskVoiceDialog?.phase) ? null : <>
            <Button onClick={startTaskVoiceRecording} disabled={sendingTaskVoice}>Nueva grabación</Button>
            <Button onClick={closeTaskVoiceDialog} disabled={sendingTaskVoice}>Cancelar</Button>
            <Button color="primary" variant="contained" disabled={sendingTaskVoice || !(taskVoiceDialog?.recordings || []).length} onClick={handleSendTaskVoiceToAssistant}>{sendingTaskVoice ? "Transcribiendo y analizando..." : "Enviar"}</Button>
          </>}
        </DialogActions>
      </Dialog>

      <Dialog open={Boolean(taskReportLineDraft)} onClose={() => setTaskReportLineDraft(null)} fullWidth maxWidth="xs">
        <DialogTitle>Reportar tarea</DialogTitle>
        <DialogContent>
          <div className="font-weight-bolder text-dark">
            {taskReportLineDraft?.product?.descripcion}
            {taskReportLineDraft?.isMaterialGroup && (
              <span className="ml-2 badge badge-light-primary">
                Agrupación completa
              </span>
            )}
          </div>
          <div className="text-muted mb-3">Material recibido disponible: {parsePercent(taskReportLineDraft?.product?.cantidad_disponible_para_reportar || 0)}</div>
          <TextField fullWidth margin="dense" variant="outlined" type="number" inputProps={{ min: 0, max: Number(taskReportLineDraft?.product?.cantidad_disponible_para_reportar || 0), step: "any" }} label="Cantidad realizada" value={taskReportLineDraft?.cantidad ?? ""} onChange={(event) => { const cantidad = event.target.value; setTaskReportLineDraft((current) => current ? { ...current, cantidad } : current); }} />
          <Autocomplete multiple options={assignedOperarios.filter((item) => !item.bloqueado && item.operario_id !== taskReportEditor?.operario?.operario_id)} value={assignedOperarios.filter((item) => (taskReportLineDraft?.companero_ids || []).includes(item.operario_id))} onChange={(event, values) => setTaskReportLineDraft((current) => current ? { ...current, companero_ids: values.map((item) => item.operario_id) } : current)} getOptionLabel={(item) => item?.nombreCompleto || ""} renderInput={(params) => <TextField {...params} label="Compañeros que han ayudado (opcional)" variant="outlined" margin="normal" />} />
          <div className="text-muted" style={{ fontSize: "13px" }}>{taskReportLineDraft?.companero_ids?.length ? `El tiempo teórico se repartirá entre ${taskReportLineDraft.companero_ids.length + 1} operarios.` : "La tarea se imputará íntegramente al operario seleccionado."}</div>
        </DialogContent>
        <DialogActions><Button onClick={() => setTaskReportLineDraft(null)}>Cancelar</Button><Button color="primary" variant="contained" onClick={handleAddTaskReportLine}>Añadir al parte</Button></DialogActions>
      </Dialog>

      <Dialog
        open={openOperarioHoursDialog}
        onClose={() => !savingOperarioHours && setOpenOperarioHoursDialog(false)}
        fullWidth
        maxWidth={false}
        PaperProps={{
          style: {
            width: "430px",
            maxWidth: "calc(100vw - 24px)",
            height: "min(760px, calc(100vh - 24px))",
          },
        }}
      >
        <DialogTitle>Parte diario</DialogTitle>
        <DialogContent dividers style={{ padding: "16px", overflowY: "auto" }}>
          <div className="mb-4 p-3" style={{ backgroundColor: "#F3F6FF", borderRadius: "8px" }}>
            <div className="text-muted text-uppercase font-weight-bolder" style={{ fontSize: "0.68rem" }}>
              Operario
            </div>
            <div className="font-weight-bolder text-dark">
              {operarioHoursEntry.operario?.nombreCompleto || "-"}
            </div>
            <div className="text-muted mt-3 text-uppercase font-weight-bolder" style={{ fontSize: "0.68rem" }}>
              Obra
            </div>
            <div className="font-weight-bolder text-dark">
              {obraHeader.codigo_obra || "-"}
            </div>
            <div className="text-muted small">{obraHeader.oferta_referencia || obraHeader.localizacion || ""}</div>
          </div>

          <TextField
            fullWidth
            margin="dense"
            variant="outlined"
            type="date"
            label="Fecha"
            value={operarioHoursEntry.fecha}
            onChange={(event) => handleOperarioHoursDateChange(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <div className="mt-4 mb-2 font-weight-bolder text-dark">Tiempo real trabajado</div>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {operarioHoursValues.map((unit) => (
              <div
                key={unit.label}
                className="d-flex align-items-center justify-content-between"
                style={{ border: "1px solid #DFE5F1", borderRadius: "10px", padding: "10px 12px" }}
              >
                <span className="font-weight-bolder text-dark">{unit.label}</span>
                <span className="d-flex align-items-center">
                  <Button
                    aria-label={`Restar ${unit.label.toLowerCase()}`}
                    onClick={() => adjustOperarioHours(-unit.increment)}
                    variant="outlined"
                    style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}
                  >
                    <RemoveIcon />
                  </Button>
                  <input
                    aria-label={unit.label}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={String(unit.value).padStart(2, "0")}
                    onFocus={(event) => event.target.select()}
                    onChange={(event) => setOperarioHoursUnit(unit.unit, event.target.value)}
                    className="obra-hours-duration-input font-weight-bolder text-center"
                    style={{ minWidth: "88px", width: "88px", border: 0, background: "transparent", fontSize: "26px", fontWeight: 700, lineHeight: 1, outline: "none" }}
                  />
                  <Button
                    aria-label={`Sumar ${unit.label.toLowerCase()}`}
                    onClick={() => adjustOperarioHours(unit.increment)}
                    color="primary"
                    variant="contained"
                    style={{ minWidth: "52px", width: "52px", height: "52px", borderRadius: "10px" }}
                  >
                    <AddIcon />
                  </Button>
                </span>
              </div>
            ))}
          </div>

          <TextField
            className="obra-hours-observations"
            fullWidth
            multiline
            rows={3}
            margin="normal"
            variant="outlined"
            label="Observaciones"
            value={operarioHoursEntry.observaciones || ""}
            onChange={(event) => {
              const observaciones = event.target.value;
              setOperarioHoursEntry((current) => ({ ...current, observaciones }));
            }}
            inputProps={{ maxLength: 1000 }}
            helperText="Opcional. Describe incidencias, desplazamientos u otros tiempos no imputables a tareas."
            InputLabelProps={{ shrink: true }}
          />

        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenOperarioHoursDialog(false)}
            color="default"
            disabled={savingOperarioHours}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveOperarioHours}
            color="primary"
            variant="contained"
            disabled={savingOperarioHours}
          >
            {savingOperarioHours ? <CircularProgress size={18} color="inherit" /> : "Guardar parte"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOperarioHoursHistoryDialog}
        onClose={() => !loadingOperarioHoursHistory && setOpenOperarioHoursHistoryDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Horas imputadas a tareas: {operarioHoursHistory.operario?.nombreCompleto || "Operario"}
        </DialogTitle>
        <DialogContent dividers style={{ minHeight: "260px" }}>
          {loadingOperarioHoursHistory ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "220px" }}>
              <CircularProgress />
            </div>
          ) : operarioHoursHistory.rows.length ? (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-hover mb-0" style={{ minWidth: "420px" }}>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th className="text-right">Tiempo imputado</th>
                  </tr>
                </thead>
                <tbody>
                  {operarioHoursHistory.rows.map((row) => (
                    <React.Fragment key={row.fecha}>
                      <tr
                        onClick={() =>
                          setExpandedOperarioTaskHourDates((current) =>
                            current.includes(row.fecha)
                              ? current.filter((fecha) => fecha !== row.fecha)
                              : [...current, row.fecha]
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-nowrap font-weight-bolder">
                          {expandedOperarioTaskHourDates.includes(row.fecha) ? (
                            <ExpandLessIcon fontSize="small" className="mr-2" />
                          ) : (
                            <ExpandMoreIcon fontSize="small" className="mr-2" />
                          )}
                          {formatDate(row.fecha)}
                        </td>
                        <td className="text-right text-nowrap font-weight-bolder">
                          {formatInstallationTime(row.segundos)}
                        </td>
                      </tr>
                      {expandedOperarioTaskHourDates.includes(row.fecha) &&
                        row.tareas.map((tarea, index) => (
                          <tr key={`${row.fecha}-${tarea.descripcion}-${index}`} style={{ backgroundColor: "#F7F9FC" }}>
                            <td className="pl-8 text-muted">{tarea.descripcion}</td>
                            <td className="text-right text-nowrap text-muted">
                              {formatInstallationTime(tarea.segundos)}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="font-weight-bolder">
                    <td>Total</td>
                    <td className="text-right text-nowrap">
                      {formatInstallationTime(
                        operarioHoursHistory.rows.reduce(
                          (total, row) => total + Number(row.segundos || 0),
                          0
                        )
                      )}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center text-muted" style={{ minHeight: "220px" }}>
              Este operario todavía no tiene horas imputadas a tareas en esta obra.
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOperarioHoursHistoryDialog(false)} color="default">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOperarioRealHoursHistoryDialog}
        onClose={() => !loadingOperarioRealHoursHistory && setOpenOperarioRealHoursHistoryDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Horas reales reportadas: {operarioRealHoursHistory.operario?.nombreCompleto || "Operario"}
        </DialogTitle>
        <DialogContent dividers style={{ minHeight: "260px" }}>
          {loadingOperarioRealHoursHistory ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "220px" }}>
              <CircularProgress />
            </div>
          ) : operarioRealHoursHistory.rows.length ? (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-hover mb-0" style={{ minWidth: "420px" }}>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th className="text-right">Horas reportadas</th>
                  </tr>
                </thead>
                <tbody>
                  {operarioRealHoursHistory.rows.map((row) => (
                    <tr key={row.id || row.fecha}>
                      <td className="text-nowrap font-weight-bolder">{formatDate(row.fecha)}</td>
                      <td className="text-right text-nowrap font-weight-bolder">
                        {formatInstallationTime(row.segundos)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="font-weight-bolder">
                    <td>Total</td>
                    <td className="text-right text-nowrap">
                      {formatInstallationTime(
                        operarioRealHoursHistory.rows.reduce(
                          (total, row) => total + Number(row.segundos || 0),
                          0
                        )
                      )}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center text-muted" style={{ minHeight: "220px" }}>
              Este operario todavía no tiene horas reales reportadas en esta obra.
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOperarioRealHoursHistoryDialog(false)} color="default">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOperariosDialog}
        onClose={() => !savingOperarios && setOpenOperariosDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Asignar operarios</DialogTitle>
        <DialogContent>
          <Autocomplete
            multiple
            options={availableOperarios}
            value={selectedOperariosToAssign}
            onChange={(event, selected) => setSelectedOperariosToAssign(selected)}
            getOptionLabel={(option) =>
              `${option?.nombre || ""} ${option?.apellidos || ""}`.trim()
            }
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                label="Operarios disponibles"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          {!availableOperarios.length && (
            <div className="mt-3 text-muted">
              No hay operarios disponibles para asignar a esta obra.
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenOperariosDialog(false)}
            color="default"
            disabled={savingOperarios}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleAssignOperarios}
            color="primary"
            variant="contained"
            disabled={!selectedOperariosToAssign.length || savingOperarios}
          >
            Asignar operarios
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHitosDialog}
        onClose={() => !savingHitos && setOpenHitosDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Hitos</DialogTitle>
        <DialogContent>
          <div className="d-flex justify-content-end mb-4">
            <Button
              color="primary"
              variant="contained"
              onClick={() => handleOpenHitoEditor({ type: "hito", id: null })}
            >
              Añadir hito
            </Button>
          </div>

          <div
            className="px-4 py-4"
            style={{
              border: "1px solid #E4E6EF",
              borderRadius: "0.42rem",
              maxHeight: "360px",
              overflowY: "auto",
            }}
          >
            <div className="d-flex font-weight-bold text-dark mb-3 px-3">
              <div style={{ flex: 1 }}>Descripción</div>
              <div style={{ width: "160px" }}>Fecha</div>
              <div style={{ width: "120px", textAlign: "center" }}>Acciones</div>
            </div>

            {hitoRows.map((row) => (
              <div
                key={row.key}
                className="d-flex align-items-center mb-3 px-3 py-3"
                style={{
                  border: "1px solid #E4E6EF",
                  borderRadius: "0.42rem",
                  gap: "1rem",
                }}
              >
                <div className="font-weight-bold text-dark" style={{ flex: 1 }}>
                  {row.description}
                </div>
                <div style={{ width: "160px" }}>{formatDate(row.date)}</div>
                <div
                  className="d-flex justify-content-center"
                  style={{ width: "120px", gap: "0.5rem" }}
                >
                  <Button
                    size="small"
                    onClick={() =>
                      handleOpenHitoEditor(
                        { type: row.type, id: row.id || null },
                        row.type === "hito"
                          ? {
                              id: row.id,
                              completado_tiempo: row.completado_tiempo,
                              fecha_prevista: row.date,
                            }
                          : null
                      )
                    }
                  >
                    <EditIcon />
                  </Button>
                  {row.type === "hito" && (
                    <Button
                      size="small"
                      onClick={() => handleDeleteDraftHito(row.id)}
                    >
                      <DeleteOutlineIcon />
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenHitosDialog(false)}
            color="default"
            disabled={savingHitos}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveHitos}
            color="primary"
            variant="contained"
            disabled={savingHitos}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHitoEditorDialog}
        onClose={() => setOpenHitoEditorDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {hitoEditorMode.type === "start"
            ? "Editar Fecha Inicio"
            : hitoEditorMode.type === "end"
            ? "Editar Fecha Fin"
            : hitoEditorMode.id
            ? "Editar hito"
            : "Nuevo hito"}
        </DialogTitle>
        <DialogContent>
          {hitoEditorMode.type === "hito" && (
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              type="number"
              label="Porcentaje de avance"
              value={hitoEditorDraft.completado_tiempo}
              onChange={(event) =>
                setHitoEditorDraft({
                  ...hitoEditorDraft,
                  completado_tiempo: event.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
            />
          )}
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            type="date"
            label="Fecha"
            value={hitoEditorDraft.fecha_prevista}
            onChange={(event) =>
              setHitoEditorDraft({
                ...hitoEditorDraft,
                fecha_prevista: event.target.value,
              })
            }
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenHitoEditorDialog(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleSaveHitoEditor} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
